var accountPageInit = require("./client/platform.account.js");
var filesPageInit = require("./client/platform.files.js");
var configPageInit = require("./client/platform.app.config.js");
var homePageInit = require("./client/platform.home.js");
var homeDefaultsPageInit = require("./client/platform.home.defaults.js");
var applicationArtisanReportPageInit = require("./client/platform.application.artisan.report.js");
var commandsPageInit = require("./client/platform.commands.js");
var collectionOrderPageInit = require("./client/collection.order.js");
var emailComposePageInit = require("./client/egt.email.compose.js");
var navigationRoutes = require("./lib/platform.navigation.routes.js");

function fieldsSchemasPageInit() {
  var explainer = document.querySelector("[data-dashboard-settings-explainer='true']");
  if (!explainer) return;

  var primary = explainer.querySelector("[data-dashboard-settings-primary='true']");
  if (!primary) return;

  var enabledMessage = "These settings only matter when Show in Dashboard is on. Pick where operators should find this schema, then choose optional filters and search fields.";
  var disabledMessage = "Show in Dashboard is off. Clear the saved dashboard-only settings or turn visibility back on before saving.";

  function findEnabledControl() {
    return document.querySelector("input[name='dashboard.enabled']");
  }

  function applyExplainerState(enabled) {
    var isEnabled = enabled !== false;
    explainer.className = isEnabled ? "alert alert-info mb-3" : "alert alert-warning mb-3";
    explainer.setAttribute("data-dashboard-settings-enabled", isEnabled ? "true" : "false");
    primary.textContent = isEnabled ? enabledMessage : disabledMessage;
  }

  function syncFromControl() {
    var control = findEnabledControl();
    if (!control) return;
    applyExplainerState(!!control.checked);
  }

  syncFromControl();
  document.addEventListener("change", function(event) {
    var target = event && event.target;
    if (!target || target.name !== "dashboard.enabled") return;
    applyExplainerState(!!target.checked);
  });
  document.addEventListener("ua:schema-editor:mutated", function() {
    syncFromControl();
  });
}

var DASHBOARD_DEBOUNCE = {
  searchInput: 360,
  searchBlur: 180,
  filterApply: 320,
  clearAll: 180,
  dialogSelect: 320
};

// ─── Shared logout + quick action wiring ────────────────────────────────────

function attachSharedDashboardBehavior(context) {
  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null);
  var currentPage = (context.dashboard || {}).currentPage || {};
  var pinButton = document.getElementById("dashboard-pin-main");
  var logout = document.getElementById("dashboard-logout");
  if (logout) {
    logout.addEventListener("click", async function() {
      try {
        await fetch("/auth/logout", { method: "POST", headers: { "Content-Type": "application/json" }, body: "{}" });
      } catch (e) {}
      window.location.href = "/auth/login";
    });
  }

  document.querySelectorAll("button[data-dashboard-action],button[data-target-id]").forEach(function(btn) {
    btn.addEventListener("click", async function(event) {
      var action = (this.getAttribute("data-dashboard-action") || "").trim().toLowerCase();
      var targetId = (this.getAttribute("data-target-id") || "").trim();
      if (targetId) {
        var target = document.getElementById(targetId);
        if (target) target.click();
        return;
      }
      if (action === "add-to-home") {
        event.preventDefault();
        await openDashboardHomeDialog(currentPage, context, dashboardApi, this);
        return;
      }
      if (action === "refresh") window.location.reload();
    });
  });

  if (pinButton && dashboardApi && (currentPage.namespace || "").toString().trim()) {
    syncDashboardHeaderPinButton(pinButton, currentPage, dashboardApi);

    document.addEventListener("ua:collection:action-success", function(event) {
      var detail = (event && event.detail) || {};
      var action = (detail.action || "").toString().trim().toLowerCase();
      if (
        action !== "pin-dashboard" &&
        action !== "remove-dashboard" &&
        action !== "add-widget" &&
        action !== "remove-widget"
      ) return;
      syncDashboardHeaderPinButton(pinButton, currentPage, dashboardApi);
    });
  }

  // Mobile sidebar toggle
  var sidebarToggle = document.getElementById("dashboard-sidebar-toggle");
  var sidebar = document.getElementById("dashboard-sidebar");
  if (sidebarToggle && sidebar) {
    sidebarToggle.addEventListener("click", function() {
      var isOpen = sidebar.classList.toggle("sidebar-open");
      sidebarToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
    // Close sidebar when a nav link is clicked on mobile
    sidebar.querySelectorAll("a.dashboard-link").forEach(function(link) {
      link.addEventListener("click", function() {
        sidebar.classList.remove("sidebar-open");
      });
    });
  }
}

async function openDashboardHomeDialog(currentPage, context, dashboardApi, pinButton) {
  var page = currentPage || {};
  var pageNamespace = (page.namespace || "").toString().trim();
  if (!(pageNamespace)) return;
  if (!(dashboardApi)) return;
  if (!(window.UATools && typeof window.UATools.render === "function")) return;

  var choices = await loadDashboardHomeChoices(pageNamespace, dashboardApi);
  var rows = choices.rows || [];
  var widgetRows = rows.filter(function(row) {
    return (row.kind || "").toString() === "widget";
  });
  var shortcutRow = rows.find(function(row) {
    return (row.kind || "").toString() === "dashboard";
  }) || null;

  if (pinButton && shortcutRow) {
    applyDashboardPinButtonState(pinButton, isDashboardShortcutPinned(shortcutRow), false);
  }

  if (widgetRows.length === 0 && shortcutRow) {
    var wasPinned = isDashboardShortcutPinned(shortcutRow);
    if (pinButton) applyDashboardPinButtonState(pinButton, !wasPinned, true);
    try {
      await toggleDashboardShortcutPin(shortcutRow, dashboardApi);
      if (pinButton) applyDashboardPinButtonState(pinButton, !wasPinned, false);
      syncDashboardHeaderPinButton(pinButton, page, dashboardApi);
    } catch (error) {
      if (pinButton) applyDashboardPinButtonState(pinButton, wasPinned, false);
      console.error("Dashboard shortcut pin toggle failed.", error);
    }
    return;
  }

  var dialogId = "dashboard-home-picker-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  var pageTitle = (page.title || "Dashboard").toString();
  var dialogJson = {
    n: "ua.dialog",
    id: dialogId,
    title: "Widgets",
    allowclose: true,
    fullscreen: false,
    inner: {
      n: "div",
      c: "p-2",
      i: [
        {
          n: "p",
          c: "text-muted mb-3",
          i: "Pin this dashboard shortcut or any of its widgets to Home."
        },
        {
          n: "ua.collection.order",
          name: dialogId + "__collection",
          title: pageTitle,
          description: "",
          searchable: false,
          editable: false,
          "empty-message": "No Home items are available for this dashboard.",
          "page-size-sequence": "12,12,12",
          "api-page-size": 12,
          "page-namespace": "platform.dashboards.all",
          "api-url": "/api/platform.dashboards.all",
          "api-filters": {
            contextPageNamespace: pageNamespace
          }
        }
      ]
    }
  };

  try {
    var rendered = await window.UATools.render(dialogJson);
    var node = null;
    if (typeof rendered === "string") {
      var holder = document.createElement("div");
      holder.innerHTML = rendered;
      node = holder.firstElementChild;
    } else if (rendered && rendered.nodeType) {
      node = rendered;
    }
    if (!node) return;

    document.body.appendChild(node);

    if (typeof window.UATools.after === "function") window.UATools.after();
    await collectionOrderPageInit({
      dashboardApi: dashboardApi,
      dashboard: (context || {}).dashboard || {}
    });
  } catch (error) {
    console.error("Dashboard Home dialog failed:", error);
  }
}

async function loadDashboardHomeChoices(pageNamespace, dashboardApi) {
  try {
    var response = await dashboardApi.list("platform.dashboards.all", {
      contextPageNamespace: pageNamespace
    }, 1, {}, 12);
    var data = response && response.data ? response.data : {};
    return {
      rows: data.rows instanceof Array ? data.rows : []
    };
  } catch (error) {
    console.error("Unable to load dashboard Home choices.", error);
    return {
      rows: []
    };
  }
}

async function toggleDashboardShortcutPin(row, dashboardApi) {
  if (!(row && dashboardApi)) return;
  var actionButtons = row.actionButtons instanceof Array ? row.actionButtons : [];
  var actionButton = actionButtons[0] || null;
  var actionName = ((actionButton || {}).action || "").toString().trim();
  var dashboardNamespace = (row.namespace || "").toString().trim();
  if (!(actionName) || !(dashboardNamespace)) return;

  return await dashboardApi.action("platform.overview", "action", {
    action: actionName,
    dashboardNamespace: dashboardNamespace
  });
}

function isDashboardShortcutPinned(row) {
  var actionButtons = row && row.actionButtons instanceof Array ? row.actionButtons : [];
  var actionButton = actionButtons[0] || {};
  return ((actionButton.action || "").toString().trim().toLowerCase() === "remove-dashboard");
}

function applyDashboardPinButtonState(button, pinned, pending) {
  if (!button) return;
  button.classList.remove("btn-outline-secondary", "btn-success");
  button.classList.add(pinned ? "btn-success" : "btn-outline-secondary");
  button.disabled = pending === true;
  button.setAttribute("aria-busy", pending === true ? "true" : "false");
  button.setAttribute("title", pinned ? "Pinned to Home" : "Add to Home");
  button.setAttribute("aria-label", pinned ? "Pinned to Home" : "Add to Home");

  var icon = button.querySelector("i");
  if (icon) icon.className = pinned ? "bi bi-pin-angle-fill" : "bi bi-pin-angle";
}

async function syncDashboardHeaderPinButton(button, currentPage, dashboardApi) {
  var pageNamespace = (((currentPage || {}).namespace) || "").toString().trim();
  if (!(button) || !(pageNamespace) || !(dashboardApi)) return;
  if (button.disabled) return;
  try {
    var choices = await loadDashboardHomeChoices(pageNamespace, dashboardApi);
    var shortcutRow = (choices.rows || []).find(function(row) {
      return (row.kind || "").toString() === "dashboard";
    }) || null;
    applyDashboardPinButtonState(button, shortcutRow ? isDashboardShortcutPinned(shortcutRow) : false, false);
  } catch (error) {
    console.error("Unable to sync dashboard header pin button.", error);
  }
}

// ─── Dashboard list view: init all ua.dashboard.list elements on the page ───

/**
 * Find and initialise every ua.dashboard.list element on the current page.
 * Each element carries its page namespace via data-dashboard-page-namespace.
 */
async function initDashboardLists(context, root) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!dashboardApi) return;

  var scope = (root && typeof root.querySelectorAll === "function") ? root : document;
  var listEls = scope.querySelectorAll("[data-ua-dashboard-list]");
  for (var i = 0; i < listEls.length; i++) {
    await initSingleList(listEls[i], dashboardApi);
  }
}

async function initSingleList(el, dashboardApi) {
  var pageNamespace = (el.getAttribute("data-dashboard-page-namespace") || "").trim();
  if (!pageNamespace) return;

  // api-url and page-url are set by content functions via context.page.routes.*
  // They encode the correct source-aware URL (e.g. /api/my/... or /api/p/.../...)
  var apiUrl   = (el.getAttribute("data-dashboard-api-url")  || "").trim() || null;
  var pageUrl  = (el.getAttribute("data-dashboard-page-url") || "").trim() || null;

  // Build a scoped API client if an explicit api-url is present
  var api = apiUrl ? dashboardApi.withBase(apiUrl) : null;

  var viewMode = (el.getAttribute("data-dashboard-view-mode") || "list").trim();
  var pageSize = parseInt(el.getAttribute("data-dashboard-page-size") || "25", 10) || 25;
  var emptyMessage = el.getAttribute("data-dashboard-empty-message") || "No items found.";
  var emptyDescription = el.getAttribute("data-dashboard-empty-description") || "";

  var searchInput = el.querySelector("[data-dashboard-search]");
  var filterControls = el.querySelectorAll("input[type='hidden'][data-dashboard-filter]");
  var filterDialogBtns = el.querySelectorAll("button[data-dashboard-filter-dialog='true']");
  var clearFiltersBtn = el.querySelector("[data-dashboard-clear-filters-row='true']");
  var resultsHost = el.querySelector("[data-dashboard-results]");
  var paginationHost = el.querySelector("[data-dashboard-pagination]");
  var countHost = el.querySelector("[data-dashboard-count]");
  var activeFiltersRow = el.querySelector("[data-dashboard-active-filters-row='true']");
  var activeChipsHost = el.querySelector("[data-dashboard-active-filter-chips='true']");
  var quickTogglesHost = el.querySelector("[data-dashboard-quick-toggles='true']");
  var viewToggleEl = el.querySelector("[data-ua-button-toggle='true'][data-toggle-name='dashboard-view-mode']");
  var quickToggleEls = el.querySelectorAll("[data-ua-button-toggle='true'][data-toggle-name^='quick-toggle-']");

  var state = {
    page: 1,
    limit: pageSize,
    viewMode: viewMode,
    filters: {},
    total: 0,
    cache: {},
    pendingFilterDebounce: null,
    pendingLoadDebounce: null
  };

  function invalidateCache() {
    state.cache = {};
  }

  var filterLabelMap = {};
  filterControls.forEach(function(ctrl) {
    var name = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
    if (!name) return;
    var label = (ctrl.getAttribute("data-dashboard-filter-label") || "").trim();
    if (label) filterLabelMap[name] = label;
  });
  filterDialogBtns.forEach(function(btn) {
    var btnName = dialogFilterName(btn);
    if (!btnName) return;
    filterLabelMap[btnName] = (btn.getAttribute("data-dashboard-filter-label") || btn.getAttribute("data-dashboard-filter-button-label") || btnName).toString();
  });

  filterControls.forEach(function(ctrl) {
    var filterName = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
    if (!filterName) return;
    state.filters[filterName] = normalizeFilterValue(ctrl.value || "");
  });

  if (!state.filters.search && searchInput) {
    state.filters.search = normalizeFilterValue(searchInput.value || "");
  }

  if (viewToggleEl) {
    var initialMode = getButtonToggleValue(viewToggleEl);
    if (initialMode) {
      state.viewMode = initialMode;
      el.setAttribute("data-dashboard-view-mode", state.viewMode);
    } else {
      setButtonToggleValue(viewToggleEl, state.viewMode);
    }
  }

  quickToggleEls.forEach(function(toggleEl) {
    var filterName = quickToggleFilterName(toggleEl);
    if (!filterName) return;
    var selected = state.filters[filterName] || "";
    setButtonToggleValue(toggleEl, selected);
  });

  function setFilterValue(filterName, value, loadDelay) {
    if (!filterName) return;
    state.filters[filterName] = normalizeFilterValue(value);
    var control = findDashboardFilterControl(el, filterName);
    if (control) control.value = state.filters[filterName];

    var dialogBtn = el.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
    if (dialogBtn) dialogBtn.setAttribute("data-dashboard-filter-selected", state.filters[filterName]);

    var quickToggle = findQuickToggleElement(el, filterName);
    if (quickToggle) setButtonToggleValue(quickToggle, state.filters[filterName]);

    syncDialogFilterButtonLabels(el, state.filters);
    renderActiveFilterRow();
    state.page = 1;
    scheduleLoad(typeof loadDelay === "number" ? loadDelay : DASHBOARD_DEBOUNCE.filterApply);
  }

  function clearAllFilters() {
    state.filters = {};
    if (searchInput) searchInput.value = "";

    filterControls.forEach(function(ctrl) {
      ctrl.value = "";
      var filterName = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
      if (filterName) state.filters[filterName] = "";
    });

    el.querySelectorAll("button[data-dashboard-filter-dialog='true']").forEach(function(btn) {
      btn.setAttribute("data-dashboard-filter-selected", "");
    });

    quickToggleEls.forEach(function(toggleEl) {
      setButtonToggleValue(toggleEl, "");
    });

    syncDialogFilterButtonLabels(el, state.filters);
    renderActiveFilterRow();
    state.page = 1;
    scheduleLoad(DASHBOARD_DEBOUNCE.clearAll);
  }

  function scheduleLoad(delay) {
    if (state.pendingLoadDebounce) clearTimeout(state.pendingLoadDebounce);
    state.pendingLoadDebounce = setTimeout(function() {
      state.pendingLoadDebounce = null;
      loadList();
    }, Math.max(0, Number(delay) || 0));
  }

  function filterLabelForValue(filterName, value) {
    var control = findDashboardFilterControl(el, filterName);
    var selectedValue = (value || "").toString();
    if (control && control.tagName && control.tagName.toLowerCase() === "select") {
      var selectedOption = control.querySelector("option[value='" + cssEscapeAttr(selectedValue) + "']");
      if (selectedOption) return (selectedOption.textContent || selectedValue).toString();
    }

    var dialogBtn = el.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
    if (dialogBtn) {
      var options = parseFilterOptionsFromButton(dialogBtn);
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === selectedValue) return options[i].label || selectedValue;
      }
    }

    var quickToggle = findQuickToggleElement(el, filterName);
    if (quickToggle) {
      var toggleOptions = parseButtonToggleOptions(quickToggle);
      for (var t = 0; t < toggleOptions.length; t++) {
        if (toggleOptions[t].name === selectedValue) return toggleOptions[t].title || selectedValue;
      }
    }

    return selectedValue;
  }

  function renderActiveFilterRow() {
    if (!activeFiltersRow || !activeChipsHost) return;

    var chips = [];
    var keys = Object.keys(state.filters || {});
    for (var i = 0; i < keys.length; i++) {
      var filterName = keys[i];
      var rawValue = normalizeFilterValue(state.filters[filterName]);
      if (!rawValue) continue;

      var isMulti = false;
      var dialogBtn = el.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
      if (dialogBtn) {
        isMulti = (dialogBtn.getAttribute("data-dashboard-filter-multi") || "").toString().toLowerCase() === "true";
      }

      var values = isMulti ? parseFilterValueList(rawValue) : [rawValue];
      for (var v = 0; v < values.length; v++) {
        var value = values[v];
        if (!value) continue;
        var filterLabel = filterLabelMap[filterName] || (filterName === "search" ? "Search" : filterName);
        var display = filterLabel + ": " + filterLabelForValue(filterName, value);
        chips.push({
          filterName: filterName,
          value: value,
          label: display
        });
      }
    }

    var quickToggleCount = quickTogglesHost
      ? quickTogglesHost.querySelectorAll("[data-ua-button-toggle='true'][data-toggle-name^='quick-toggle-']").length
      : 0;

    if (chips.length === 0 && quickToggleCount === 0) {
      activeFiltersRow.classList.add("d-none");
      activeChipsHost.innerHTML = "";
      if (clearFiltersBtn) clearFiltersBtn.classList.add("d-none");
      return;
    }

    activeFiltersRow.classList.remove("d-none");

    var html = "";
    for (var c = 0; c < chips.length; c++) {
      html += "<button type='button' class='btn btn-outline-secondary btn-sm' data-dashboard-chip-remove='true' data-filter-name='" + escapeHtml(chips[c].filterName) + "' data-filter-value='" + escapeHtml(chips[c].value) + "'>" + escapeHtml(chips[c].label) + "</button>";
    }
    activeChipsHost.innerHTML = html;

    if (clearFiltersBtn) {
      clearFiltersBtn.classList.toggle("d-none", chips.length < 3);
    }
  }

  if (viewToggleEl) {
    bindButtonToggle(viewToggleEl, {
      onChange: function(nextValue) {
        state.viewMode = normalizeFilterValue(nextValue || "list") || "list";
        el.setAttribute("data-dashboard-view-mode", state.viewMode);
        state.page = 1;
        scheduleLoad(0);
      },
      onSettings: function() {
        openButtonToggleDialog(viewToggleEl, function(nextValue) {
          state.viewMode = normalizeFilterValue(nextValue || "list") || "list";
          el.setAttribute("data-dashboard-view-mode", state.viewMode);
          state.page = 1;
          scheduleLoad(0);
        });
      }
    });
  }

  quickToggleEls.forEach(function(toggleEl) {
    var filterName = quickToggleFilterName(toggleEl);
    if (!filterName) return;
    bindButtonToggle(toggleEl, {
      onChange: function(nextValue) {
        setFilterValue(filterName, nextValue, DASHBOARD_DEBOUNCE.filterApply);
      },
      onSettings: function() {
        openButtonToggleDialog(toggleEl, function(nextValue) {
          setFilterValue(filterName, nextValue, DASHBOARD_DEBOUNCE.filterApply);
        });
      }
    });
  });

  // Search (debounced)
  if (searchInput) {
    searchInput.addEventListener("input", function() {
      setFilterValue("search", this.value || "", DASHBOARD_DEBOUNCE.searchInput);
    });
    searchInput.addEventListener("keydown", function(event) {
      if ((event.key || "").toLowerCase() !== "enter") return;
      event.preventDefault();
      setFilterValue("search", this.value || "", 0);
    });
    searchInput.addEventListener("blur", function() {
      setFilterValue("search", this.value || "", DASHBOARD_DEBOUNCE.searchBlur);
    });
  }

  // Filter controls
  filterControls.forEach(function(sel) {
    sel.addEventListener("change", function() {
      var filterName = (this.getAttribute("data-dashboard-filter") || "").trim();
      setFilterValue(filterName, this.value || "", DASHBOARD_DEBOUNCE.filterApply);
    });
  });

  // Dialog-backed filter buttons
  filterDialogBtns.forEach(function(btn) {
    btn.addEventListener("click", function(event) {
      event.preventDefault();
      event.stopPropagation();
      openDashboardFilterDialog(btn, el, state, function(filterName, selectedValue) {
        setFilterValue(filterName, selectedValue || "", DASHBOARD_DEBOUNCE.filterApply);
      });
    });
  });

  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", function(event) {
      event.preventDefault();
      clearAllFilters();
    });
  }

  function cacheKey() {
    var filtersKey = stableStringifyFilters(state.filters || {});
    return [state.page, state.limit, state.viewMode, filtersKey].join("|");
  }

  async function applyListPayload(data) {
    data = data || {};
    applyDynamicFilterOptions(el, data.filterOptions || {});
    var rows = data.rows instanceof Array ? data.rows : [];
    state.total = typeof data.total === "number" ? data.total : rows.length;
    state.page  = typeof data.page  === "number" ? data.page  : state.page;

    if (countHost) {
      var start = ((state.page - 1) * state.limit) + 1;
      var end   = Math.min(state.page * state.limit, state.total);
      if (state.total > 0) {
        countHost.textContent = "Showing " + start + "–" + end + " of " + state.total;
        countHost.style.display = "";
      } else {
        countHost.textContent = "";
        countHost.style.display = "none";
      }
    }

    if (rows.length === 0) {
      if (resultsHost) {
        resultsHost.innerHTML = "<div class='py-4 text-center'>" +
          "<p class='text-muted mb-1'>" + escapeHtml(emptyMessage) + "</p>" +
          (emptyDescription ? ("<p class='text-muted small mb-0'>" + escapeHtml(emptyDescription) + "</p>") : "") +
          "</div>";
      }
    } else {
      await renderRows(resultsHost, rows, pageNamespace, state.viewMode, pageUrl, apiUrl);
    }

    renderPagination(paginationHost, state, function() {
      scheduleLoad(0);
    });
  }

  async function loadList() {
    renderSkeleton(resultsHost);
    if (countHost) {
      countHost.textContent = "";
      countHost.style.display = "none";
    }

    try {
      var key = cacheKey();
      var now = Date.now();
      var hit = state.cache[key];
      if (hit && (now - hit.timestamp) < 10000) {
        await applyListPayload(hit.data || {});
        renderActiveFilterRow();
        return;
      }

      var response = api
        ? await api.list(state.filters, state.page, {}, state.limit)
        : await dashboardApi.list(pageNamespace, state.filters, state.page, {}, state.limit);

      if (!response || !response.success) {
        renderError(resultsHost, "Unable to load data.");
        return;
      }

      var data = response.data || {};
      state.cache[key] = {
        timestamp: now,
        data: data
      };
      await applyListPayload(data);
      renderActiveFilterRow();
    } catch (err) {
      console.error("Dashboard list load error:", err);
      renderError(resultsHost, "An error occurred while loading.");
    }
  }

  // Initial load
  syncDialogFilterButtonLabels(el, state.filters);
  renderActiveFilterRow();
  await loadList();

  // Wire row-level actions (event delegation on the host element)
  el.addEventListener("click", function(e) {
    if (e.defaultPrevented) return;
    var dialogBtn = e.target.closest("button[data-dashboard-filter-dialog='true']");
    if (dialogBtn && el.contains(dialogBtn)) {
      e.preventDefault();
      openDashboardFilterDialog(dialogBtn, el, state, function(filterName, selectedValue) {
        setFilterValue(filterName, selectedValue || "", DASHBOARD_DEBOUNCE.filterApply);
      });
      return;
    }

    var chipRemove = e.target.closest("[data-dashboard-chip-remove='true']");
    if (chipRemove && el.contains(chipRemove)) {
      e.preventDefault();
      var chipFilterName = (chipRemove.getAttribute("data-filter-name") || "").trim();
      var chipValue = (chipRemove.getAttribute("data-filter-value") || "").trim();
      if (!chipFilterName) return;

      var dialogBtnForChip = el.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(chipFilterName) + "']");
      var isMultiChip = dialogBtnForChip && (dialogBtnForChip.getAttribute("data-dashboard-filter-multi") || "").toString().toLowerCase() === "true";

      if (isMultiChip) {
        var currentValues = parseFilterValueList(state.filters[chipFilterName] || "");
        var nextValues = currentValues.filter(function(value) {
          return value !== chipValue;
        });
        setFilterValue(chipFilterName, nextValues.join(","), DASHBOARD_DEBOUNCE.filterApply);
      } else {
        setFilterValue(chipFilterName, "", DASHBOARD_DEBOUNCE.filterApply);
      }
      return;
    }

    var rowTarget = e.target.closest("[data-dashboard-row-href]");
    if (rowTarget && el.contains(rowTarget)) {
      if (rowTarget.getAttribute("data-file-folder-nav") === "true") return;
      if (e.target.closest("a,button,input,select,textarea,label")) return;
      var rowHref = (rowTarget.getAttribute("data-dashboard-row-href") || "").trim();
      if (!rowHref) return;
      window.location.href = rowHref;
      return;
    }

    var customActionButton = e.target.closest("[data-dashboard-custom-action='true']");
    if (customActionButton && el.contains(customActionButton)) {
      e.preventDefault();
      var actionName = (customActionButton.getAttribute("data-action-name") || "").trim();
      var payloadRaw = (customActionButton.getAttribute("data-action-payload") || "{}").trim();
      var payload = {};
      try {
        payload = JSON.parse(payloadRaw);
      } catch (error) {
        payload = {};
      }

      var runCustomAction = function() {
        (async function() {
          try {
            await doCustomAction(pageNamespace, actionName, payload, async function() {
              invalidateCache();
              await loadList();
            }, dashboardApi, apiUrl);
          } catch (customActionError) {
            console.error("Dashboard custom action failed:", customActionError);
          }
        })();
      };

      // OPT-IN: a row action that declares `confirm` (see rowActionConfirmAttrs)
      // must be approved before ANY request is dispatched. Rows without it keep the
      // previous fire-immediately behaviour, byte for byte.
      var actionConfirm = (customActionButton.getAttribute("data-action-confirm") || "").trim();
      if (actionConfirm) {
        confirmDashboardAction({
          title: (customActionButton.getAttribute("data-action-confirm-title") || "Are you sure?").trim(),
          message: actionConfirm,
          confirmLabel: (customActionButton.getAttribute("data-action-confirm-label") || "Continue").trim(),
          confirmClass: (customActionButton.getAttribute("data-action-confirm-class") || "btn btn-danger").trim()
        }, runCustomAction);
        return;
      }

      runCustomAction();
      return;
    }

    var deleteBtn = e.target.closest("[data-dashboard-delete]");
    if (!deleteBtn) return;
    e.preventDefault();
    var deleteId    = (deleteBtn.getAttribute("data-delete-id")    || "").trim();
    var deleteLabel = (deleteBtn.getAttribute("data-delete-label") || deleteId).trim();
    var ns          = (deleteBtn.getAttribute("data-page-namespace") || pageNamespace).trim();
    var btnApiUrl   = (deleteBtn.getAttribute("data-api-url") || apiUrl || "").trim() || null;
    confirmDelete(ns, deleteId, deleteLabel, async function() {
      invalidateCache();
      await loadList();
    }, dashboardApi, btnApiUrl);
  });

  // External reload hook for page-level scripts
  el.addEventListener("ua:dashboard:list:reload", function(event) {
    var detail = (event || {}).detail || {};
    var nextFilters = (detail && typeof detail.filters === "object") ? detail.filters : null;
    if (nextFilters) {
      Object.keys(nextFilters).forEach(function(filterName) {
        var nextValue = normalizeFilterValue(nextFilters[filterName] || "");
        state.filters[filterName] = nextValue;
        var control = findDashboardFilterControl(el, filterName);
        if (control) control.value = nextValue;
        var dialogBtn = el.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
        if (dialogBtn) dialogBtn.setAttribute("data-dashboard-filter-selected", nextValue);
        var quickToggle = findQuickToggleElement(el, filterName);
        if (quickToggle) setButtonToggleValue(quickToggle, nextValue);
      });
      syncDialogFilterButtonLabels(el, state.filters);
      renderActiveFilterRow();
    }

    if (detail.page && Number(detail.page) > 0) {
      state.page = Number(detail.page);
    } else {
      state.page = 1;
    }

    invalidateCache();
    scheduleLoad(0);
  });
}

function normalizeFilterValue(value) {
  if (value === undefined || value === null) return "";
  return (value || "").toString().trim();
}

function stableStringifyFilters(filters) {
  var obj = (filters && typeof filters === "object") ? filters : {};
  var keys = Object.keys(obj).sort();
  var normalized = {};
  for (var i = 0; i < keys.length; i++) {
    normalized[keys[i]] = normalizeFilterValue(obj[keys[i]]);
  }
  try {
    return JSON.stringify(normalized);
  } catch (error) {
    return "{}";
  }
}

function normalizeToggleIcon(icon) {
  var text = (icon || "").toString().trim();
  if (!text) return "";
  if (text.indexOf("bi ") === 0) return text;
  if (text.indexOf("bi-") === 0) return "bi " + text;
  return text;
}

function parseButtonToggleOptions(toggleEl) {
  if (!toggleEl) return [];
  var raw = toggleEl.getAttribute("data-toggle-options") || "[]";
  try {
    var parsed = JSON.parse(raw);
    if (!(parsed instanceof Array)) return [];
    return parsed.map(function(item, index) {
      var row = item || {};
      var hasExplicitName = Object.prototype.hasOwnProperty.call(row, "name") || Object.prototype.hasOwnProperty.call(row, "value") || Object.prototype.hasOwnProperty.call(row, "id");
      var name = hasExplicitName ? (row.name || row.value || row.id || "").toString().trim() : (("option-" + index));
      return {
        name: name,
        title: (row.title || row.label || name).toString(),
        icon: normalizeToggleIcon(row.icon || "")
      };
    });
  } catch (error) {
    console.warn("Unable to parse toggle options.", error);
    return [];
  }
}

function getButtonToggleValue(toggleEl) {
  if (!toggleEl) return "";
  return normalizeFilterValue(toggleEl.getAttribute("data-toggle-value") || "");
}

function renderButtonToggleLabel(toggleEl, option) {
  if (!toggleEl || !option) return;
  var labelHost = toggleEl.querySelector("[data-toggle-label='true']");
  var mainBtn = toggleEl.querySelector("[data-toggle-main='true']");
  if (!labelHost || !mainBtn) return;

  var mode = (toggleEl.getAttribute("data-toggle-mode") || "icon-text").toString().trim().toLowerCase();
  var iconClass = normalizeToggleIcon(option.icon || "");
  var text = option.title || option.name;
  var chooserTitle = (toggleEl.getAttribute("data-toggle-placeholder-title") || toggleEl.getAttribute("aria-label") || toggleEl.getAttribute("title") || "Toggle").toString().trim() || "Toggle";
  var chooserAriaLabelBase = (toggleEl.getAttribute("data-toggle-main-aria-label-base") || chooserTitle).toString().trim() || chooserTitle;
  var chooserLabel = chooserTitle + ": " + text;
  var chooserAriaLabel = chooserAriaLabelBase + ": " + text;
  var html = "";

  if (mode === "icon") {
    html = iconClass ? ("<i class='" + escapeHtml(iconClass) + "'></i>") : "";
  } else if (mode === "text") {
    html = escapeHtml(text);
  } else if (iconClass) {
    html = "<i class='" + escapeHtml(iconClass) + "'></i><span>" + escapeHtml(text) + "</span>";
  } else {
    html = escapeHtml(text);
  }

  labelHost.innerHTML = html;
  mainBtn.setAttribute("title", chooserLabel);
  mainBtn.setAttribute("aria-label", chooserAriaLabel);
}

function setButtonToggleValue(toggleEl, value) {
  if (!toggleEl) return;
  var desired = normalizeFilterValue(value);
  var options = parseButtonToggleOptions(toggleEl);
  var match = null;
  if (!desired) {
    for (var e = 0; e < options.length; e++) {
      if (options[e].name === "") {
        match = options[e];
        break;
      }
    }
    if (!match) {
      toggleEl.setAttribute("data-toggle-value", "");
      renderButtonToggleLabel(toggleEl, {
        name: "",
        title: (toggleEl.getAttribute("data-toggle-placeholder-title") || toggleEl.getAttribute("aria-label") || "Toggle").toString(),
        icon: (toggleEl.getAttribute("data-toggle-placeholder-icon") || "").toString()
      });
      return;
    }
  }

  for (var i = 0; i < options.length; i++) {
    if (options[i].name === desired) {
      match = options[i];
      break;
    }
  }
  if (!match && options.length > 0) {
    match = options[0];
  }
  if (!match) return;

  toggleEl.setAttribute("data-toggle-value", match.name);
  renderButtonToggleLabel(toggleEl, match);
}

function bindButtonToggle(toggleEl, handlers) {
  if (!toggleEl) return;
  if (toggleEl.getAttribute("data-toggle-bound") === "true") return;
  toggleEl.setAttribute("data-toggle-bound", "true");

  var onChange = handlers && typeof handlers.onChange === "function" ? handlers.onChange : null;
  var onSettings = handlers && typeof handlers.onSettings === "function" ? handlers.onSettings : null;

  toggleEl.addEventListener("click", function(event) {
    var settingsBtn = event.target.closest("[data-toggle-settings='true']");
    if (settingsBtn && toggleEl.contains(settingsBtn)) {
      event.preventDefault();
      if (onSettings) onSettings();
      return;
    }

    var mainBtn = event.target.closest("[data-toggle-main='true']");
    if (!mainBtn || !toggleEl.contains(mainBtn)) return;
    event.preventDefault();

    var options = parseButtonToggleOptions(toggleEl);
    if (options.length === 0) return;
    var currentValue = getButtonToggleValue(toggleEl);
    var currentIndex = -1;
    for (var i = 0; i < options.length; i++) {
      if (options[i].name === currentValue) {
        currentIndex = i;
        break;
      }
    }
    var nextIndex = currentIndex >= 0 ? ((currentIndex + 1) % options.length) : 0;
    var nextValue = options[nextIndex] ? options[nextIndex].name : "";
    setButtonToggleValue(toggleEl, nextValue);
    if (onChange) onChange(nextValue);
  });
}

async function openButtonToggleDialog(toggleEl, onSelect) {
  if (!(toggleEl) || typeof onSelect !== "function") return;
  var options = parseButtonToggleOptions(toggleEl);
  if (options.length === 0) return;
  var currentValue = getButtonToggleValue(toggleEl);
  var title = (toggleEl.getAttribute("data-toggle-placeholder-title") || toggleEl.getAttribute("aria-label") || toggleEl.getAttribute("data-toggle-name") || "Select option").toString();

  if (!(window.UATools && typeof window.UATools.render === "function" && typeof window.UATools.save === "function" && typeof window.UATools.load === "function")) {
    var promptText = title + ": choose one of " + options.map(function(option) { return option.title || option.name || "All"; }).join(", ");
    var fallbackValue = window.prompt(promptText, currentValue || options[0].name);
    if (fallbackValue === null) return;
    onSelect((fallbackValue || "").toString().trim());
    return;
  }

  var dialogId = "toggle-settings-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  var controlName = dialogId + "__value";
  var dialogJson = {
    n: "ua.dialog",
    id: dialogId,
    title: title,
    allowclose: true,
    fullscreen: false,
    inner: {
      n: "div",
      c: "p-2",
      i: {
        n: "ua.select.multiple",
        name: controlName,
        title: "",
        searchable: true,
        preview: "text",
        options: options.map(function(option) {
          return {
            value: option.name,
            label: option.title,
            icon: option.icon
          };
        }),
        value: currentValue ? [currentValue] : []
      }
    }
  };

  try {
    var rendered = await window.UATools.render(dialogJson);
    var node = null;
    if (typeof rendered === "string") {
      var holder = document.createElement("div");
      holder.innerHTML = rendered;
      node = holder.firstElementChild;
    } else if (rendered && rendered.nodeType) {
      node = rendered;
    }
    if (!node) return;
    document.body.appendChild(node);

    if (typeof window.UATools.after === "function") window.UATools.after();

    var dialogHostName = dialogId;
    try {
      if (node.tagName === "UAE") node.setAttribute("name", dialogHostName);
    } catch (error) {}
    var dialogHostSelector = "uae[name='" + cssEscapeAttr(dialogHostName) + "']";

    var controlUae = node.querySelector(".modal-body uae[name]");
    var resolvedControlName = controlUae ? (controlUae.getAttribute("name") || "").toString().trim() : "";
    if (!resolvedControlName) return;

    var payload = {};
    payload[resolvedControlName] = currentValue ? [currentValue] : [];
    await window.UATools.load(payload, dialogHostSelector);

    var saveDebounce = null;
    node.addEventListener("change", function() {
      if (saveDebounce) clearTimeout(saveDebounce);
      saveDebounce = setTimeout(function() {
        (async function() {
          try {
            var saveResult = await window.UATools.save(dialogHostSelector, true);
            if (!saveResult || saveResult.success === false) return;
            var controlResult = saveResult[resolvedControlName];
            if (!controlResult || controlResult.success === false) return;
            var selected = parseFilterValueList(controlResult.data || []);
            var nextValue = selected.length ? (selected[0] || "").toString() : "";
            onSelect(nextValue);
            var dismissBtn = node.querySelector("[data-ua-dismiss='modal'],[data-bs-dismiss='modal']");
            if (dismissBtn && typeof dismissBtn.click === "function") dismissBtn.click();
          } catch (saveError) {
            console.error("Toggle settings dialog save failed:", saveError);
          }
        })();
      }, 120);
    });
  } catch (error) {
    console.error("Toggle settings dialog failed:", error);
  }
}

function quickToggleFilterName(toggleEl) {
  if (!toggleEl) return "";
  var toggleName = (toggleEl.getAttribute("data-toggle-name") || "").toString().trim();
  if (toggleName.indexOf("quick-toggle-") !== 0) return "";
  return toggleName.substring("quick-toggle-".length).trim();
}

function findQuickToggleElement(listEl, filterName) {
  if (!listEl || !filterName) return null;
  return listEl.querySelector("[data-ua-button-toggle='true'][data-toggle-name='quick-toggle-" + cssEscapeAttr(filterName) + "']");
}

function cssEscapeAttr(value) {
  var text = (value || "").toString();
  if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(text);
  return text.replace(/["\\]/g, "\\$&");
}

function parseFilterOptionsFromButton(btn) {
  if (!btn) return [];
  var raw = btn.getAttribute("data-dashboard-filter-options") || "[]";
  try {
    var parsed = JSON.parse(raw);
    if (!(parsed instanceof Array)) return [];
    return parsed.map(function(item) {
      return {
        value: ((item || {}).value || "").toString(),
        label: ((item || {}).label || (item || {}).value || "").toString(),
        description: ((item || {}).description || "").toString(),
        icon: ((item || {}).icon || "").toString(),
        thumbnail: ((item || {}).thumbnail || (item || {}).image || "").toString(),
        meta: ((item || {}).meta || "").toString(),
        badge: ((item || {}).badge || "").toString()
      };
    });
  } catch (error) {
    console.warn("Unable to parse dashboard filter options.", error);
    return [];
  }
}

function parseFilterValueList(value) {
  if (value instanceof Array) {
    return value.map(function(item) {
      return (item || "").toString().trim();
    }).filter(Boolean);
  }

  var text = (value || "").toString().trim();
  if (!text) return [];
  return text.split(",").map(function(item) {
    return (item || "").toString().trim();
  }).filter(Boolean);
}

function applyDynamicFilterOptions(listEl, filterOptions) {
  if (!(listEl) || !(filterOptions && typeof filterOptions === "object")) return;
  var map = {
    category: "categories",
    subcategory: "subcategories",
    source: "sources",
    plugins: "plugins",
    provider: "plugins"
  };

  Object.keys(map).forEach(function(filterName) {
    var optionKey = map[filterName];
    var options = filterOptions[optionKey];
    if (!(options instanceof Array)) return;
    var hasOptions = options.length > 0;

    var button = listEl.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
    if (button) {
      button.classList.toggle("d-none", !hasOptions);
      try {
        button.setAttribute("data-dashboard-filter-options", JSON.stringify(options));
      } catch (error) {}
    }

    var quickToggle = findQuickToggleElement(listEl, filterName);
    if (quickToggle) {
      quickToggle.classList.toggle("d-none", !hasOptions);
      var emptyLabel = (quickToggle.getAttribute("data-dashboard-filter-empty-label") || "All").toString();
      var nextToggleOptions = [{
        name: "",
        title: emptyLabel,
        icon: normalizeToggleIcon(quickToggle.getAttribute("data-toggle-placeholder-icon") || "bi bi-funnel")
      }].concat(options.map(function(row) {
        return {
          name: ((row || {}).value || "").toString(),
          title: ((row || {}).label || (row || {}).value || "").toString(),
          icon: normalizeToggleIcon((row || {}).icon || "bi bi-toggle2-on")
        };
      }));

      try {
        quickToggle.setAttribute("data-toggle-options", JSON.stringify(nextToggleOptions));
      } catch (error) {}

      var currentValue = getButtonToggleValue(quickToggle);
      var exists = nextToggleOptions.some(function(row) { return row.name === currentValue; });
      if (!exists && nextToggleOptions.length > 0) {
        setButtonToggleValue(quickToggle, nextToggleOptions[0].name);
      } else {
        setButtonToggleValue(quickToggle, currentValue);
      }
    }
  });
}

function dialogFilterName(btn) {
  if (!btn) return "";
  return (btn.getAttribute("data-dashboard-filter-name") || btn.getAttribute("data-dashboard-filter") || "").trim();
}

function findDashboardFilterControl(listEl, filterName) {
  if (!(listEl)) return null;
  var escaped = cssEscapeAttr((filterName || "").toString());
  return listEl.querySelector("input[type='hidden'][data-dashboard-filter='" + escaped + "']");
}

function syncDialogFilterButtonLabels(el, filters) {
  var stateFilters = filters || {};
  el.querySelectorAll("button[data-dashboard-filter-dialog='true']").forEach(function(btn) {
    var filterName = dialogFilterName(btn);
    var baseLabel = (btn.getAttribute("data-dashboard-filter-button-label") || btn.getAttribute("data-dashboard-filter-label") || "Filter").trim();
    var icon = (btn.getAttribute("data-dashboard-filter-icon") || "").trim();
    var iconOnly = (btn.getAttribute("data-dashboard-filter-icon-only") || "false").toString().trim().toLowerCase() === "true";
    var selectedValue = (stateFilters[filterName] || btn.getAttribute("data-dashboard-filter-selected") || "").toString();
    var selectedValues = parseFilterValueList(selectedValue);
    var options = parseFilterOptionsFromButton(btn);

    var labelMap = {};
    for (var i = 0; i < options.length; i++) {
      labelMap[options[i].value] = options[i].label;
    }

    var label = baseLabel;
    if (selectedValues.length === 1) {
      var singleLabel = labelMap[selectedValues[0]] || selectedValues[0];
      label = baseLabel + ": " + singleLabel;
    } else if (selectedValues.length > 1) {
      label = baseLabel + ": " + selectedValues.length + " selected";
    }
    btn.setAttribute("title", label);
    btn.setAttribute("aria-label", label);
    if (iconOnly) {
      btn.innerHTML = icon ? ("<i class='" + escapeHtml(icon.indexOf("bi-") === 0 ? ("bi " + icon) : icon) + "'></i>") : "";
    } else {
      btn.innerHTML = (icon ? ("<i class='" + escapeHtml(icon.indexOf("bi-") === 0 ? ("bi " + icon) : icon) + "'></i> ") : "") + escapeHtml(label);
    }
  });
}

async function openDashboardFilterDialog(btn, listEl, state, onApplyFilter) {
  var filterName = dialogFilterName(btn);
  if (!filterName) return;

  var filterLabel = (btn.getAttribute("data-dashboard-filter-label") || "Filter").trim();
  var filterButtonLabel = (btn.getAttribute("data-dashboard-filter-button-label") || filterLabel).toString().trim();
  var filterDescription = (btn.getAttribute("data-dashboard-filter-description") || "").toString().trim();
  if (filterDescription.toLowerCase() === filterLabel.toLowerCase() || filterDescription.toLowerCase() === filterButtonLabel.toLowerCase()) {
    filterDescription = "";
  }
  var options = parseFilterOptionsFromButton(btn);
  var control = findDashboardFilterControl(listEl, filterName);
  var filterPreview = (btn.getAttribute("data-dashboard-filter-preview") || "text").toString().trim().toLowerCase();
  var filterMulti = (btn.getAttribute("data-dashboard-filter-multi") || "false").toString().trim().toLowerCase() === "true";
  var currentValue = ((state || {}).filters || {})[filterName];
  if (currentValue === undefined || currentValue === null || currentValue === "") {
    if (control) currentValue = control.value || "";
    else currentValue = btn.getAttribute("data-dashboard-filter-selected") || "";
  }
  currentValue = (currentValue || "").toString();

  function applySelectedValue(selectedValue) {
    var nextValue = (selectedValue || "").toString();
    if (control) control.value = nextValue;
    btn.setAttribute("data-dashboard-filter-selected", nextValue);
    if (state && state.filters) state.filters[filterName] = nextValue;

    if (typeof onApplyFilter === "function") {
      onApplyFilter(filterName, nextValue);
      return;
    }

    if (control) {
      control.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  if (!(window.UATools && typeof window.UATools.render === "function" && typeof window.UATools.save === "function" && typeof window.UATools.load === "function")) {
    var fallbackValue = window.prompt("Filter " + filterLabel + " (leave blank for all):", currentValue);
    if (fallbackValue === null) return;
    applySelectedValue(fallbackValue);
    return;
  }

  var dialogId = "dash-filter-dialog-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  var controlName = dialogId + "__values";
  var initialValues = parseFilterValueList(currentValue);
  if (!filterMulti && initialValues.length > 1) {
    initialValues = initialValues.length > 0 ? [initialValues[0]] : [];
  }
  var controlJson = {
    n: "ua.select.multiple",
    name: controlName,
    title: "",
    searchable: true,
    preview: filterPreview,
    options: options || [],
    value: initialValues
  };
  var dialogJson = {
    n: "ua.dialog",
    id: dialogId,
    title: filterLabel,
    allowclose: true,
    fullscreen: false,
    inner: {
      n: "div",
      c: "p-2",
      i: [
        filterDescription ? {
          n: "p",
          c: "text-muted mb-2",
          i: filterDescription
        } : "",
        controlJson
      ]
    },
    footer: {
      n: "div",
      c: "d-flex justify-content-end",
      i: {
        n: "button",
        id: dialogId + "__done",
        type: "button",
        c: "btn btn-outline-secondary btn-sm",
        i: "Done"
      }
    }
  };

  try {
    var rendered = await window.UATools.render(dialogJson);
    var node = null;
    if (typeof rendered === "string") {
      var holder = document.createElement("div");
      holder.innerHTML = rendered;
      node = holder.firstElementChild;
    } else if (rendered && rendered.nodeType) {
      node = rendered;
    }
    if (!node) return;

    document.body.appendChild(node);
    if (typeof window.UATools.after === "function") {
      window.UATools.after();
    }

    var dialogHostName = dialogId;
    try {
      if (node.nodeType === 1 && node.tagName === "UAE") {
        node.setAttribute("name", dialogHostName);
      }
    } catch (error) {}
    var dialogHostSelector = "uae[name='" + cssEscapeAttr(dialogHostName) + "']";

    var controlUae = node.querySelector(".modal-body uae[name]");
    var resolvedControlName = controlUae ? (controlUae.getAttribute("name") || "").toString().trim() : "";
    if (!resolvedControlName) {
      console.error("Dashboard filter dialog could not resolve control uae name.", {
        dialogId: dialogId,
        controlName: controlName
      });
      return;
    }

    var loadObj = {};
    loadObj[resolvedControlName] = initialValues;
    await window.UATools.load(loadObj, dialogHostSelector);

    function closeDialog() {
      var dismissBtn = node.querySelector("[data-ua-dismiss='modal'],[data-bs-dismiss='modal']");
      if (dismissBtn && typeof dismissBtn.click === "function") {
        dismissBtn.click();
      }
    }

    async function saveAndApplyFilter() {
      var saveResult = await window.UATools.save(dialogHostSelector, true);
      if (!saveResult || saveResult.success === false) return false;

      var controlResult = saveResult[resolvedControlName];
      if (!controlResult || controlResult.success === false) return false;

      var selected = parseFilterValueList(controlResult.data || []);
      if (!filterMulti && selected.length > 1) {
        selected = selected.length > 0 ? [selected[0]] : [];
      }
      applySelectedValue(selected.join(","));
      return true;
    }

    var applyDebounce = null;
    node.addEventListener("change", function() {
      if (applyDebounce) clearTimeout(applyDebounce);
      applyDebounce = setTimeout(async function() {
        try {
          await saveAndApplyFilter();
        } catch (saveError) {
          console.error("Dashboard filter apply failed:", saveError);
        }
      }, DASHBOARD_DEBOUNCE.dialogSelect);
    });

    var doneBtn = node.querySelector("#" + dialogId + "__done");
    if (doneBtn) {
      doneBtn.addEventListener("click", function(event) {
        event.preventDefault();
        closeDialog();
      });
    }
  } catch (error) {
    console.error("Dashboard filter dialog open failed:", error);
    var fallbackValue = window.prompt("Filter " + filterLabel + " (comma separated, blank for all):", currentValue);
    if (fallbackValue === null) return;
    applySelectedValue(fallbackValue);
  }
}

// ─── Render helpers ──────────────────────────────────────────────────────────

function renderSkeleton(host) {
  if (!host) return;
  var rows = "";
  for (var i = 0; i < 4; i++) {
    rows += "<div class='ua-dashboard-skeleton-row'></div>";
  }
  host.innerHTML = "<div class='ua-dashboard-list-skeleton'>" + rows + "</div>";
}

function renderError(host, message) {
  if (!host) return;
  host.innerHTML = "<div class='alert alert-danger mb-0'>" + escapeHtml(message) + "</div>";
}

async function platformPagesWorkspaceInit(context) {
  var root = document.querySelector("[data-platform-pages-workspace='true']");
  if (!root) return;
  if (typeof root.__platformPagesCleanup === "function") {
    try {
      root.__platformPagesCleanup();
    } catch (cleanupError) {
      console.warn("Previous page workspace cleanup failed.", cleanupError);
    }
  }

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI;
  if (!dashboardApi) return;

  var apiUrl = (root.getAttribute("data-api-url") || "").trim();
  var pagePath = (root.getAttribute("data-page-path") || "").trim();
  var api = apiUrl ? dashboardApi.withBase(apiUrl) : dashboardApi.withBase("/api/platform.pages");

  root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'>Loading page workspace...</div></div>";

  function esc(value) {
    return escapeHtml((value || "").toString());
  }

  function setStatus(message, tone) {
    var el = root.querySelector("[data-pages-workspace-status='true']");
    if (!el) return;
    el.className = "small mb-0 " + (tone || "text-muted");
    el.textContent = message || "";
  }

  function describeWorkspaceError(error, fallbackMessage, fallbackTitle) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var title = (error && (error.title || data.title)) || fallbackTitle || "Page Workspace Error";
    var message = (error && (error.description || data.description || error.message || data.message)) || fallbackMessage || "An error occurred while working with this page.";
    var namespace = (error && (error.namespace || data.namespace)) || "";
    var reasons = (data.reasons instanceof Array) ? data.reasons : ((error && error.reasons instanceof Array) ? error.reasons : []);
    var recovery = data.recovery || (error && error.recovery) || null;
    return {
      title: (title || "").toString(),
      message: (message || "").toString(),
      namespace: (namespace || "").toString(),
      reasons: reasons,
      recovery: recovery
    };
  }

  function getPublishConfirmationDetails(error, expectedNamespace) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var namespace = ((error && (error.namespace || "")) || data.namespace || "").toString();
    if (namespace !== expectedNamespace) return null;
    return {
      title: ((error && error.title) || data.title || "Publish confirmation required").toString(),
      message: ((error && error.description) || data.description || "Live changed after this draft started. Confirm if you want to replace the newer live version with this draft.").toString(),
      collaboration: data.collaboration || error.collaboration || {}
    };
  }

  function buildPublishOverridePrompt(details, label) {
    var collaboration = details && details.collaboration ? details.collaboration : {};
    var lines = [
      (details && details.title) || (label + " publish confirmation required"),
      "",
      (details && details.message) || ("Live " + label.toLowerCase() + " changed after this draft started."),
      "",
      "Draft modified: " + (collaboration.draftModified || "—"),
      "Live modified: " + (collaboration.liveModified || "—"),
      "Draft baseline live version: " + (collaboration.sourceLiveVersion || "—"),
      "Current live version: " + (collaboration.liveVersion || "—")
    ];
    if (collaboration.summary) {
      lines.push("", collaboration.summary);
    }
    lines.push("", "Publish anyway and intentionally replace the newer live " + label.toLowerCase() + " with this draft?");
    return lines.join("\n");
  }

  function renderWorkspaceFailure(error, fallbackMessage, fallbackTitle) {
    var details = describeWorkspaceError(error, fallbackMessage, fallbackTitle);
    var namespaceHtml = details.namespace
      ? ("<div class='small text-uppercase text-muted mb-2'>" + esc(details.namespace) + "</div>")
      : "";
    var recovery = details.recovery || {};
    root.innerHTML = "" +
      "<div class='card border-0 shadow-sm'><div class='card-body p-4'>" +
        "<div class='alert alert-warning mb-3'>" +
          namespaceHtml +
          "<h1 class='h5 mb-2'>" + esc(details.title) + "</h1>" +
          "<p class='mb-0'>" + esc(details.message) + "</p>" +
          (details.reasons.length ? ("<ul class='small mb-0 mt-3'>" + details.reasons.map(function(reason) { return "<li>" + esc(reason) + "</li>"; }).join("") + "</ul>") : "") +
        "</div>" +
        "<div class='d-flex flex-wrap gap-2'>" +
          ((recovery.action === "revert") ? ("<button type='button' class='btn btn-outline-danger' data-pages-action='recover-revert' data-base-draft-version='" + esc(String(Number(recovery.baseDraftVersion || 0) || 0)) + "'>" + esc(recovery.label || "Revert Draft to Live") + "</button>") : "") +
          "<a class='btn btn-outline-secondary' href='/dashboard/platform.pages'>Back to Pages</a>" +
        "</div>" +
      "</div></div>";
  }

  function useDocumentEndSummary(settings) {
    settings = settings || {};
    if ((settings.useDocumentEndMode || "default") === "disabled") return "Document end disabled";
    if ((settings.useDocumentEndMode || "default") === "custom-part") {
      return settings.useDocumentEndPart ? ("Custom document-end part: " + settings.useDocumentEndPart) : "Custom document-end part";
    }
    return "Default document end";
  }

  function getAllowedPageTypeDataFields(pageType, schemaType) {
    var type = (pageType || "").toString().trim().toLowerCase();
    var schema = (schemaType || "").toString().trim().toLowerCase();
    var allowed = [];
    if (["pages.podcast", "pages.podcastepisode", "pages.song", "pages.album"].indexOf(type) >= 0 || ["podcastseries", "podcastepisode", "musicrecording", "musicalbum"].indexOf(schema) >= 0) allowed.push("audio");
    if (type === "pages.video" || schema === "videoobject") allowed.push("video");
    if (type === "pages.recipe" || schema === "recipe") allowed.push("recipe");
    return allowed;
  }

  function humanizePageTypeDataField(key) {
    if (key === "audio") return "audio details";
    if (key === "video") return "video details";
    if (key === "recipe") return "recipe details";
    return (key || "").toString();
  }

  function getPageTypeGuidance() {
    return {
      pageTypes: [
        { value: "pages.web", label: "General page", note: "Default layout with no extra page-specific fields." },
        { value: "pages.video", label: "Video page", note: "Reveals video details such as source, poster, and title." },
        { value: "pages.recipe", label: "Recipe page", note: "Reveals recipe details like times, ingredients, and steps." },
        { value: "pages.podcast", label: "Podcast series page", note: "Supports audio source details." },
        { value: "pages.podcastepisode", label: "Podcast episode page", note: "Supports audio source details." },
        { value: "pages.song", label: "Song page", note: "Supports audio source details." },
        { value: "pages.album", label: "Album page", note: "Supports audio source details." }
      ],
      schemaTypes: [
        { value: "VideoObject", label: "VideoObject", note: "Reveals video details." },
        { value: "Recipe", label: "Recipe", note: "Reveals recipe details." },
        { value: "PodcastSeries", label: "PodcastSeries", note: "Reveals audio details." },
        { value: "PodcastEpisode", label: "PodcastEpisode", note: "Reveals audio details." },
        { value: "MusicRecording", label: "MusicRecording", note: "Reveals audio details." },
        { value: "MusicAlbum", label: "MusicAlbum", note: "Reveals audio details." }
      ]
    };
  }

  function renderPageTypeGuidance(editorData) {
    var guidance = getPageTypeGuidance();
    var pageType = ((editorData || {}).pageType || "pages.web").toString();
    var schemaType = (((editorData || {}).schemaType) || "").toString();
    function renderList(items, selectedValue, kindLabel) {
      return "<div class='col-12 col-lg-6'><div class='border rounded p-3 h-100 bg-body-tertiary'><div class='small text-uppercase text-muted mb-2'>" + kindLabel + " suggestions</div><ul class='small mb-0 ps-3'>" + items.map(function(item) {
        var selected = item.value === selectedValue;
        return "<li class='mb-2'><code>" + esc(item.value) + "</code>" + (selected ? " <span class='badge text-bg-primary ms-1'>Current</span>" : "") + "<div class='text-muted'>" + esc(item.label + ": " + item.note) + "</div></li>";
      }).join("") + "</ul></div></div>";
    }
    return "<details class='border rounded p-3 mb-3 bg-body-tertiary'><summary class='fw-semibold'>Page setup help</summary><p class='small text-muted mt-3 mb-0'>Use these examples only when you need help choosing <strong>Page Type</strong> and optional <strong>Schema Type</strong>. Those values control which page-specific fields appear in the editor.</p><div class='row g-3 mt-1'>" + renderList(guidance.pageTypes, pageType, "Page type") + renderList(guidance.schemaTypes, schemaType, "Schema type") + "</div></details>";
  }

  function getFocusablePageEditorControls() {
    if (!(activeEditorHost) || typeof activeEditorHost.querySelectorAll !== "function") return [];
    return Array.prototype.slice.call(activeEditorHost.querySelectorAll('input, select, textarea, button, [tabindex]:not([tabindex="-1"])')).filter(function(node) {
      if (!(node) || typeof node.focus !== "function") return false;
      if (node.disabled) return false;
      if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') return false;
      return true;
    });
  }

  function captureSchemaFocusPreference(event) {
    var detail = (event && event.detail) || {};
    var target = event && event.target;
    var names = [detail.name, detail.field, detail.fieldName, detail.path];
    if (target && typeof target.getAttribute === "function") {
      names.push(target.getAttribute('name') || target.name || '');
      names.push(target.getAttribute('data-field-name') || target.getAttribute('field') || '');
      names.push(target.id || '');
    }
    var preferred = 'pageType';
    if (names.filter(Boolean).some(function(name) { return /schemaType/i.test((name || '').toString()); })) preferred = 'schemaType';
    pendingFocusRestore = { preferred: preferred };
  }

  function restoreSchemaEditorFocus() {
    if (!(pendingFocusRestore)) return;
    var controls = getFocusablePageEditorControls();
    if (!(controls.length)) {
      pendingFocusRestore = null;
      return;
    }
    var preferred = ((pendingFocusRestore || {}).preferred || 'pageType').toString();
    pendingFocusRestore = null;
    var matcher = preferred.toLowerCase();
    var target = controls.find(function(control) {
      var names = [control.name || '', control.id || '', (control.getAttribute && control.getAttribute('data-field-name')) || ''];
      return names.some(function(name) { return name && name.toString().toLowerCase().indexOf(matcher) >= 0; });
    }) || controls[0];
    window.requestAnimationFrame(function() {
      try { target.focus({ preventScroll: false }); } catch (error) { try { target.focus(); } catch (focusError) {} }
    });
  }

  function buildReactivePageWorkspaceConfig(editorData) {
    var doc = editorData || {};
    var allowedFields = getAllowedPageTypeDataFields(doc.pageType, doc.schemaType);
    var schemaSource = activeWorkspace.canonicalSchema || activeWorkspace.schema || {};
    var groupsSource = activeWorkspace.canonicalGroups || activeWorkspace.groups || [];
    var schema = JSON.parse(JSON.stringify(schemaSource));
    var groups = JSON.parse(JSON.stringify(groupsSource));

    if (schema.pageTypeData && schema.pageTypeData.fields) {
      if (allowedFields.length) {
        var nextFields = {};
        allowedFields.forEach(function(key) {
          if (schema.pageTypeData.fields[key]) nextFields[key] = schema.pageTypeData.fields[key];
        });
        schema.pageTypeData.fields = nextFields;
      } else {
        delete schema.pageTypeData;
      }
    }

    groups = groups.map(function(group) {
      var next = JSON.parse(JSON.stringify(group || {}));
      if ((next.fields || []).indexOf("pageTypeData") >= 0 && !(allowedFields.length)) {
        next.fields = next.fields.filter(function(field) { return field !== "pageTypeData"; });
        next.description = "Primary media, short highlight chips, and optional platform links.";
      } else if ((next.fields || []).indexOf("pageTypeData") >= 0 && allowedFields.length) {
        next.description = "Primary media, short highlight chips, " + allowedFields.map(humanizePageTypeDataField).join(", ") + ", and optional platform links.";
      }
      return next;
    }).filter(function(group) {
      return group.fields && group.fields.length > 0;
    });

    return { schema: schema, groups: groups, allowedFields: allowedFields };
  }

  function renderWorkspace(workspace) {
    var live = workspace.live || {};
    var draft = workspace.draft || {};
    var editor = workspace.editor || {};
    var proof = workspace.proof || {};
    var constraints = workspace.constraints || {};
    var access = editor.access || {};
    var settings = editor.settings || {};
    var title = (draft.title || live.title || editor.title || "").toString().trim();
    var headingTitle = title || pagePath;
    var headingMeta = title ? ("File: " + pagePath) : "Page file";
    root.innerHTML = "" +
      "<div class='container-fluid px-0'><div class='row g-4'>" +
        "<div class='col-12 col-xl-5'>" +
          "<div class='card border-0 shadow-sm h-100'><div class='card-body p-4'>" +
            "<div class='d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3'>" +
              "<div><p class='text-uppercase text-muted small mb-1'>Single Draft Workspace</p><h1 class='h4 mb-1' data-pages-heading-title='true'>" + esc(headingTitle) + "</h1><p class='small text-muted mb-1' data-pages-heading-meta='true'>" + esc(headingMeta) + "</p><p class='text-muted mb-0'>One draft, one live page. You can edit the supported page fields here while any unsupported page JSON stays preserved and protected.</p></div>" +
            "</div>" +
            "<details class='border rounded p-3 mb-4 bg-body-tertiary'><summary class='fw-semibold'>Workspace details</summary><div class='small text-muted mt-3'><div><strong>Editor route:</strong> <code data-pages-proof-route='true'>" + esc(proof.route || ("/dashboard/platform.pages/" + pagePath)) + "</code></div><div><strong>Live source:</strong> <code data-pages-live-path='true'>" + esc(proof.livePath || ("@!/app/pages/" + pagePath)) + "</code></div><div><strong>Draft source:</strong> <code data-pages-draft-path='true'>" + esc(proof.draftPath || ("@!/app/drafts/pages/" + pagePath)) + "</code></div><div><strong>Editable scope:</strong> <span data-pages-scope-summary='true'>" + esc(constraints.summary || "Supported page fields only.") + "</span></div></div></details>" +
            "<div class='row g-3 mb-4'><div class='col-12 col-md-6'><div class='border rounded p-3 h-100'><div class='small text-uppercase text-muted mb-1'>Live</div><div class='fw-semibold' data-pages-live-title='true'>" + esc(live.title || pagePath) + "</div><div class='small text-muted mt-2'>Published: <span data-pages-live-published='true'>" + esc(live.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-pages-live-modified='true'>" + esc(live.modified || "—") + "</span></div></div></div>" +
            "<div class='col-12 col-md-6'><div class='border rounded p-3 h-100 bg-warning-subtle'><div class='small text-uppercase text-muted mb-1'>Draft</div><div class='fw-semibold' data-pages-draft-title='true'>" + esc(draft.title || pagePath) + "</div><div class='small text-muted mt-2'>Published: <span data-pages-draft-published='true'>" + esc(draft.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-pages-draft-modified='true'>" + esc(draft.modified || "—") + "</span></div></div></div></div>" +
            "<div class='small text-muted border rounded p-3 mb-3 bg-body-tertiary'><div><strong>Page type:</strong> <span data-pages-editor-type='true'>" + esc(editor.pageType || "pages.web") + "</span></div><div><strong>Schema type:</strong> <span data-pages-editor-schema-type='true'>" + esc(editor.schemaType || "—") + "</span></div><div><strong>Status:</strong> <span data-pages-editor-status='true'>" + esc(editor.status || "published") + "</span></div><div><strong>Access:</strong> <span data-pages-editor-access='true'>" + esc(access.policy || "public") + (access.requiredRole ? (" • role: " + esc(access.requiredRole)) : "") + "</span></div><div><strong>Settings:</strong> <span data-pages-editor-settings='true'>" + esc(useDocumentEndSummary(settings)) + "</span></div><div class='mt-2'><strong>Editor location:</strong> <span data-pages-current-branch='true'>Page basics</span></div></div>" +
            "<details class='border rounded p-3 mb-3 bg-body-tertiary'><summary class='fw-semibold'>Editor help & tools</summary><div class='mt-3'><nav aria-label='Editor location trail'><ol class='list-unstyled d-flex flex-wrap gap-2 align-items-center mb-0' data-pages-breadcrumbs='true'></ol></nav><p class='small text-muted mb-3 mt-2' data-pages-breadcrumb-summary='true'>Open this only when you need orientation, setup help, or reusable-part tools.</p><div class='border rounded p-3 mb-3 bg-body'><div class='small text-uppercase text-muted mb-2'>Quick starts</div><div data-pages-template-actions='true'></div></div><div class='border rounded p-3 bg-body'><div class='small text-uppercase text-muted mb-2'>Reusable parts</div><div data-pages-part-actions='true'></div><div data-pages-part-dialog='true' class='mt-3'></div></div></div></details><div class='border rounded p-3 mb-3 bg-body-tertiary d-none' data-pages-schema-change-note='true' role='status' aria-live='polite' aria-atomic='true'></div><div data-pages-type-guidance='true'></div>" +
            "<div data-pages-schema-editor='true' class='mb-3'></div>" +
            "<div class='d-flex flex-wrap gap-2 align-items-center'><button type='button' class='btn btn-outline-primary' data-pages-action='save'>Save Draft</button><button type='button' class='btn btn-success' data-pages-action='publish'>Publish Draft to Live</button><button type='button' class='btn btn-outline-danger' data-pages-action='revert'>Revert Draft to Live</button><a class='btn btn-outline-secondary' href='/dashboard/platform.pages'>Back to Pages</a></div>" +
            "<p class='small text-muted mb-0 mt-3' data-pages-workspace-status='true' role='status' aria-live='polite' aria-atomic='true'>Draft workspace ready.</p>" +
          "</div></div>" +
        "</div>" +
        "<div class='col-12 col-xl-7'><div class='card border-0 shadow-sm h-100'><div class='card-body p-0'><div class='border-bottom px-4 py-3 d-flex justify-content-between align-items-center gap-3 flex-wrap'><div><p class='text-uppercase text-muted small mb-1'>Preview</p><h2 class='h5 mb-0'>Draft preview for <span data-pages-preview-path='true'>" + esc(proof.draftPath || ("@!/app/drafts/pages/" + pagePath)) + "</span></h2><p class='small text-muted mb-0 mt-1'>Editor context: <span data-pages-preview-branch='true'>Page basics</span></p></div><button type='button' class='btn btn-sm btn-outline-secondary' data-pages-action='refresh-preview'>Refresh Preview</button></div><iframe title='Page draft preview' data-pages-preview='true' style='width:100%;min-height:72vh;border:0;'></iframe></div></div></div>" +
      "</div></div>";
  }

  var activeWorkspace = null;
  var activeEditorHost = null;
  var activeEditorSelector = "";
  var saveTimer = null;
  var pendingFocusRestore = null;
  var saveSequence = 0;
  var lastAppliedSaveSequence = 0;
  var draftMutationVersion = 0;
  var draftBaseVersion = 0;
  var makePartDialogState = null;
  var lastReactiveSignature = "";
  var pendingSchemaRefresh = null;
  var preservedPageTypeData = { audio: undefined, video: undefined, recipe: undefined };
  var activeNavigationState = null;
  var workspaceDisposed = false;
  var schemaRefreshGeneration = 0;
  var workspaceInstanceGeneration = 0;

  async function mountSchemaEditor(workspace, editorData) {
    var host = root.querySelector("[data-pages-schema-editor='true']");
    if (!host || !(window.UATools && typeof window.UATools.render === "function")) {
      throw new Error("Schema editor tools are unavailable.");
    }

    var editorState = syncPreservedPageTypeData(editorData || workspace.editor || {});
    var editorConfig = buildReactivePageWorkspaceConfig(editorState);
    host.innerHTML = "";
    activeEditorSelector = "";
    lastReactiveSignature = [editorState.pageType || "pages.web", editorState.schemaType || ""].join("|");
    var editorNode = await window.UATools.render({
      n: "ua.fields.schema.editor",
      name: "platformPagesEditor",
      schema: editorConfig.schema || {},
      groups: editorConfig.groups || [],
      data: editorState,
      continueText: "Continue",
      showSummaryStep: false,
      skipGroupedNestedSteps: true,
      disableDefaultWizardBehavior: true,
      showStepNavigation: true
    });

    if (typeof editorNode === "string") {
      host.innerHTML = editorNode;
      activeEditorHost = host.firstElementChild;
    } else if (editorNode && editorNode.nodeType) {
      host.appendChild(editorNode);
      activeEditorHost = editorNode;
    } else {
      throw new Error("Unable to render schema editor.");
    }

    if (activeEditorHost) {
      if (!(activeEditorHost.id)) activeEditorHost.id = "platform-pages-editor-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
      activeEditorSelector = "#" + activeEditorHost.id;
    }

    if (typeof window.UATools.after === "function") window.UATools.after();
    restoreSchemaEditorFocus();
  }

  async function getEditorData() {
    if (!(activeEditorHost && window.UATools && typeof window.UATools.save === "function")) {
      throw new Error("Schema editor is unavailable.");
    }
    var repo = {};
    var result = await window.UATools.save(activeEditorSelector || activeEditorHost, true);
    if (!result || result.success === false) throw result || new Error("Unable to save schema editor state.");
    var editorSave = result.platformPagesEditor || null;
    if (!editorSave || editorSave.success === false) throw editorSave || new Error("Schema editor did not return page data.");
    return syncPreservedPageTypeData(editorSave.data || {});
  }

  function cancelPendingAutosave() {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = null;
  }

  function setText(selector, value, fallback) {
    var el = root.querySelector(selector);
    if (!el) return;
    el.textContent = (value || value === false) ? value : (fallback || "");
  }

  function getWorkspaceDraftMutation(workspace) {
    return Number(((((workspace || {}).editorState) || {}).draftMutation) || 0) || 0;
  }

  function getWorkspaceDraftBaseVersion(workspace) {
    return Number(((((workspace || {}).editorState) || {}).baseDraftVersion) || ((((workspace || {}).editorState) || {}).draftVersion) || 0) || 0;
  }

  function syncWorkspaceSummary(workspace) {
    var live = (workspace || {}).live || {};
    var draft = (workspace || {}).draft || {};
    var editor = (workspace || {}).editor || {};
    var proof = (workspace || {}).proof || {};
    var constraints = (workspace || {}).constraints || {};
    var access = editor.access || {};
    var settings = editor.settings || {};
    var title = (draft.title || live.title || editor.title || "").toString().trim();

    setText("[data-pages-proof-route='true']", proof.route || ("/dashboard/platform.pages/" + pagePath));
    setText("[data-pages-live-path='true']", proof.livePath || ("@!/app/pages/" + pagePath));
    setText("[data-pages-draft-path='true']", proof.draftPath || ("@!/app/drafts/pages/" + pagePath));
    setText("[data-pages-scope-summary='true']", constraints.summary || "Supported page fields only.");
    setText("[data-pages-live-title='true']", live.title || pagePath);
    setText("[data-pages-live-published='true']", live.published || "—");
    setText("[data-pages-live-modified='true']", live.modified || "—");
    setText("[data-pages-draft-title='true']", draft.title || pagePath);
    setText("[data-pages-draft-published='true']", draft.published || "—");
    setText("[data-pages-draft-modified='true']", draft.modified || "—");
    setText("[data-pages-heading-title='true']", title || pagePath);
    setText("[data-pages-heading-meta='true']", title ? ("File: " + pagePath) : "Page file");
    setText("[data-pages-editor-type='true']", editor.pageType || "pages.web");
    setText("[data-pages-editor-schema-type='true']", editor.schemaType || "—");
    setText("[data-pages-editor-status='true']", editor.status || "published");
    setText("[data-pages-editor-access='true']", (access.policy || "public") + (access.requiredRole ? (" • role: " + access.requiredRole) : ""));
    setText("[data-pages-editor-settings='true']", useDocumentEndSummary(settings));
    setText("[data-pages-preview-path='true']", proof.draftPath || ("@!/app/drafts/pages/" + pagePath));
    var guidanceHost = root.querySelector("[data-pages-type-guidance='true']");
    if (guidanceHost) guidanceHost.innerHTML = renderPageTypeGuidance(editor);
    renderTemplateActions(editor);
    if (!(activeNavigationState)) renderNavigationState(buildPageNavigationState({}));
    else renderNavigationState(activeNavigationState);
  }

  function setSchemaChangeNote(message, tone) {
    var el = root.querySelector("[data-pages-schema-change-note='true']");
    if (!el) return;
    if (!message) {
      el.className = "border rounded p-3 mb-3 bg-body-tertiary d-none";
      el.textContent = "";
      return;
    }
    el.className = "border rounded p-3 mb-3 alert " + (tone || "alert-info");
    el.textContent = message;
  }

  function humanizeEditorKey(value) {
    var text = (value || "").toString().trim();
    if (!text) return "Field";
    return text.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[._-]+/g, " ").replace(/\s+/g, " ").trim().replace(/^./, function(chr) {
      return chr.toUpperCase();
    });
  }

  function buildPageNavigationState(detail) {
    var info = detail && typeof detail === "object" ? detail : {};
    var baseSegments = [{ label: "Page basics", path: [], navigationTargetId: activeEditorHost && activeEditorHost.id ? activeEditorHost.id : "" }];
    var detailSegments = info.segments instanceof Array ? info.segments.map(function(segment) {
      var next = segment && typeof segment === "object" ? segment : {};
      return {
        label: (next.label || humanizeEditorKey(next.key || "Field")).toString(),
        path: next.path instanceof Array ? next.path.slice() : [],
        navigationTargetId: (next.navigationTargetId || "").toString(),
        canNavigate: next.canNavigate !== false,
        stepNumber: Number(next.stepNumber || 0) || 0
      };
    }) : [];
    var segments = baseSegments.concat(detailSegments);
    var current = segments.length ? segments[segments.length - 1].label : "Page basics";
    var summary = segments.map(function(segment) { return segment.label; }).join(" → ");
    return {
      segments: segments,
      current: current,
      summary: summary || "Page basics",
      rootEditorName: (info.rootEditorName || info.editorName || "").toString(),
      rootEditorLabel: (info.rootEditorLabel || info.editorLabel || "").toString()
    };
  }

  function renderNavigationState(state) {
    var nextState = state || { segments: [{ label: "Page basics", path: [] }], current: "Page basics", summary: "Page basics" };
    activeNavigationState = nextState;
    var branchText = nextState.summary || nextState.current || "Page basics";
    setText("[data-pages-current-branch='true']", branchText);
    setText("[data-pages-preview-branch='true']", branchText);
    setText("[data-pages-breadcrumb-summary='true']", "Current editor location: " + branchText);
    var host = root.querySelector("[data-pages-breadcrumbs='true']");
    if (!host) return;
    host.innerHTML = (nextState.segments || []).map(function(segment, index) {
      var isCurrent = index === (nextState.segments.length - 1);
      var canNavigate = segment.canNavigate !== false;
      var label = esc(segment.label || ("Location " + (index + 1)));
      var title = canNavigate
        ? ("Go to " + esc(segment.label || ("Location " + (index + 1))))
        : (esc(segment.label || ("Location " + (index + 1))) + " (current location context)");
      var attrs = isCurrent ? " aria-current='location'" : "";
      if (canNavigate) {
        return "<li class='d-inline-flex align-items-center gap-2'>" +
          (index > 0 ? "<span class='text-muted' aria-hidden='true'>→</span>" : "") +
          "<button type='button' class='btn btn-sm " + (isCurrent ? "btn-primary" : "btn-outline-secondary") + "' data-pages-action='jump-branch' data-branch-index='" + index + "'" + attrs + " title='" + title + "'>" + label + "</button>" +
        "</li>";
      }
      return "<li class='d-inline-flex align-items-center gap-2'>" +
        (index > 0 ? "<span class='text-muted' aria-hidden='true'>→</span>" : "") +
        "<span class='btn btn-sm " + (isCurrent ? "btn-primary" : "btn-outline-secondary disabled") + "'" + attrs + " aria-disabled='true' title='" + title + "'>" + label + "</span>" +
      "</li>";
    }).join("");
  }

  function clonePageTypeData(value) {
    var source = value && typeof value === "object" ? value : {};
    return {
      audio: source.audio,
      video: source.video && typeof source.video === "object" ? JSON.parse(JSON.stringify(source.video)) : source.video,
      recipe: source.recipe && typeof source.recipe === "object" ? JSON.parse(JSON.stringify(source.recipe)) : source.recipe
    };
  }

  function mergePreservedPageTypeData(editorData) {
    var next = editorData && typeof editorData === "object" ? JSON.parse(JSON.stringify(editorData)) : {};
    var currentPageTypeData = next.pageTypeData && typeof next.pageTypeData === "object" ? next.pageTypeData : {};
    next.pageTypeData = Object.assign({}, clonePageTypeData(preservedPageTypeData), currentPageTypeData);
    return next;
  }

  function syncPreservedPageTypeData(editorData) {
    var merged = mergePreservedPageTypeData(editorData || {});
    preservedPageTypeData = clonePageTypeData(merged.pageTypeData || {});
    return merged;
  }

  function isPageTypeSignatureControl(event) {
    var detail = event && event.detail;
    var detailNames = [];
    if (detail && typeof detail === "object") {
      [detail.name, detail.field, detail.fieldName, detail.path].forEach(function(value) {
        if (value !== undefined && value !== null) detailNames.push(value);
      });
    }

    var target = event && event.target;
    var names = detailNames.slice();
    if (target && typeof target.getAttribute === "function") {
      names.push(target.getAttribute("name") || target.name || "");
      names.push(target.getAttribute("data-field-name") || target.getAttribute("field") || "");
      names.push(target.getAttribute("id") || "");
    }

    return names.filter(Boolean).some(function(name) {
      var text = name.toString().trim();
      return /(^|\.|\[)(pageType|schemaType)(\]|$)/.test(text) || /(?:^|[-_])(pageType|schemaType)(?:$|[-_])/.test(text);
    });
  }

  function isCurrentSchemaRefresh(refreshGeneration, instanceGeneration) {
    return !(workspaceDisposed) &&
      refreshGeneration === schemaRefreshGeneration &&
      instanceGeneration === workspaceInstanceGeneration;
  }

  function beginWorkspaceInstance() {
    workspaceInstanceGeneration += 1;
    schemaRefreshGeneration += 1;
    return workspaceInstanceGeneration;
  }

  function isCurrentWorkspaceInstance(generation) {
    return !(workspaceDisposed) && generation === workspaceInstanceGeneration;
  }

  function scheduleSchemaRefresh() {
    if (pendingSchemaRefresh) return pendingSchemaRefresh;
    var refreshGeneration = ++schemaRefreshGeneration;
    var instanceGeneration = workspaceInstanceGeneration;
    pendingSchemaRefresh = Promise.resolve().then(async function() {
      pendingSchemaRefresh = null;
      var editorData = syncPreservedPageTypeData(await getEditorData());
      if (!(isCurrentSchemaRefresh(refreshGeneration, instanceGeneration))) return;
      var nextSignature = [editorData.pageType || "pages.web", editorData.schemaType || ""].join("|");
      if (nextSignature === lastReactiveSignature) return;
      await mountSchemaEditor(activeWorkspace, editorData);
      if (!(isCurrentSchemaRefresh(refreshGeneration, instanceGeneration))) return;
      syncWorkspaceSummary(Object.assign({}, activeWorkspace, { editor: editorData }));
      renderMakePartActions(editorData || {}, makePartDialogState);
      var allowedFields = buildReactivePageWorkspaceConfig(editorData).allowedFields;
      setSchemaChangeNote(
        allowedFields.length
          ? ("Editor fields updated for " + (editorData.pageType || "pages.web") + (editorData.schemaType ? (" / " + editorData.schemaType) : "") + ". Available page-specific fields: " + allowedFields.map(humanizePageTypeDataField).join(", ") + ". Hidden page-specific values remain preserved in the draft unless you explicitly clear them after switching back.")
          : ("Editor fields updated for " + (editorData.pageType || "pages.web") + (editorData.schemaType ? (" / " + editorData.schemaType) : "") + ". Page-specific media/detail fields are hidden until this page type or schema type supports them. Hidden page-specific values remain preserved in the draft unless you explicitly clear them after switching back.")
        ,
        "alert-info"
      );
    }).catch(function(error) {
      pendingSchemaRefresh = null;
      if (!(isCurrentSchemaRefresh(refreshGeneration, instanceGeneration))) return;
      console.error(error);
      setSchemaChangeNote("The editor could not refresh its page-specific fields yet. Your current edits are still in place.", "alert-warning");
    });
    return pendingSchemaRefresh;
  }

  async function focusNavigationBranch(index) {
    if (!(activeNavigationState && activeNavigationState.segments instanceof Array)) return;
    var segment = activeNavigationState.segments[index];
    if (!segment || segment.canNavigate === false) return;

    if (activeEditorHost && window.UATools && typeof window.UATools.load === "function") {
      var editorMeta = activeEditorHost.__uaSchemaEditor || {};
      var stepNumber = Number(segment.stepNumber || 0) || 0;
      if (stepNumber > 0 && editorMeta.wizardDomId) {
        var wizardEl = document.getElementById(editorMeta.wizardDomId);
        var currentStep = wizardEl ? (Number(wizardEl.getAttribute("data-wizard-current") || "1") || 1) : 1;
        if (currentStep !== stepNumber) {
          try {
            await window.UATools.load(null, activeEditorHost, stepNumber);
          } catch (error) {}
        }
      }
    }

    var target = null;
    var navigationTargetId = (segment.navigationTargetId || "").toString().trim();
    if (navigationTargetId) {
      target = document.getElementById(navigationTargetId);
    }

    var path = segment.path instanceof Array ? segment.path : [];
    if (!target && path.length && activeEditorHost) {
      target = activeEditorHost.querySelector("[data-fse-entry-path='" + cssEscapeAttr(path.join(".")) + "']");
    }

    if (!target && (!(path.length) || index === 0) && activeEditorHost) {
      target = activeEditorHost.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
    }

    if (!target) return;

    var focusTarget = target.matches && target.matches('input, select, textarea, button, [tabindex]:not([tabindex="-1"])')
      ? target
      : target.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
    if (!focusTarget) focusTarget = target;

    if (focusTarget && typeof focusTarget.focus === "function") {
      try { focusTarget.focus({ preventScroll: false }); } catch (error) { try { focusTarget.focus(); } catch (focusError) {} }
    }
  }

  function partSlugFromSection(section, index) {
    var source = ((section || {}).kind || "section") === "reusable-part"
      ? (((section || {}).reusablePartPath || "").replace(/\.json$/i, "") || ("section-" + (index + 1)))
      : (((section || {}).heading) || ("section-" + (index + 1)));
    return source.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || ("section-" + (index + 1));
  }

  function buildSectionTemplateBase(data) {
    data = data || {};
    return {
      kind: "section",
      reusablePartPath: "",
      headingTag: data.headingTag || "h2",
      heading: data.heading || "",
      note: data.note || "",
      body: data.body || "",
      extraParagraphs: data.extraParagraphs instanceof Array ? data.extraParagraphs.slice() : [],
      links: data.links instanceof Array ? data.links.map(function(link) {
        return {
          label: (link && link.label) || "",
          href: (link && link.href) || "",
          style: (link && link.style) || "secondary"
        };
      }) : [],
      attributes: data.attributes && typeof data.attributes === "object" ? JSON.parse(JSON.stringify(data.attributes)) : { className: "container py-4" },
      editorKey: "preset-" + Date.now() + "-" + Math.floor(Math.random() * 100000)
    };
  }

  function buildPageStarterPresets(editorData) {
    var doc = editorData || {};
    var title = (doc.title || "This Page").toString().trim() || "This Page";
    return [
      {
        key: "landing",
        label: "Landing page starter",
        description: "Hero follow-up, value explanation, proof/operations section, and a closing CTA.",
        sections: [
          buildSectionTemplateBase({
            heading: "Built to explain " + title + " clearly",
            note: "Use this first section to connect the hero to the real operator or customer problem.",
            body: "Introduce the page in one grounded paragraph that says what the offer does, who it helps, and why this page exists right now.",
            links: [{ label: "Primary call to action", href: "/contact-us.html", style: "primary" }, { label: "Secondary link", href: "/pages.html", style: "secondary" }]
          }),
          buildSectionTemplateBase({
            heading: "Why teams use it",
            body: "Summarize the strongest practical benefit in one paragraph, then use the extra paragraphs below for a second and third proof point instead of turning this into a wall of copy.",
            extraParagraphs: ["Add one concrete outcome, workflow improvement, or operator advantage.", "Add a second proof point such as speed, clarity, maintainability, or launch control."]
          }),
          buildSectionTemplateBase({
            heading: "How the workflow stays maintainable",
            body: "Explain the operational model: what stays reusable, what can be updated safely, and how the page remains easy to keep current as the product changes."
          }),
          buildSectionTemplateBase({
            heading: "Ready for the next step",
            body: "Close with the single most important action you want someone to take after reading the page.",
            links: [{ label: "Talk to the team", href: "/contact-us.html", style: "primary" }]
          })
        ]
      },
      {
        key: "story",
        label: "Story / explainer starter",
        description: "Narrative flow for context, problem, approach, and next step.",
        sections: [
          buildSectionTemplateBase({
            heading: "The context behind " + title,
            body: "Start with the situation, market change, team need, or user frustration that makes this page worth publishing.",
            extraParagraphs: ["Add one short paragraph that gives the reader enough context without forcing them to guess why they should care."]
          }),
          buildSectionTemplateBase({
            heading: "What was getting in the way",
            body: "Describe the friction, constraints, or product gap in straightforward language."
          }),
          buildSectionTemplateBase({
            heading: "What changed",
            body: "Explain the new approach, workflow, or product capability and why it improves the situation in practical terms."
          }),
          buildSectionTemplateBase({
            heading: "Where to go next",
            body: "Point the reader to the next action, related page, or contact path.",
            links: [{ label: "Continue", href: "/pages.html", style: "secondary" }]
          })
        ]
      },
      {
        key: "announcement",
        label: "Announcement starter",
        description: "Simple launch/update structure for what changed, who it affects, and how to act.",
        sections: [
          buildSectionTemplateBase({
            heading: "What launched",
            note: "Use the note for release timing, availability, or rollout context.",
            body: "State the release or update in one paragraph with clear scope and no hype inflation."
          }),
          buildSectionTemplateBase({
            heading: "Why it matters",
            body: "Summarize the benefit or impact for the intended audience.",
            extraParagraphs: ["Add one paragraph for operational consequences, migration notes, or an important limitation if needed."]
          }),
          buildSectionTemplateBase({
            heading: "How to use it now",
            body: "Explain the immediate next step readers should take.",
            links: [{ label: "Learn more", href: "/pages.html", style: "secondary" }]
          })
        ]
      }
    ];
  }

  function buildLayoutBlockPresets() {
    return [
      {
        key: "feature",
        label: "Feature explainer",
        description: "Heading, body, two proof paragraphs, and optional CTA.",
        section: buildSectionTemplateBase({
          heading: "Feature or capability",
          body: "Describe one important capability in a concise paragraph.",
          extraParagraphs: ["Add one implementation detail or product proof point.", "Add one outcome or operator-facing benefit."],
          links: [{ label: "Learn more", href: "/pages.html", style: "secondary" }]
        })
      },
      {
        key: "cta",
        label: "Call to action",
        description: "Short closer with one strong action and one optional secondary path.",
        section: buildSectionTemplateBase({
          heading: "Ready to move forward",
          body: "Use this block near the end of the page to focus the reader on the next action.",
          links: [{ label: "Primary action", href: "/contact-us.html", style: "primary" }, { label: "Secondary action", href: "/pages.html", style: "secondary" }]
        })
      },
      {
        key: "note",
        label: "Disclosure / note block",
        description: "Useful for rollout caveats, sourcing notes, or implementation guidance.",
        section: buildSectionTemplateBase({
          heading: "Important context",
          note: "Use the note line for the shortest version of the caveat or disclosure.",
          body: "Explain the limitation, rollout detail, or usage guidance in one calm paragraph."
        })
      }
    ];
  }

  function renderTemplateActions(editorData) {
    var host = root.querySelector("[data-pages-template-actions='true']");
    if (!host) return;
    var starters = buildPageStarterPresets(editorData);
    var blocks = buildLayoutBlockPresets();
    host.innerHTML = "<div class='small text-muted mb-3'>Use starters only when you intentionally want scaffold content. Replace every heading, paragraph, and link before publish.</div><div class='row g-3'><div class='col-12 col-xl-6'><div class='border rounded p-3 h-100 bg-body'><div class='small text-uppercase text-muted mb-2'>Page starters</div>" + starters.map(function(preset) {
      return "<div class='border rounded p-2 mb-2'><div class='d-flex justify-content-between align-items-start gap-2 flex-wrap'><div><div class='fw-semibold'>" + esc(preset.label) + "</div><div class='small text-muted'>" + esc(preset.description) + "</div></div><button type='button' class='btn btn-sm btn-outline-primary' data-pages-action='apply-template' data-template-key='" + esc(preset.key) + "'>Use starter</button></div></div>";
    }).join("") + "</div></div><div class='col-12 col-xl-6'><div class='border rounded p-3 h-100 bg-body'><div class='small text-uppercase text-muted mb-2'>Layout blocks</div>" + blocks.map(function(preset) {
      return "<div class='border rounded p-2 mb-2'><div class='d-flex justify-content-between align-items-start gap-2 flex-wrap'><div><div class='fw-semibold'>" + esc(preset.label) + "</div><div class='small text-muted'>" + esc(preset.description) + "</div></div><button type='button' class='btn btn-sm btn-outline-secondary' data-pages-action='insert-layout-block' data-template-key='" + esc(preset.key) + "'>Add block</button></div></div>";
    }).join("") + "</div></div></div>";
  }

  function renderMakePartDialog(state) {
    var host = root.querySelector("[data-pages-part-dialog='true']");
    if (!host) return;
    if (!state || state.open !== true) {
      host.innerHTML = "";
      return;
    }
    if (state.mode === "success") {
      host.innerHTML = "<div class='alert alert-success mb-0'><div class='fw-semibold mb-1'>Reusable part draft created</div><div class='small mb-3'>Created <code>app/drafts/pages/parts/" + esc(state.partPath || "") + "</code>. The page block you started from is still unchanged here. Open the part workspace to finish the draft, then come back to this page later if you want to swap this block to a reusable-part reference.</div><div class='d-flex flex-wrap gap-2'><a class='btn btn-sm btn-success' href='" + esc(state.partRoute || "/dashboard/platform.parts") + "'>Open Part Workspace</a><button type='button' class='btn btn-sm btn-outline-secondary' data-pages-action='dismiss-make-part-success'>Stay on Page</button></div></div>";
      return;
    }
    var section = state.section || {};
    host.innerHTML = "<div class='card border shadow-sm'><div class='card-body'><div class='d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3'><div><div class='small text-uppercase text-muted mb-1'>Create Reusable Part</div><div class='fw-semibold mb-1'>Block " + esc(String((state.sectionIndex || 0) + 1)) + ": " + esc(section.heading || ("Section " + ((state.sectionIndex || 0) + 1))) + "</div><div class='small text-muted'>This creates a new draft reusable part from the selected editable block only.</div></div><button type='button' class='btn btn-sm btn-outline-secondary' data-pages-action='cancel-make-part'>Cancel</button></div><div class='small text-muted border rounded p-3 mb-3 bg-body-tertiary'><div><strong>Supported source:</strong> structured page sections with a heading, main paragraph, and any optional context note, additional paragraphs, or action links from the current page editor</div><div><strong>Selected block:</strong> " + esc((section.headingTag || "h2").toUpperCase()) + " • " + esc((section.heading || "").trim() || ("Section " + ((state.sectionIndex || 0) + 1))) + "</div><div><strong>Preview:</strong> " + esc(((section.body || "").trim().slice(0, 180)) || "Structured section") + "</div><div class='mt-2'><strong>What happens next:</strong> a draft part is created with any optional context note, additional paragraphs, and action links preserved, but this page block stays exactly as it is until you update the page yourself later.</div></div><label class='form-label' for='pages-make-part-path'>Part path</label><div class='input-group mb-2'><span class='input-group-text'>app/pages/parts/</span><input id='pages-make-part-path' class='form-control' data-pages-make-part-path='true' value='" + esc(state.partPath || "") + "' placeholder='about/team.json' /></div><p class='small text-muted mb-3'>Use a JSON path relative to <code>app/pages/parts</code>. Drafts preserve supported optional notes, extra paragraphs, and action links from eligible structured sections.</p><div class='d-flex flex-wrap gap-2 align-items-center'><button type='button' class='btn btn-primary' data-pages-action='confirm-make-part' data-section-index='" + esc(String(state.sectionIndex || 0)) + "'>Create Draft Part</button><button type='button' class='btn btn-outline-secondary' data-pages-action='cancel-make-part'>Cancel</button></div></div></div>";
    var input = host.querySelector("[data-pages-make-part-path='true']");
    if (input && typeof input.focus === "function") input.focus();
  }

  function renderMakePartActions(editorData, state) {
    var host = root.querySelector("[data-pages-part-actions='true']");
    if (!host) return;
    var sections = editorData && editorData.bodySections instanceof Array ? editorData.bodySections : [];
    if (!sections.length) {
      host.innerHTML = "<p class='small text-muted mb-0'>Add at least one complete body block before creating a reusable part.</p>";
      renderMakePartDialog(null);
      return;
    }
    host.innerHTML = sections.map(function(section, index) {
      if (((section || {}).kind || "section") === "reusable-part") {
        return "<div class='border rounded p-2 mb-2 bg-body-tertiary'><div class='d-flex justify-content-between align-items-center gap-2 flex-wrap'><div><div class='fw-semibold'>Block " + esc(String(index + 1)) + ": Reusable Part</div><div class='small text-muted'>Uses <code>app/pages/parts/" + esc(section.reusablePartPath || "") + "</code>. This page keeps that shared part linked here, but you do not edit its content inline in the page editor.</div><div class='small text-muted mt-1'>To change the shared content, open the part workspace for <code>" + esc(section.reusablePartPath || "parts reference") + "</code>.</div></div><span class='badge text-bg-secondary'>Managed in Parts</span></div></div>";
      }
      return "<div class='border rounded p-2 mb-2 bg-body'><div class='d-flex justify-content-between align-items-center gap-2 flex-wrap'><div><div class='fw-semibold'>Block " + esc(String(index + 1)) + ": " + esc(section.heading || ("Section " + (index + 1))) + "</div><div class='small text-muted'>" + esc((section.headingTag || "h2").toUpperCase()) + " • " + esc((section.body || "").slice(0, 120) || "Structured section") + "</div></div><button type='button' class='btn btn-sm btn-outline-secondary' data-pages-action='make-part' data-section-index='" + index + "'>Make Part</button></div></div>";
    }).join("");
    renderMakePartDialog(state);
  }

  function cloneSections(sections) {
    return sections instanceof Array ? JSON.parse(JSON.stringify(sections)) : [];
  }

  function cloneEditorData(editorData) {
    return syncPreservedPageTypeData(JSON.parse(JSON.stringify(editorData || {})));
  }

  function collectTemplateRecoveryIssues(source, target) {
    target = target || [];
    if (source === null || source === undefined) return target;
    if (typeof source === "string" || typeof source === "number" || typeof source === "boolean") {
      var summary = String(source).trim();
      if (summary) target.push({ summary: summary });
      return target;
    }
    if (Array.isArray(source)) {
      source.forEach(function(item) {
        collectTemplateRecoveryIssues(item, target);
      });
      return target;
    }
    if (typeof source === "object") {
      var hasNestedIssues = Array.isArray(source.errors) || Array.isArray(source.reasons);
      if (Array.isArray(source.errors)) collectTemplateRecoveryIssues(source.errors, target);
      if (Array.isArray(source.reasons)) collectTemplateRecoveryIssues(source.reasons, target);

      var record = {
        field: source.field,
        path: source.path,
        name: source.name,
        label: source.label,
        title: source.title,
        message: source.message,
        description: source.description,
        reason: source.reason,
        error: source.error
      };
      var hasScopeFields = [record.field, record.path, record.name, record.label].some(function(value) {
        return value !== undefined && value !== null && String(value).trim();
      });
      var hasMeaningfulRecord = Object.keys(record).some(function(key) {
        return record[key] !== undefined && record[key] !== null && String(record[key]).trim();
      });
      if (hasMeaningfulRecord && (hasScopeFields || !hasNestedIssues)) {
        Object.keys(record).forEach(function(key) {
          if (record[key] !== undefined && record[key] !== null) record[key] = String(record[key]).trim();
        });
        target.push(record);
      }
    }
    return target;
  }

  function templateRecoveryTextContainsBodySections(value) {
    var text = (value || "").toString().trim().toLowerCase();
    if (!text) return false;
    return text.indexOf("bodysections") >= 0 || text.indexOf("body sections") >= 0 || text.indexOf("body section") >= 0;
  }

  function isBodySectionsValidationFailure(error) {
    var details = collectTemplateRecoveryIssues(error, []);
    if (!(details.length)) return false;

    var sawBodySectionsFailure = false;
    for (var i = 0; i < details.length; i++) {
      var entry = details[i] || {};
      var scopeFields = [entry.field, entry.path, entry.name, entry.label, entry.title].filter(function(value) {
        return !!((value || "").toString().trim());
      });
      var detailFields = [entry.message, entry.description, entry.reason, entry.error, entry.summary].filter(function(value) {
        return !!((value || "").toString().trim());
      });

      var scopeMentionsBodySections = scopeFields.some(templateRecoveryTextContainsBodySections);
      var detailMentionsBodySections = detailFields.some(templateRecoveryTextContainsBodySections);

      if (scopeFields.length > 0) {
        if (!scopeMentionsBodySections) return false;
        sawBodySectionsFailure = true;
        continue;
      }

      if (detailMentionsBodySections) {
        sawBodySectionsFailure = true;
        var combinedDetail = detailFields.join(" ").toLowerCase();
        if (/(^|[^a-z])(title|access|settings|page type|pagetype|schema type|schematype|status)([^a-z]|$)/.test(combinedDetail)) {
          return false;
        }
        continue;
      }

      return false;
    }

    return sawBodySectionsFailure;
  }

  function looksLikeTemplateEditorData(source) {
    if (!(source) || typeof source !== "object") return false;
    if (source.bodySections instanceof Array) return true;

    var editorMarkers = 0;
    if (Object.prototype.hasOwnProperty.call(source, "access") && source.access && typeof source.access === "object") editorMarkers += 1;
    if (Object.prototype.hasOwnProperty.call(source, "settings") && source.settings && typeof source.settings === "object") editorMarkers += 1;
    if (Object.prototype.hasOwnProperty.call(source, "pageType")) editorMarkers += 1;
    if (Object.prototype.hasOwnProperty.call(source, "schemaType")) editorMarkers += 1;
    if (Object.prototype.hasOwnProperty.call(source, "status")) editorMarkers += 1;
    if (Object.prototype.hasOwnProperty.call(source, "pageTypeData") && source.pageTypeData && typeof source.pageTypeData === "object") editorMarkers += 1;
    return editorMarkers >= 2;
  }

  function findTemplateRecoveryEditorData(source) {
    if (!(source) || typeof source !== "object") return null;

    var knownContainers = [
      source.platformPagesEditor && typeof source.platformPagesEditor === "object" ? source.platformPagesEditor.data : null,
      source.data,
      source.platformPagesEditor,
      source.editor,
      source.originalError
    ];
    for (var i = 0; i < knownContainers.length; i++) {
      var candidate = knownContainers[i];
      if (candidate && typeof candidate === "object") {
        var nested = findTemplateRecoveryEditorData(candidate);
        if (nested) return nested;
      }
    }

    if (looksLikeTemplateEditorData(source)) return source;
    return null;
  }

  async function getTemplateEditorData() {
    var fallbackEditor = cloneEditorData(((activeWorkspace || {}).editor) || {});
    try {
      return {
        editorData: await getEditorData(),
        usedFallback: false,
        fallbackMode: "none"
      };
    } catch (error) {
      var fallbackAllowed = isBodySectionsValidationFailure(error);
      var currentEditorSnapshot = findTemplateRecoveryEditorData(error);
      if (currentEditorSnapshot && fallbackAllowed) {
        var recoveredEditor = cloneEditorData(currentEditorSnapshot);
        recoveredEditor.bodySections = cloneSections(fallbackEditor.bodySections);
        console.warn("Template preset recovered stored body sections after a body-section validation failure.", error);
        return {
          editorData: recoveredEditor,
          usedFallback: true,
          fallbackMode: "bodySections"
        };
      }
      if (!fallbackAllowed) {
        var templateError = new Error("Starter presets only recover from invalid body sections. Fix the other invalid page fields in the form, then try again.");
        templateError.originalError = error;
        throw templateError;
      }
      console.warn("Template preset may need the last stored page editor state because current body sections are invalid.", error);
      return {
        editorData: fallbackEditor,
        usedFallback: true,
        fallbackMode: "fullEditor"
      };
    }
  }

  function confirmTemplatePresetFallback(templateState, mode, label) {
    if (!templateState) return true;
    if (templateState.fallbackMode === "fullEditor") {
      return window.confirm("The current body sections are invalid, so this " + label + " can only continue from the last stored draft snapshot. If you continue, ALL unsaved local edits currently in the form may be discarded before the " + label + " is " + (mode === "replace" ? "applied" : "inserted") + ". Continue?");
    }
    if (templateState.fallbackMode === "bodySections") {
      return window.confirm("The current body-section edits in the form are invalid, so this " + label + " cannot use them. If you continue, those invalid body-section edits will be replaced with the last stored draft body before the " + label + " is " + (mode === "replace" ? "applied" : "inserted") + ". Continue?");
    }
    return true;
  }

  async function applyTemplatePreset(presetKey, mode) {
    var templateState = await getTemplateEditorData();
    var editorData = templateState.editorData || {};
    var starters = buildPageStarterPresets(editorData);
    var blocks = buildLayoutBlockPresets();
    var nextEditor = JSON.parse(JSON.stringify(editorData || {}));
    nextEditor.bodySections = cloneSections(nextEditor.bodySections);

    if (mode === "replace") {
      var starter = starters.find(function(entry) { return entry.key === presetKey; });
      if (!starter) throw new Error("Unknown page starter preset.");
      var starterFallbackConfirmed = confirmTemplatePresetFallback(templateState, "replace", "starter");
      if (!starterFallbackConfirmed) return false;
      if (templateState.fallbackMode !== "bodySections" && nextEditor.bodySections.length) {
        var replaceConfirmed = window.confirm("Replace the current page body with the '" + starter.label + "' starter? This discards the current body-section edits in the form, including unsaved local changes, and replaces them with placeholder starter copy/links that you must review before publish.");
        if (!replaceConfirmed) return false;
      }
      nextEditor.bodySections = cloneSections(starter.sections);
      var starterSave = await saveDraft("manual", { editorData: nextEditor });
      if (starterSave.instanceChanged === true) return false;
      setStatus("Applied page starter: " + starter.label + "." + (templateState.fallbackMode === "bodySections" ? " The current body sections were invalid, so only body sections were recovered from the last stored draft before the starter replaced them; other in-form edits were preserved where possible." : (templateState.fallbackMode === "fullEditor" ? " The current body sections were invalid, so the starter used the last stored full draft snapshot after your confirmation; unsaved local edits elsewhere in the form may have been discarded." : " Review the placeholder copy and example links before publishing.")), templateState.usedFallback ? "text-warning" : "text-success");
      return true;
    }

    var block = blocks.find(function(entry) { return entry.key === presetKey; });
    if (!block) throw new Error("Unknown layout block preset.");
    var blockFallbackConfirmed = confirmTemplatePresetFallback(templateState, "append", "layout block");
    if (!blockFallbackConfirmed) return false;
    nextEditor.bodySections.push(JSON.parse(JSON.stringify(block.section)));
    var blockSave = await saveDraft("manual", { editorData: nextEditor });
    if (blockSave.instanceChanged === true) return false;
    setStatus("Inserted layout block: " + block.label + "." + (templateState.fallbackMode === "bodySections" ? " The current body sections were invalid, so only body sections were recovered from the last stored draft before the block was appended; other in-form edits were preserved where possible." : (templateState.fallbackMode === "fullEditor" ? " The current body sections were invalid, so the block used the last stored full draft snapshot after your confirmation; unsaved local edits elsewhere in the form may have been discarded." : " Review the placeholder copy and example links before publishing.")), templateState.usedFallback ? "text-warning" : "text-success");
    return true;
  }

  async function refreshPreview(editorData, options) {
    options = options || {};
    var generation = options.generation || workspaceInstanceGeneration;
    if (!(activeWorkspace) || !(isCurrentWorkspaceInstance(generation))) return false;
    var response = await api.action("preview", {
      relativePath: pagePath,
      editor: editorData || await getEditorData()
    });
    if (!(isCurrentWorkspaceInstance(generation))) return false;
    var iframe = root.querySelector("[data-pages-preview='true']");
    if (iframe) iframe.srcdoc = (((response || {}).data || {}).html) || "";
    return true;
  }

  async function loadWorkspace() {
    var generation = beginWorkspaceInstance();
    var response = await api.get(pagePath);
    if (!(isCurrentWorkspaceInstance(generation))) return null;
    activeWorkspace = (response || {}).data || {};
    preservedPageTypeData = clonePageTypeData((((activeWorkspace || {}).editor) || {}).pageTypeData || {});
    draftMutationVersion = getWorkspaceDraftMutation(activeWorkspace);
    draftBaseVersion = getWorkspaceDraftBaseVersion(activeWorkspace);
    makePartDialogState = null;
    activeNavigationState = null;
    renderWorkspace(activeWorkspace);
    await mountSchemaEditor(activeWorkspace);
    if (!(isCurrentWorkspaceInstance(generation))) return null;
    syncWorkspaceSummary(activeWorkspace);
    setSchemaChangeNote("");
    renderMakePartActions(activeWorkspace.editor || {}, makePartDialogState);
    await refreshPreview(activeWorkspace.editor || {}, { generation: generation });
    if (!(isCurrentWorkspaceInstance(generation))) return null;
    return activeWorkspace;
  }

  async function remountWorkspace(workspace, options) {
    options = options || {};
    var generation = beginWorkspaceInstance();
    activeWorkspace = workspace || activeWorkspace || {};
    activeNavigationState = null;
    draftMutationVersion = getWorkspaceDraftMutation(activeWorkspace);
    draftBaseVersion = getWorkspaceDraftBaseVersion(activeWorkspace);
    syncWorkspaceSummary(activeWorkspace);
    setSchemaChangeNote("");
    renderMakePartActions(activeWorkspace.editor || {}, makePartDialogState);
    await mountSchemaEditor(activeWorkspace);
    if (!(isCurrentWorkspaceInstance(generation))) return activeWorkspace;
    if (options.refreshPreview === false) return activeWorkspace;
    await refreshPreview(activeWorkspace.editor || {}, { generation: generation });
    if (!(isCurrentWorkspaceInstance(generation))) return activeWorkspace;
    return activeWorkspace;
  }

  async function saveDraft(reason, options) {
    options = options || {};
    cancelPendingAutosave();
    var requestGeneration = workspaceInstanceGeneration;
    var editorData = options.editorData || await getEditorData();
    var requestMutation = options.clientMutation || draftMutationVersion;
    var currentSaveSequence = ++saveSequence;
    setStatus("Saving draft…", "text-muted");
    var response = await api.save("", {
      relativePath: pagePath,
      editor: editorData,
      clientMutation: requestMutation,
      baseDraftVersion: draftBaseVersion
    });
    var responseData = ((response || {}).data) || {};
    var nextWorkspace = responseData.workspace || activeWorkspace;
    if (!(isCurrentWorkspaceInstance(requestGeneration))) {
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false, instanceChanged: true };
    }
    if (currentSaveSequence < lastAppliedSaveSequence) {
      return { workspace: nextWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false, instanceChanged: false };
    }
    if (draftMutationVersion > requestMutation) {
      setStatus(reason === "autosave"
        ? "Autosave finished for an older editor state, so the response was ignored and newer unsaved edits were kept in place."
        : "Save finished for an older editor state, so the response was ignored and newer unsaved edits were kept in place.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: true, instanceChanged: false };
    }
    lastAppliedSaveSequence = currentSaveSequence;
    await remountWorkspace(nextWorkspace, { refreshPreview: options.refreshPreview });
    if (!(isCurrentWorkspaceInstance(requestGeneration + 1))) {
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false, instanceChanged: true };
    }

    if (responseData.staleIgnored === true) {
      setStatus("Draft was not saved because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: true, localChangesAhead: false, instanceChanged: false };
    }

    setStatus(reason === "autosave" ? "Draft autosaved and reloaded from stored state." : "Draft saved and reloaded from stored state.", "text-success");
    return { workspace: activeWorkspace, staleIgnored: false, localChangesAhead: false, instanceChanged: false };
  }

  function scheduleWorkspaceAutosave() {
    draftMutationVersion += 1;
    setStatus("Editing draft… autosave pending.", "text-muted");
    cancelPendingAutosave();
    saveTimer = setTimeout(function() {
      saveDraft("autosave").catch(function(error) {
        console.error(error);
        var autosaveError = describeWorkspaceError(error, "Draft autosave failed.", "Draft Autosave Failed");
        setStatus(autosaveError.message, "text-danger");
      });
    }, 800);
  }

  function isEditorMutationEvent(event) {
    if (!(activeEditorHost) || !(event)) return false;
    if (event.target && activeEditorHost.contains(event.target)) return true;
    if (event.type === "ua:schema-editor:mutated" && event.target === activeEditorHost) return true;
    return false;
  }

  function handleSchemaNavigation(event) {
    var detail = (event && event.detail) || {};
    var rootEditorName = (detail.rootEditorName || detail.editorName || "").toString();
    if (rootEditorName !== "platformPagesEditor") return;
    renderNavigationState(buildPageNavigationState(detail));
  }

  function handleWorkspaceInput(event) {
    if (!(isEditorMutationEvent(event))) return;
    scheduleWorkspaceAutosave();
  }

  function handleWorkspaceChange(event) {
    if (!(isEditorMutationEvent(event))) return;
    scheduleWorkspaceAutosave();
    if (isPageTypeSignatureControl(event)) {
      captureSchemaFocusPreference(event);
      scheduleSchemaRefresh();
    }
  }

  async function handleWorkspaceClick(event) {
    var btn = event.target.closest("[data-pages-action]");
    if (!btn) return;
    event.preventDefault();
    var action = btn.getAttribute("data-pages-action");
    try {
        if (action === "jump-branch") {
          focusNavigationBranch(Number(btn.getAttribute("data-branch-index") || 0) || 0);
          return;
        }
        if (action === "save") {
          await saveDraft("manual");
          return;
        }
        if (action === "refresh-preview") {
          cancelPendingAutosave();
          var refreshGeneration = workspaceInstanceGeneration;
          setStatus("Refreshing preview…", "text-muted");
          var previewRefreshed = await refreshPreview(undefined, { generation: refreshGeneration });
          if (!(previewRefreshed)) return;
          setStatus("Preview refreshed.", "text-success");
          return;
        }
        if (action === "publish") {
          cancelPendingAutosave();
          var publishGeneration = workspaceInstanceGeneration;
          var savedDraft = await saveDraft("manual", { refreshPreview: false });
          if (savedDraft.instanceChanged === true || !(isCurrentWorkspaceInstance(publishGeneration + (savedDraft.instanceChanged ? 0 : 1)))) {
            return;
          }
          if (savedDraft.localChangesAhead === true) {
            setStatus("Publish stopped because newer unsaved edits were made while the save was in flight. Save again after those edits settle before publishing.", "text-warning");
            return;
          }
          if (savedDraft.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale changes. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          var publishResponse;
          try {
            publishResponse = await api.action("publish", { relativePath: pagePath, baseDraftVersion: draftBaseVersion });
          } catch (publishError) {
            if (!(isCurrentWorkspaceInstance(publishGeneration + 1))) return;
            var publishConfirmation = getPublishConfirmationDetails(publishError, "platform.pages.publishConfirmationRequired");
            if (!(publishConfirmation)) throw publishError;
            var publishOverrideConfirmed = window.confirm(buildPublishOverridePrompt(publishConfirmation, "Page"));
            if (!(publishOverrideConfirmed)) {
              setStatus("Publish cancelled. Live page changed after this draft started, so the draft was not forced over the newer live page.", "text-warning");
              return;
            }
            setStatus("Publishing draft with explicit stale-draft override…", "text-warning");
            publishResponse = await api.action("publish", { relativePath: pagePath, baseDraftVersion: draftBaseVersion, forcePublish: true });
          }
          if (!(isCurrentWorkspaceInstance(publishGeneration + 1))) return;
          var publishData = ((publishResponse || {}).data) || {};
          makePartDialogState = null;
          await remountWorkspace((publishData.workspace) || activeWorkspace);
          if (!(isCurrentWorkspaceInstance(publishGeneration + 2))) return;
          if (publishData.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale draft state. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          setStatus("Draft published to live and reloaded from stored state.", "text-success");
          return;
        }
        if (action === "apply-template") {
          cancelPendingAutosave();
          var appliedTemplate = await applyTemplatePreset((btn.getAttribute("data-template-key") || "").trim(), "replace");
          if (appliedTemplate === false) setStatus("Page starter cancelled.", "text-muted");
          return;
        }
        if (action === "insert-layout-block") {
          cancelPendingAutosave();
          var insertedTemplate = await applyTemplatePreset((btn.getAttribute("data-template-key") || "").trim(), "append");
          if (insertedTemplate === false) setStatus("Layout block insertion cancelled.", "text-muted");
          return;
        }
        if (action === "make-part") {
          cancelPendingAutosave();
          var editorData = await getEditorData();
          var sectionIndex = Number(btn.getAttribute("data-section-index") || -1);
          var selectedSection = ((editorData.bodySections || [])[sectionIndex]) || {};
          makePartDialogState = {
            open: true,
            mode: "create",
            sectionIndex: sectionIndex,
            section: selectedSection,
            partPath: partSlugFromSection(selectedSection, sectionIndex) + ".json"
          };
          renderMakePartActions(activeWorkspace.editor || editorData || {}, makePartDialogState);
          setStatus("Choose where to save the new draft part. The current page block will stay unchanged.", "text-muted");
          return;
        }
        if (action === "cancel-make-part") {
          makePartDialogState = null;
          renderMakePartActions(activeWorkspace.editor || {}, makePartDialogState);
          setStatus("Make part cancelled.", "text-muted");
          return;
        }
        if (action === "dismiss-make-part-success") {
          makePartDialogState = null;
          renderMakePartActions(activeWorkspace.editor || {}, makePartDialogState);
          setStatus("Reusable part created.", "text-success");
          return;
        }
        if (action === "confirm-make-part") {
          cancelPendingAutosave();
          var latestEditorData = await getEditorData();
          var makePartSectionIndex = Number(btn.getAttribute("data-section-index") || -1);
          var partPathInput = root.querySelector("[data-pages-make-part-path='true']");
          var requestedPartPath = ((partPathInput && partPathInput.value) || "").trim();
          if (!requestedPartPath) {
            setStatus("Enter a part path before creating the draft part.", "text-danger");
            if (partPathInput && typeof partPathInput.focus === "function") partPathInput.focus();
            return;
          }
          setStatus("Creating draft reusable part…", "text-muted");
          var makePartResponse = await api.action("makePart", {
            relativePath: pagePath,
            editor: latestEditorData,
            clientMutation: draftMutationVersion,
            baseDraftVersion: draftBaseVersion,
            sectionIndex: makePartSectionIndex,
            partPath: requestedPartPath
          });
          var makePartData = ((makePartResponse || {}).data) || {};
          makePartDialogState = {
            open: true,
            mode: "success",
            partPath: makePartData.partPath || requestedPartPath,
            partRoute: makePartData.partRoute || "/dashboard/platform.parts"
          };
          renderMakePartActions(activeWorkspace.editor || latestEditorData || {}, makePartDialogState);
          setStatus("Draft reusable part created: " + (makePartData.partPath || requestedPartPath) + ". The page block is still unchanged.", "text-success");
          return;
        }
        if (action === "revert") {
          var confirmed = window.confirm("Revert this draft back to the published live page?");
          if (!confirmed) return;
          cancelPendingAutosave();
          var revertGeneration = workspaceInstanceGeneration;
          var revertResponse = await api.action("revert", { relativePath: pagePath, baseDraftVersion: draftBaseVersion });
          if (!(isCurrentWorkspaceInstance(revertGeneration))) return;
          var revertData = ((revertResponse || {}).data) || {};
          makePartDialogState = null;
          await remountWorkspace(revertData.workspace || activeWorkspace);
          if (!(isCurrentWorkspaceInstance(revertGeneration + 1))) return;
          if (revertData.staleIgnored === true) {
            setStatus("Revert was not applied because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
            return;
          }
          setStatus("Draft reverted to live.", "text-success");
          return;
        }
        if (action === "recover-revert") {
          var recoverConfirmed = window.confirm("Revert this unsupported page draft back to the published live page? This discards the unsupported draft so editing can resume from live.");
          if (!recoverConfirmed) return;
          var recoverGeneration = workspaceInstanceGeneration;
          setStatus("Reverting draft to the published live page…", "text-muted");
          var recoverBaseDraftVersion = Number(btn.getAttribute("data-base-draft-version") || 0) || 0;
          var recoverResponse = await api.action("revert", { relativePath: pagePath, baseDraftVersion: recoverBaseDraftVersion });
          if (!(isCurrentWorkspaceInstance(recoverGeneration))) return;
          var recoverData = ((recoverResponse || {}).data) || {};
          await remountWorkspace(recoverData.workspace || activeWorkspace);
          if (!(isCurrentWorkspaceInstance(recoverGeneration + 1))) return;
          if (recoverData.staleIgnored === true) {
            setStatus("Recovery lost the freshness race, so the latest stored page workspace was reloaded instead.", "text-warning");
            return;
          }
          setStatus("Unsupported draft reverted to live. Editing can continue from the supported live page.", "text-success");
          return;
        }
    } catch (error) {
      console.error(error);
      var actionError = describeWorkspaceError(error, "Page workspace action failed.", "Page Workspace Action Failed");
      setStatus(actionError.message, "text-danger");
    }
  }

  document.addEventListener("ua:schema-editor:navigation", handleSchemaNavigation);
  root.addEventListener("input", handleWorkspaceInput);
  root.addEventListener("change", handleWorkspaceChange);
  root.addEventListener("ua:schema-editor:mutated", handleWorkspaceChange);
  root.addEventListener("click", handleWorkspaceClick);
  root.__platformPagesCleanup = function() {
    workspaceDisposed = true;
    schemaRefreshGeneration += 1;
    workspaceInstanceGeneration += 1;
    cancelPendingAutosave();
    document.removeEventListener("ua:schema-editor:navigation", handleSchemaNavigation);
    root.removeEventListener("input", handleWorkspaceInput);
    root.removeEventListener("change", handleWorkspaceChange);
    root.removeEventListener("ua:schema-editor:mutated", handleWorkspaceChange);
    root.removeEventListener("click", handleWorkspaceClick);
    if (pendingSchemaRefresh && typeof pendingSchemaRefresh.catch === "function") {
      pendingSchemaRefresh.catch(function() {});
    }
    root.__platformPagesCleanup = null;
    activeEditorHost = null;
    activeEditorSelector = "";
    activeNavigationState = null;
    pendingFocusRestore = null;
    pendingSchemaRefresh = null;
  };

  try {
    await loadWorkspace();
  } catch (error) {
    console.error(error);
    renderWorkspaceFailure(error, "Unable to load page workspace.", "Unable to Load Page Workspace");
  }
}

async function platformPartsWorkspaceInit(context) {
  var root = document.querySelector("[data-platform-parts-workspace='true']");
  if (!root) return;

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI;
  if (!dashboardApi) return;

  var apiUrl = (root.getAttribute("data-api-url") || "").trim();
  var partPath = (root.getAttribute("data-part-path") || "").trim();
  var api = apiUrl ? dashboardApi.withBase(apiUrl) : dashboardApi.withBase("/api/platform.parts");

  root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'>Loading part workspace...</div></div>";

  function esc(value) {
    return escapeHtml((value || "").toString());
  }

  function setStatus(message, tone) {
    var el = root.querySelector("[data-parts-workspace-status='true']");
    if (!el) return;
    el.className = "small mb-0 " + (tone || "text-muted");
    el.textContent = message || "";
  }

  function describeWorkspaceError(error, fallbackMessage, fallbackTitle) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var title = (error && (error.title || data.title)) || fallbackTitle || "Part Workspace Error";
    var message = (error && (error.description || data.description || error.message || data.message)) || fallbackMessage || "An error occurred while working with this part.";
    var reasons = (data.reasons instanceof Array) ? data.reasons : ((error && error.reasons instanceof Array) ? error.reasons : []);
    var recovery = data.recovery || (error && error.recovery) || null;
    return { title: title.toString(), message: message.toString(), reasons: reasons, recovery: recovery };
  }

  function getPublishConfirmationDetails(error) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var namespace = ((error && (error.namespace || "")) || data.namespace || "").toString();
    if (namespace !== "platform.parts.publishConfirmationRequired") return null;
    return {
      title: ((error && error.title) || data.title || "Publish confirmation required").toString(),
      message: ((error && error.description) || data.description || "Live changed after this draft started. Confirm if you want to replace the newer live version with this draft.").toString(),
      collaboration: data.collaboration || error.collaboration || {}
    };
  }

  function buildPublishOverridePrompt(details) {
    var collaboration = details && details.collaboration ? details.collaboration : {};
    var lines = [
      (details && details.title) || "Part publish confirmation required",
      "",
      (details && details.message) || "Live part changed after this draft started.",
      "",
      "Draft modified: " + (collaboration.draftModified || "—"),
      "Live modified: " + (collaboration.liveModified || "—"),
      "Draft baseline live version: " + (collaboration.sourceLiveVersion || "—"),
      "Current live version: " + (collaboration.liveVersion || "—")
    ];
    if (collaboration.summary) lines.push("", collaboration.summary);
    lines.push("", "Publish anyway and intentionally replace the newer live part with this draft?");
    return lines.join("\n");
  }

  function renderWorkspace(workspace) {
    var live = workspace.live || {};
    var draft = workspace.draft || {};
    var proof = workspace.proof || {};
    var constraints = workspace.constraints || {};
    root.innerHTML = "" +
      "<div class='container-fluid px-0'><div class='row g-4'>" +
        "<div class='col-12 col-xl-5'><div class='card border-0 shadow-sm h-100'><div class='card-body p-4'>" +
          "<div class='mb-3'><p class='text-uppercase text-muted small mb-1'>Reusable Part Workspace</p><h1 class='h4 mb-1'>" + esc(partPath) + "</h1><p class='text-muted mb-0'>Edit and publish one reusable structured section part without widening into broader part JSON.</p></div>" +
          "<div class='small text-muted border rounded p-3 mb-4 bg-body-tertiary'><div><strong>Editor route:</strong> <code>" + esc(proof.route || ("/dashboard/platform.parts/" + partPath)) + "</code></div><div><strong>Live source:</strong> <code>" + esc(proof.livePath || ("@!/app/pages/parts/" + partPath)) + "</code></div><div><strong>Draft source:</strong> <code>" + esc(proof.draftPath || ("@!/app/drafts/pages/parts/" + partPath)) + "</code></div><div><strong>Scope:</strong> <span data-parts-scope-summary='true'>" + esc(constraints.summary || "Structured section part subset only.") + "</span></div></div>" +
          "<div class='row g-3 mb-4'><div class='col-12 col-md-6'><div class='border rounded p-3 h-100'><div class='small text-uppercase text-muted mb-1'>Live</div><div class='fw-semibold'>" + esc(live.title || partPath) + "</div><div class='small text-muted mt-2'>Modified: <span data-parts-live-modified='true'>" + esc(live.modified || "—") + "</span></div></div></div><div class='col-12 col-md-6'><div class='border rounded p-3 h-100 bg-warning-subtle'><div class='small text-uppercase text-muted mb-1'>Draft</div><div class='fw-semibold'>" + esc(draft.title || partPath) + "</div><div class='small text-muted mt-2'>Modified: <span data-parts-draft-modified='true'>" + esc(draft.modified || "—") + "</span></div></div></div></div>" +
          "<div data-parts-schema-editor='true' class='mb-3'></div>" +
          "<div class='d-flex flex-wrap gap-2 align-items-center'><button type='button' class='btn btn-outline-primary' data-parts-action='save'>Save Draft</button><button type='button' class='btn btn-success' data-parts-action='publish'>Publish Draft to Live</button><button type='button' class='btn btn-outline-danger' data-parts-action='revert'>Revert Draft to Live</button><a class='btn btn-outline-secondary' href='/dashboard/platform.parts'>Back to Parts</a></div>" +
          "<p class='small text-muted mb-0 mt-3' data-parts-workspace-status='true'>Draft workspace ready.</p>" +
        "</div></div></div>" +
      "</div></div>";
  }

  var activeWorkspace = null;
  var activeEditorHost = null;
  var activeEditorSelector = "";
  var saveSequence = 0;
  var lastAppliedSaveSequence = 0;
  var draftMutationVersion = 0;
  var draftBaseVersion = 0;

  async function mountSchemaEditor(workspace) {
    var host = root.querySelector("[data-parts-schema-editor='true']");
    host.innerHTML = "";
    var editorNode = await window.UATools.render({
      n: "ua.fields.schema.editor",
      name: "platformPartsEditor",
      schema: workspace.schema || {},
      groups: workspace.groups || [],
      data: workspace.editor || {},
      continueText: "Continue",
      showSummaryStep: false,
      skipGroupedNestedSteps: true,
      disableDefaultWizardBehavior: true,
      showStepNavigation: true
    });
    if (typeof editorNode === "string") {
      host.innerHTML = editorNode;
      activeEditorHost = host.firstElementChild;
    } else {
      host.appendChild(editorNode);
      activeEditorHost = editorNode;
    }
    if (activeEditorHost) {
      if (!activeEditorHost.id) activeEditorHost.id = "platform-parts-editor-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
      activeEditorSelector = "#" + activeEditorHost.id;
    }
    if (typeof window.UATools.after === "function") window.UATools.after();
  }

  async function getEditorData() {
    var result = await window.UATools.save(activeEditorSelector || activeEditorHost, true);
    if (!result || result.success === false) throw result || new Error("Unable to save schema editor state.");
    var editorSave = result.platformPartsEditor || null;
    if (!editorSave || editorSave.success === false) throw editorSave || new Error("Schema editor did not return part data.");
    return editorSave.data || {};
  }

  function getWorkspaceDraftMutation(workspace) {
    return Number(((((workspace || {}).editorState) || {}).draftMutation) || 0) || 0;
  }

  function getWorkspaceDraftBaseVersion(workspace) {
    return Number(((((workspace || {}).editorState) || {}).baseDraftVersion) || ((((workspace || {}).editorState) || {}).draftVersion) || 0) || 0;
  }

  function syncWorkspaceSummary(workspace) {
    var live = (workspace || {}).live || {};
    var draft = (workspace || {}).draft || {};
    var constraints = (workspace || {}).constraints || {};
    var liveEl = root.querySelector("[data-parts-live-modified='true']");
    if (liveEl) liveEl.textContent = live.modified || "—";
    var draftEl = root.querySelector("[data-parts-draft-modified='true']");
    if (draftEl) draftEl.textContent = draft.modified || "—";
    var scopeEl = root.querySelector("[data-parts-scope-summary='true']");
    if (scopeEl) scopeEl.textContent = constraints.summary || "Structured section part subset only.";
  }

  function remountWorkspace(workspace) {
    activeWorkspace = workspace || activeWorkspace;
    draftMutationVersion = getWorkspaceDraftMutation(activeWorkspace);
    draftBaseVersion = getWorkspaceDraftBaseVersion(activeWorkspace);
    renderWorkspace(activeWorkspace);
    return mountSchemaEditor(activeWorkspace).then(function() {
      syncWorkspaceSummary(activeWorkspace);
      return activeWorkspace;
    });
  }

  async function loadWorkspace() {
    var response = await api.get(partPath);
    await remountWorkspace((response || {}).data || {});
  }

  function markDraftDirty() {
    draftMutationVersion += 1;
    setStatus("Editing draft… not yet saved.", "text-muted");
  }

  function isEditorMutationEvent(event) {
    if (!(activeEditorHost) || !(event)) return false;
    if (event.target && activeEditorHost.contains(event.target)) return true;
    if (event.type === "ua:schema-editor:mutated" && event.target === activeEditorHost) return true;
    return false;
  }

  async function saveDraft(options) {
    options = options || {};
    var editorData = options.editorData || await getEditorData();
    var clientMutation = options.clientMutation;
    if (!(clientMutation > 0)) clientMutation = draftMutationVersion || getWorkspaceDraftMutation(activeWorkspace) || 0;
    var currentSaveSequence = ++saveSequence;
    var saveResponse = await api.save("", { relativePath: partPath, editor: editorData, clientMutation: clientMutation, baseDraftVersion: draftBaseVersion });
    var responseData = ((saveResponse || {}).data) || {};
    var nextWorkspace = responseData.workspace || activeWorkspace;
    if (currentSaveSequence < lastAppliedSaveSequence) {
      return { workspace: nextWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false };
    }
    if (draftMutationVersion > clientMutation) {
      setStatus("Save finished for an older editor state, so the response was ignored and newer unsaved edits were kept in place.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: true };
    }
    lastAppliedSaveSequence = currentSaveSequence;
    await remountWorkspace(nextWorkspace);
    if (responseData.staleIgnored === true) {
      setStatus("Draft was not saved because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: true, localChangesAhead: false };
    }
    setStatus(options.reason === "publish-prepare" ? "Draft saved and reloaded from stored state. Ready to publish." : "Draft saved and reloaded from stored state.", "text-success");
    return { workspace: activeWorkspace, staleIgnored: false, localChangesAhead: false };
  }

  try {
    await loadWorkspace();

    root.addEventListener("input", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("change", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("ua:schema-editor:mutated", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("click", async function(event) {
      var btn = event.target.closest("[data-parts-action]");
      if (!btn) return;
      event.preventDefault();
      var action = btn.getAttribute("data-parts-action");
      try {
        if (action === "save") {
          setStatus("Saving draft…", "text-muted");
          await saveDraft();
          return;
        }
        if (action === "publish") {
          setStatus("Saving latest draft before publish…", "text-muted");
          var savedDraft = await saveDraft({ reason: "publish-prepare" });
          if (savedDraft.localChangesAhead === true) {
            setStatus("Publish stopped because newer unsaved edits were made while the save was in flight. Save again after those edits settle before publishing.", "text-warning");
            return;
          }
          if (savedDraft.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale changes. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          setStatus("Publishing draft…", "text-muted");
          var publishResponse;
          try {
            publishResponse = await api.action("publish", { relativePath: partPath, baseDraftVersion: draftBaseVersion });
          } catch (publishError) {
            var publishConfirmation = getPublishConfirmationDetails(publishError);
            if (!(publishConfirmation)) throw publishError;
            var publishOverrideConfirmed = window.confirm(buildPublishOverridePrompt(publishConfirmation));
            if (!(publishOverrideConfirmed)) {
              setStatus("Publish cancelled. Live part changed after this draft started, so the draft was not forced over the newer live part.", "text-warning");
              return;
            }
            setStatus("Publishing draft with explicit stale-draft override…", "text-warning");
            publishResponse = await api.action("publish", { relativePath: partPath, baseDraftVersion: draftBaseVersion, forcePublish: true });
          }
          var publishData = ((publishResponse || {}).data) || {};
          await remountWorkspace((publishData.workspace) || activeWorkspace);
          if (publishData.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale draft state. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          setStatus("Draft published to live and reloaded from stored state.", "text-success");
          return;
        }
        if (action === "revert") {
          var confirmed = window.confirm("Revert this part draft back to the published live part?");
          if (!confirmed) return;
          setStatus("Reverting draft…", "text-muted");
          var revertResponse = await api.action("revert", { relativePath: partPath, baseDraftVersion: draftBaseVersion });
          var revertData = ((revertResponse || {}).data) || {};
          await remountWorkspace(revertData.workspace || activeWorkspace);
          if (revertData.staleIgnored === true) {
            setStatus("Revert was not applied because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
            return;
          }
          setStatus("Draft reverted to live.", "text-success");
          return;
        }
        if (action === "recover-revert") {
          var recoverConfirmed = window.confirm("Revert this unsupported part draft back to the published live part? This discards the unsupported draft so editing can resume from live.");
          if (!recoverConfirmed) return;
          setStatus("Reverting draft to the published live part…", "text-muted");
          var recoverBaseDraftVersion = Number(btn.getAttribute("data-base-draft-version") || 0) || 0;
          var recoverResponse = await api.action("revert", { relativePath: partPath, baseDraftVersion: recoverBaseDraftVersion });
          var recoverData = ((recoverResponse || {}).data) || {};
          await remountWorkspace(recoverData.workspace || activeWorkspace);
          if (recoverData.staleIgnored === true) {
            setStatus("Recovery lost the freshness race, so the latest stored part workspace was reloaded instead.", "text-warning");
            return;
          }
          setStatus("Unsupported draft reverted to live. Editing can continue from the supported live part.", "text-success");
          return;
        }
      } catch (error) {
        console.error(error);
        var actionError = describeWorkspaceError(error, "Part workspace action failed.", "Part Workspace Action Failed");
        setStatus(actionError.message, "text-danger");
      }
    });
  } catch (error) {
    console.error(error);
    var details = describeWorkspaceError(error, "Unable to load part workspace.", "Unable to Load Part Workspace");
    root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'><div class='alert alert-warning mb-3'><h1 class='h5 mb-2'>" + esc(details.title) + "</h1><p class='mb-0'>" + esc(details.message) + "</p>" + (details.reasons.length ? ("<ul class='small mb-0 mt-3 ps-3'>" + details.reasons.map(function(reason) { return "<li>" + esc(reason) + "</li>"; }).join("") + "</ul>") : "") + "</div><div class='d-flex flex-wrap gap-2'>" + (((details.recovery || {}).action === "revert") ? ("<button type='button' class='btn btn-outline-danger' data-parts-action='recover-revert' data-base-draft-version='" + esc(String(Number(((details.recovery || {}).baseDraftVersion || 0) || 0))) + "'>" + esc((details.recovery || {}).label || "Revert Draft to Live") + "</button>") : "") + "<a class='btn btn-outline-secondary' href='/dashboard/platform.parts'>Back to Parts</a></div></div></div>";
  }
}

async function platformFooterWorkspaceInit(context) {
  var root = document.querySelector("[data-platform-footer-workspace='true']");
  if (!root) return;

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI;
  if (!dashboardApi) return;

  var apiUrl = (root.getAttribute("data-api-url") || "").trim();
  var api = apiUrl ? dashboardApi.withBase(apiUrl) : dashboardApi.withBase("/api/platform.footer");

  root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'>Loading footer workspace...</div></div>";

  function esc(value) { return escapeHtml((value || "").toString()); }
  function normalizeReason(reason) {
    if (reason === null || reason === undefined) return "";
    if (typeof reason === "string") return reason.trim();
    if (typeof reason === "number" || typeof reason === "boolean") return String(reason);
    if (reason && typeof reason === "object") {
      var label = reason.title || reason.label || reason.field || reason.path || reason.name || "";
      var detail = reason.description || reason.message || reason.reason || reason.error || reason.expected || reason.value || "";
      if (label && detail) return (label + ": " + detail).trim();
      if (detail) return detail.toString().trim();
      if (label) return label.toString().trim();
      try { return JSON.stringify(reason); } catch (jsonError) { return "[unreadable reason]"; }
    }
    return "";
  }
  function formatReasonList(reasons) {
    return (reasons instanceof Array ? reasons : []).map(normalizeReason).filter(Boolean);
  }
  function guidanceListHtml(items, itemClass) {
    var list = items instanceof Array ? items.filter(Boolean) : [];
    if (!list.length) return "";
    return "<ul class='ps-3 mb-0 " + (itemClass || "small") + "'>" + list.map(function(item) { return "<li>" + esc(item) + "</li>"; }).join("") + "</ul>";
  }
  function setStatus(message, tone, reasons) {
    var el = root.querySelector("[data-footer-workspace-status='true']");
    if (!el) return;
    var toneClass = tone || "alert-secondary";
    el.className = "alert " + toneClass + " mb-0";
    var html = "<div class='fw-semibold mb-1'>" + esc(message || "") + "</div>";
    var normalizedReasons = formatReasonList(reasons);
    if (normalizedReasons.length) html += guidanceListHtml(normalizedReasons, "small");
    el.innerHTML = html;
  }
  function describeWorkspaceError(error, fallbackMessage, fallbackTitle) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var title = (error && (error.title || data.title)) || fallbackTitle || "Footer Workspace Error";
    var message = (error && (error.description || data.description || error.message || data.message)) || fallbackMessage || "An error occurred while working with the footer.";
    var reasons = [];
    if (error && error.errors instanceof Array) reasons = reasons.concat(error.errors);
    if (data && data.errors instanceof Array) reasons = reasons.concat(data.errors);
    if (data && data.originalError) {
      var original = data.originalError;
      if (original.errors instanceof Array) reasons = reasons.concat(original.errors);
      if (original.message && reasons.length === 0) reasons.push(original.message);
    }
    return { title: title.toString(), message: message.toString(), reasons: formatReasonList(reasons) };
  }
  function getPublishConfirmationDetails(error) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var namespace = ((error && (error.namespace || "")) || data.namespace || "").toString();
    if (namespace !== "platform.footer.publishConfirmationRequired") return null;
    return {
      title: ((error && error.title) || data.title || "Live footer changed since this draft began").toString(),
      message: ((error && error.description) || data.description || "Someone updated the live footer after this draft started.").toString(),
      collaboration: data.collaboration || error.collaboration || {}
    };
  }
  function footerPreviewYear(workspace) {
    var published = (((workspace || {}).draft || {}).published) || (((workspace || {}).live || {}).published) || "";
    var year = Number(String((published || "").toString().slice(0, 4))) || new Date().getFullYear();
    return year;
  }
  function isSafeFooterPreviewHref(value) {
    var href = (value || "").toString().trim();
    if (!href) return false;
    if (/^\/\//.test(href)) return false;
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(href)) return /^(https?:|mailto:|tel:)/i.test(href);
    return /^(\/|\.\/|\.\.\/|#|\?)/.test(href);
  }
  function footerPreviewHrefStatus(href) {
    var value = (href || "").toString().trim();
    if (!value) return "No destination";
    return isSafeFooterPreviewHref(value) ? "Supported destination" : "Unsupported destination";
  }
  function footerPreviewCardHtml(workspace) {
    var doc = ((workspace || {}).editor) || {};
    var proof = (workspace || {}).proof || {};
    var appLinks = doc.appLinks instanceof Array ? doc.appLinks : [];
    var promo = doc.promo || {};
    var promoWords = promo.typeonWords instanceof Array ? promo.typeonWords.filter(Boolean) : [];
    var bannerEyebrow = doc.bannerEyebrow || "Welcome to The Universe,";
    var bannerMessage = doc.bannerMessage || "pursue your dreams!";
    var legalYear = footerPreviewYear(workspace);
    var promoHtml = promo.enabled === true
      ? ("<aside class='rounded border bg-body-tertiary px-3 py-3 text-center mb-3'><a class='text-reset text-decoration-none fs-5 fw-semibold' href='" + esc(promo.href || "#") + "'>" +
          "<span>" + esc(promo.beforeText || "") + "</span>" +
          (promoWords.length ? " <span class='text-primary'>" + esc(promoWords.join(" • ")) + "</span>" : "") +
          ((promo.afterText || "") ? " <span>" + esc(promo.afterText || "") + "</span>" : "") +
        "</a><div class='small text-muted mt-2'>Destination: " + esc(promo.href || "—") + "</div><div class='small mt-1 " + (isSafeFooterPreviewHref(promo.href) ? "text-success" : "text-danger") + "'>" + esc(footerPreviewHrefStatus(promo.href)) + "</div></aside>")
      : "<div class='small text-muted mb-3'>Structured promo copy is off.</div>";
    var linksHtml = appLinks.length
      ? ("<div class='row g-2 justify-content-center'>" + appLinks.map(function(link, index) {
          var iconHtml = link.icon ? ("<div class='small text-muted mb-1'><i class='bi bi-" + esc(link.icon) + " me-1'></i>Footer icon</div>") : "";
          return "<div class='col-12 col-md-6 col-xl-4'><div class='border rounded p-3 h-100 bg-white'><div class='small text-uppercase text-muted mb-1'>Link " + esc(String(index + 1)) + "</div>" + iconHtml + "<div class='fw-semibold'>" + esc(link.title || "Untitled link") + "</div><div class='small text-muted text-break mt-1'>" + esc(link.href || "No destination") + "</div><div class='small mt-1 " + (isSafeFooterPreviewHref(link.href) ? "text-success" : "text-danger") + "'>" + esc(footerPreviewHrefStatus(link.href)) + "</div></div></div>";
        }).join("") + "</div>")
      : "<div class='small text-muted'>No app links configured.</div>";
    var hiddenNote = doc.appSectionVisible === true
      ? ""
      : "<div class='alert alert-warning small mt-3 mb-0'><strong>App footer content is currently hidden.</strong> Promo copy and app links stay configured in the draft, but they will not appear on the live footer until this section is turned back on.</div>";
    return "<div class='border rounded overflow-hidden bg-white'><div class='bg-75-info border-bottom px-4 py-4 text-center'><div class='small text-uppercase fw-semibold text-primary mb-1'>" + esc(bannerEyebrow) + "</div><div class='h5 mb-0'>" + esc(bannerMessage) + "</div></div><div class='p-4'>" + (doc.appSectionVisible === true ? promoHtml + linksHtml : "<div class='small text-muted'>App footer content is hidden in the live footer right now.</div>") + hiddenNote + "</div><div class='bg-dark text-white px-4 py-4'><div class='d-flex flex-column align-items-center gap-3 text-center'><a href='https://egtuniverse.com' class='d-inline-flex align-items-center justify-content-center'><img src='https://egtuniverse.com/logo.svg' alt='The Universe Logo' style='width:4rem;max-width:100%;height:auto;filter:brightness(0) invert(1);'/></a><div class='small'>© " + esc(String(legalYear)) + ". EGT. All Rights Reserved.</div><div class='d-flex flex-wrap justify-content-center gap-3 small'><span>Terms of Service</span><span>Privacy Policy</span></div><div class='small text-light-emphasis'>Locked Universe legal strip preview • source: " + esc(proof.draftHtmlPath || "@!/app/drafts/pages/parts/footer.html") + "</div></div></div></div>";
  }
  function collaborationSummary(workspace) {
    var collaboration = (workspace || {}).collaboration || {};
    if (!collaboration.draftExists) return "No draft yet. Your first save creates the shared footer draft files.";
    if (collaboration.liveChangedSinceDraft && collaboration.draftChanged) return "Draft differs from live, and live also changed after this draft began.";
    if (collaboration.liveChangedSinceDraft) return "Live changed after this draft began. Publishing now requires confirmation.";
    if (collaboration.draftChanged) return "Draft differs from live.";
    return "Draft matches live.";
  }
  function renderWorkspace(workspace) {
    var live = workspace.live || {};
    var draft = workspace.draft || {};
    var proof = workspace.proof || {};
    var constraints = workspace.constraints || {};
    var collaboration = workspace.collaboration || {};
    root.innerHTML = "" +
      "<div class='container-fluid px-0'><div class='row g-4'>" +
        "<div class='col-12 col-xl-5'><div class='card border-0 shadow-sm h-100'><div class='card-body p-4'>" +
          "<div class='mb-4'><p class='text-uppercase text-muted small mb-1'>Shared Footer Workspace</p><h1 class='h4 mb-2'>Shared Footer</h1><p class='text-muted mb-0'>Edit shared banner copy and optional app footer content while the locked Universe legal strip stays enforced.</p></div>" +
          "<div class='border rounded p-3 mb-4 bg-body-tertiary small text-muted'><div><strong>Editor route:</strong> <code>" + esc(proof.route || "/dashboard/platform.footer/shared-footer") + "</code></div><div><strong>Live JSON + HTML:</strong> <code>" + esc(proof.livePath || "@!/app/pages/parts/footer.json") + "</code> and <code>" + esc(proof.liveHtmlPath || "@!/app/pages/parts/footer.html") + "</code></div><div><strong>Draft JSON + HTML:</strong> <code>" + esc(proof.draftPath || "@!/app/drafts/pages/parts/footer.json") + "</code> and <code>" + esc(proof.draftHtmlPath || "@!/app/drafts/pages/parts/footer.html") + "</code></div></div>" +
          "<div class='alert alert-light border mb-4'><div class='fw-semibold mb-2'>How this workspace works</div><ul class='small ps-3 mb-0'><li>Save updates draft JSON + draft HTML only.</li><li>Publish first saves the latest draft, then updates live JSON + live HTML.</li><li>Revert discards the current draft and rebuilds it from live.</li><li>The locked Universe legal strip is never editable here.</li></ul></div>" +
          "<div class='alert alert-secondary mb-3'><div class='fw-semibold mb-2'>What you can edit</div>" + guidanceListHtml(constraints.supports || []) + "</div>" +
          "<div class='alert alert-dark-subtle border mb-4'><div class='fw-semibold mb-2'>What stays locked</div>" + guidanceListHtml(constraints.locked || []) + "</div>" +
          "<div class='row g-3 mb-4'><div class='col-12 col-md-6'><div class='border rounded p-3 h-100'><div class='small text-uppercase text-muted mb-1'>Live</div><div class='fw-semibold'>" + esc(live.title || "Shared Footer") + "</div><div class='small mt-2'><strong>Status:</strong> Live site source</div><div class='small text-muted mt-2'>Published: <span data-footer-live-published='true'>" + esc(live.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-footer-live-modified='true'>" + esc(live.modified || "—") + "</span></div></div></div><div class='col-12 col-md-6'><div class='border rounded p-3 h-100 bg-body-tertiary'><div class='small text-uppercase text-muted mb-1'>Draft</div><div class='fw-semibold'>" + esc(draft.title || "Shared Footer") + "</div><div class='small mt-2' data-footer-draft-state='true'>" + esc(collaborationSummary(workspace)) + "</div><div class='small text-muted mt-2'>Published: <span data-footer-draft-published='true'>" + esc(draft.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-footer-draft-modified='true'>" + esc(draft.modified || "—") + "</span></div></div></div></div>" +
          "<div class='alert " + (collaboration.liveChangedSinceDraft ? "alert-warning" : (collaboration.draftChanged ? "alert-info" : "alert-light border")) + " mb-4'><div class='fw-semibold mb-1'>Collaboration state</div><div class='small mb-2'>" + esc(collaborationSummary(workspace)) + "</div><ul class='small ps-3 mb-0'><li>Draft exists: " + esc(collaboration.draftExists ? "Yes" : "No") + "</li><li>Draft modified: " + esc(collaboration.draftModified || "—") + "</li><li>Live modified: " + esc(collaboration.liveModified || "—") + "</li><li>Publish confirmation required: " + esc(collaboration.publishRequiresConfirmation ? "Yes" : "No") + "</li></ul></div>" +
          "<div data-footer-schema-editor='true' class='mb-3'></div>" +
          "<div class='d-flex flex-wrap gap-2 align-items-center'><button type='button' class='btn btn-outline-primary' data-footer-action='save'>Save Draft</button><button type='button' class='btn btn-success' data-footer-action='publish'>Publish to Live</button><button type='button' class='btn btn-outline-danger' data-footer-action='revert'>Revert Draft to Live</button><a class='btn btn-outline-secondary' href='/dashboard/platform.footer'>Back to Footer</a></div>" +
          "<div class='alert alert-secondary mt-3 mb-0' data-footer-workspace-status='true'><div class='fw-semibold mb-1'>Workspace ready</div><div class='small'>Preview reflects the currently loaded draft state.</div></div>" +
        "</div></div></div>" +
        "<div class='col-12 col-xl-7'><div class='card border-0 shadow-sm h-100'><div class='card-body p-4'><p class='text-uppercase text-muted small mb-1'>Preview</p><h2 class='h5 mb-3'>Rendered footer preview</h2><div data-footer-preview='true'>" + footerPreviewCardHtml(workspace) + "</div><div class='alert alert-light border mt-3 mb-0'><div class='fw-semibold mb-2'>Supported-shape notes</div>" + guidanceListHtml(constraints.recovery || []) + "</div></div></div></div>" +
      "</div></div>";
  }
  function renderUnsupportedWorkspace(details) {
    details = details || {};
    var reasons = details.reasons instanceof Array ? details.reasons : [];
    var recovery = details.recovery || null;
    root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4 p-lg-5'>" +
      "<div class='alert alert-warning mb-4'><h1 class='h5 mb-2'>" + esc(details.title || "This Footer Can’t Be Edited Here Yet") + "</h1><p class='mb-0'>" + esc(details.message || "This workspace is read-only right now.") + "</p>" + (reasons.length ? guidanceListHtml(reasons, "small mt-3") : "") + "</div>" +
      "<div class='row g-4'>" +
        "<div class='col-12 col-lg-6'><div class='border rounded p-3 h-100 bg-body-tertiary'><h2 class='h6 mb-2'>This editor supports</h2><ul class='small mb-0 ps-3'><li>Footer banner copy</li><li>App footer section visibility</li><li>App footer links</li><li>Structured promo copy</li><li>Locked Universe legal strip enforcement</li></ul></div></div>" +
        "<div class='col-12 col-lg-6'><div class='border rounded p-3 h-100'><h2 class='h6 mb-2'>What to do next</h2><ul class='small mb-0 ps-3'><li>Review the live footer source at <code>@!/app/pages/parts/footer.json</code> and rendered output at <code>@!/app/pages/parts/footer.html</code>.</li><li>If only the draft is unsupported, inspect <code>@!/app/drafts/pages/parts/footer.json</code> before recovery so any needed copy can be copied/exported first.</li><li>Small unsupported fields anywhere in the JSON can trigger this read-only state because the editor only supports the safe shared-footer subset.</li><li>If you are not using developer/source flows, use the recovery action below to discard only the unsupported draft and restart from live.</li></ul></div></div>" +
      "</div>" +
      (recovery ? ("<div class='alert alert-danger mt-4 mb-0'><div class='fw-semibold mb-2'>Recovery will discard the current draft only</div><div class='small mb-0'>Live stays unchanged. Copy anything needed from the unsupported draft files before you continue, because recovery rebuilds the draft from the current live footer.</div></div>") : "") +
      "<div class='d-flex flex-wrap gap-2 align-items-center mt-4'>" + (recovery && recovery.action === "revert" ? ("<button type='button' class='btn btn-outline-danger' data-footer-action='recover-revert' data-base-draft-version='" + esc(String(Number(recovery.baseDraftVersion || 0) || 0)) + "'>" + esc(recovery.label || "Revert Draft to Live") + "</button>") : "") + "<a class='btn btn-outline-secondary' href='/dashboard/platform.footer'>Back to Footer</a></div>" +
    "</div></div>";
  }

  var activeWorkspace = null;
  var activeEditorHost = null;
  var activeEditorSelector = "";
  var saveSequence = 0;
  var lastAppliedSaveSequence = 0;
  var draftMutationVersion = 0;
  var draftBaseVersion = 0;
  var autosaveTimer = null;
  var hasUnsavedChanges = false;
  var pendingAutosave = false;
  var modalResolver = null;

  function clearAutosaveTimer() {
    if (autosaveTimer) window.clearTimeout(autosaveTimer);
    autosaveTimer = null;
  }
  function syncBeforeUnloadGuard() {
    window.onbeforeunload = hasUnsavedChanges ? function() { return "You have unsaved footer draft changes."; } : null;
  }
  function queueAutosave() {
    clearAutosaveTimer();
    if (!hasUnsavedChanges) return;
    autosaveTimer = window.setTimeout(async function() {
      autosaveTimer = null;
      if (!hasUnsavedChanges || pendingAutosave) return;
      pendingAutosave = true;
      setStatus("Autosaving footer draft changes…", "alert-info");
      try {
        await saveDraft({ reason: "autosave" });
      } catch (error) {
        var autosaveError = describeWorkspaceError(error, "Autosave failed. Your edits are still in the form right now.", "Footer Autosave Failed");
        setStatus(autosaveError.message, "alert-danger", autosaveError.reasons);
      } finally {
        pendingAutosave = false;
      }
    }, 1200);
  }
  function openConfirmModal(options) {
    options = options || {};
    return new Promise(function(resolve) {
      modalResolver = resolve;
      var reasons = options.reasons instanceof Array ? options.reasons : [];
      var actions = options.confirmLabel ? ("<button type='button' class='btn btn-" + esc(options.confirmTone || "primary") + "' data-footer-modal-action='confirm'>" + esc(options.confirmLabel) + "</button>") : "";
      root.insertAdjacentHTML("beforeend", "<div class='position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3' style='background:rgba(0,0,0,.45);z-index:1080' data-footer-modal='true'><div class='card shadow-lg border-0' style='max-width:40rem;width:100%'><div class='card-body p-4'><div class='d-flex justify-content-between gap-3 align-items-start mb-3'><div><p class='text-uppercase text-muted small mb-1'>Confirm action</p><h2 class='h5 mb-0'>" + esc(options.title || "Confirm") + "</h2></div><button type='button' class='btn-close' aria-label='Close' data-footer-modal-action='cancel'></button></div><p class='mb-3'>" + esc(options.message || "") + "</p>" + (reasons.length ? guidanceListHtml(reasons, "small mb-3") : "") + "<div class='d-flex flex-wrap justify-content-end gap-2'><button type='button' class='btn btn-outline-secondary' data-footer-modal-action='cancel'>Cancel</button>" + actions + "</div></div></div></div>");
    });
  }
  function closeConfirmModal(confirmed) {
    var modal = root.querySelector("[data-footer-modal='true']");
    if (modal) modal.remove();
    if (modalResolver) modalResolver(confirmed === true);
    modalResolver = null;
  }
  async function mountSchemaEditor(workspace) {
    var host = root.querySelector("[data-footer-schema-editor='true']");
    if (!host || !workspace || workspace.readOnly === true || workspace.unsupported) { activeEditorHost = null; activeEditorSelector = ""; return; }
    host.innerHTML = "";
    var editorNode = await window.UATools.render({ n: "ua.fields.schema.editor", name: "platformFooterEditor", schema: workspace.schema || {}, groups: workspace.groups || [], data: workspace.editor || {}, continueText: "Continue", showSummaryStep: false, skipGroupedNestedSteps: true, disableDefaultWizardBehavior: true, showStepNavigation: true });
    if (typeof editorNode === "string") { host.innerHTML = editorNode; activeEditorHost = host.firstElementChild; } else { host.appendChild(editorNode); activeEditorHost = editorNode; }
    if (activeEditorHost) {
      if (!activeEditorHost.id) activeEditorHost.id = "platform-footer-editor-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
      activeEditorSelector = "#" + activeEditorHost.id;
    }
    if (typeof window.UATools.after === "function") window.UATools.after();
  }
  async function getEditorData() {
    var result = await window.UATools.save(activeEditorSelector || activeEditorHost, true);
    if (!result || result.success === false) throw result || new Error("Unable to save schema editor state.");
    var editorSave = result.platformFooterEditor || null;
    if (!editorSave || editorSave.success === false) throw editorSave || new Error("Schema editor did not return footer data.");
    return editorSave.data || {};
  }
  function getWorkspaceDraftMutation(workspace) { return Number(((((workspace || {}).editorState) || {}).draftMutation) || 0) || 0; }
  function getWorkspaceDraftBaseVersion(workspace) { return Number(((((workspace || {}).editorState) || {}).baseDraftVersion) || ((((workspace || {}).editorState) || {}).draftVersion) || 0) || 0; }
  function syncWorkspaceSummary(workspace) {
    var live = (workspace || {}).live || {};
    var draft = (workspace || {}).draft || {};
    var previewEl = root.querySelector("[data-footer-preview='true']");
    if (previewEl) previewEl.innerHTML = footerPreviewCardHtml(workspace || {});
    var livePublished = root.querySelector("[data-footer-live-published='true']"); if (livePublished) livePublished.textContent = live.published || "—";
    var liveModified = root.querySelector("[data-footer-live-modified='true']"); if (liveModified) liveModified.textContent = live.modified || "—";
    var draftPublished = root.querySelector("[data-footer-draft-published='true']"); if (draftPublished) draftPublished.textContent = draft.published || "—";
    var draftModified = root.querySelector("[data-footer-draft-modified='true']"); if (draftModified) draftModified.textContent = draft.modified || "—";
    var draftState = root.querySelector("[data-footer-draft-state='true']"); if (draftState) draftState.textContent = collaborationSummary(workspace);
  }
  function remountWorkspace(workspace) {
    activeWorkspace = workspace || activeWorkspace;
    draftMutationVersion = getWorkspaceDraftMutation(activeWorkspace);
    draftBaseVersion = getWorkspaceDraftBaseVersion(activeWorkspace);
    hasUnsavedChanges = false;
    syncBeforeUnloadGuard();
    clearAutosaveTimer();
    if (activeWorkspace && (activeWorkspace.readOnly === true || activeWorkspace.unsupported)) {
      var unsupported = activeWorkspace.unsupported || {};
      renderUnsupportedWorkspace({ title: unsupported.title, message: unsupported.description || unsupported.reason, reasons: formatReasonList([unsupported.reason].filter(Boolean)), recovery: unsupported.recovery || null });
      return Promise.resolve(activeWorkspace);
    }
    renderWorkspace(activeWorkspace);
    return mountSchemaEditor(activeWorkspace).then(function() { syncWorkspaceSummary(activeWorkspace); return activeWorkspace; });
  }
  async function loadWorkspace() { var response = await api.get("shared-footer"); await remountWorkspace((response || {}).data || {}); }
  function markDraftDirty() {
    draftMutationVersion += 1;
    hasUnsavedChanges = true;
    syncBeforeUnloadGuard();
    setStatus("Unsaved draft changes. Autosave will update draft JSON + draft HTML shortly; live stays unchanged until Publish.", "alert-warning");
    queueAutosave();
  }
  function isEditorMutationEvent(event) {
    if (!(activeEditorHost) || !(event)) return false;
    if (event.target && activeEditorHost.contains(event.target)) return true;
    if (event.type === "ua:schema-editor:mutated" && event.target === activeEditorHost) return true;
    return false;
  }
  async function saveDraft(options) {
    options = options || {};
    var editorData = options.editorData || await getEditorData();
    var clientMutation = options.clientMutation;
    if (!(clientMutation > 0)) clientMutation = draftMutationVersion || getWorkspaceDraftMutation(activeWorkspace) || 0;
    var currentSaveSequence = ++saveSequence;
    var saveResponse = await api.save("", { editor: editorData, clientMutation: clientMutation, baseDraftVersion: draftBaseVersion });
    var responseData = ((saveResponse || {}).data) || {};
    var nextWorkspace = responseData.workspace || activeWorkspace;
    if (currentSaveSequence < lastAppliedSaveSequence) return { workspace: nextWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false };
    if (draftMutationVersion > clientMutation) {
      setStatus("A newer footer edit happened while this save was in flight, so the older response was ignored and your newest unsaved edits were kept.", "alert-warning");
      hasUnsavedChanges = true; syncBeforeUnloadGuard(); queueAutosave();
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: true };
    }
    lastAppliedSaveSequence = currentSaveSequence;
    await remountWorkspace(nextWorkspace);
    if (responseData.staleIgnored === true) {
      setStatus("This draft was not saved because a newer stored draft already exists. The latest stored footer draft has been reloaded.", "alert-warning");
      return { workspace: activeWorkspace, staleIgnored: true, localChangesAhead: false };
    }
    hasUnsavedChanges = false; syncBeforeUnloadGuard();
    setStatus(options.reason === "autosave" ? "Draft autosaved. Preview and draft files now match the latest stored draft; live is still unchanged." : (options.reason === "publish-prepare" ? "Draft saved. Publish will now update live JSON + live HTML." : "Draft saved. Draft JSON + draft HTML were updated; live is still unchanged."), "alert-success");
    return { workspace: activeWorkspace, staleIgnored: false, localChangesAhead: false };
  }

  try {
    await loadWorkspace();
    root.addEventListener("input", function(event) { if (isEditorMutationEvent(event)) markDraftDirty(); });
    root.addEventListener("change", function(event) { if (isEditorMutationEvent(event)) markDraftDirty(); });
    root.addEventListener("ua:schema-editor:mutated", function(event) { if (isEditorMutationEvent(event)) markDraftDirty(); });
    root.addEventListener("click", async function(event) {
      var modalAction = event.target.closest("[data-footer-modal-action]");
      if (modalAction) {
        event.preventDefault();
        closeConfirmModal(modalAction.getAttribute("data-footer-modal-action") === "confirm");
        return;
      }
      var btn = event.target.closest("[data-footer-action]");
      if (!btn) return;
      event.preventDefault();
      var action = btn.getAttribute("data-footer-action");
      try {
        if (action === "save") { clearAutosaveTimer(); setStatus("Saving draft footer files…", "alert-info"); await saveDraft(); return; }
        if (action === "publish") {
          var publishConfirmed = await openConfirmModal({ title: "Publish this shared footer to live?", message: "Publishing updates live footer JSON and live footer HTML for everyone. Your latest draft is saved first, then promoted to live.", reasons: ["Live stays unchanged until Publish finishes.", "If live changed after this draft began, you will get a second conflict confirmation before replacement happens."], confirmLabel: "Publish to Live", confirmTone: "success" });
          if (!publishConfirmed) { setStatus("Publish cancelled. Draft remains unchanged.", "alert-secondary"); return; }
          clearAutosaveTimer();
          setStatus("Saving the latest draft before publish…", "alert-info");
          var savedDraft = await saveDraft({ reason: "publish-prepare" });
          if (savedDraft.localChangesAhead === true) { setStatus("Publish stopped because newer unsaved edits landed during save. Let autosave finish or save again before publishing.", "alert-warning"); return; }
          if (savedDraft.staleIgnored === true) { setStatus("Publish stopped because this editor was behind the stored draft. Review the reloaded draft before publishing.", "alert-warning"); return; }
          setStatus("Publishing shared footer to live…", "alert-info");
          var publishResponse;
          try {
            publishResponse = await api.action("publish", { baseDraftVersion: draftBaseVersion });
          } catch (publishError) {
            var publishConfirmation = getPublishConfirmationDetails(publishError);
            if (!(publishConfirmation)) throw publishError;
            var overrideConfirmed = await openConfirmModal({ title: publishConfirmation.title, message: "Someone else changed live after this draft started. Publishing now will intentionally replace that newer live footer with this draft.", reasons: ["Draft modified: " + (publishConfirmation.collaboration.draftModified || "—"), "Live modified: " + (publishConfirmation.collaboration.liveModified || "—"), "Draft baseline live version: " + (publishConfirmation.collaboration.sourceLiveVersion || "—"), "Current live version: " + (publishConfirmation.collaboration.liveVersion || "—")], confirmLabel: "Replace Live Footer", confirmTone: "danger" });
            if (!overrideConfirmed) { setStatus("Publish cancelled. A newer live footer still exists; your draft was left untouched.", "alert-warning"); return; }
            setStatus("Publishing with explicit live-replacement confirmation…", "alert-warning");
            publishResponse = await api.action("publish", { baseDraftVersion: draftBaseVersion, forcePublish: true });
          }
          var publishData = ((publishResponse || {}).data) || {};
          await remountWorkspace(publishData.workspace || activeWorkspace);
          if (publishData.staleIgnored === true) { setStatus("Publish stopped because this editor had stale draft state. Review the reloaded draft before publishing.", "alert-warning"); return; }
          setStatus("Shared footer published. Draft and live JSON/HTML now match the newly published footer.", "alert-success");
          return;
        }
        if (action === "revert") {
          var confirmed = await openConfirmModal({ title: "Revert draft back to live?", message: "This discards the current draft files and rebuilds them from the published live footer. Live footer JSON and live footer HTML stay unchanged.", reasons: ["Copy any draft-only content before you continue.", "After revert, the preview will match live again."], confirmLabel: "Revert Draft", confirmTone: "danger" });
          if (!confirmed) { setStatus("Revert cancelled. Draft remains unchanged.", "alert-secondary"); return; }
          clearAutosaveTimer();
          setStatus("Rebuilding draft from live footer…", "alert-info");
          var revertResponse = await api.action("revert", { baseDraftVersion: draftBaseVersion });
          var revertData = ((revertResponse || {}).data) || {};
          await remountWorkspace(revertData.workspace || activeWorkspace);
          if (revertData.staleIgnored === true) { setStatus("Revert was not applied because a newer stored draft already exists. The latest draft has been reloaded.", "alert-warning"); return; }
          setStatus("Draft reverted. Draft JSON + draft HTML now match the current live footer again.", "alert-success");
          return;
        }
        if (action === "recover-revert") {
          var recoverConfirmed = await openConfirmModal({ title: "Recover by discarding the unsupported draft?", message: "Recovery deletes only the unsupported draft files and rebuilds the draft from the current live footer so editing can resume here.", reasons: ["Live footer stays untouched.", "Copy anything you need from the unsupported draft files before continuing."], confirmLabel: "Recover from Live", confirmTone: "danger" });
          if (!recoverConfirmed) return;
          setStatus("Recovering draft from live footer…", "alert-info");
          var recoverBaseDraftVersion = Number(btn.getAttribute("data-base-draft-version") || 0) || 0;
          var recoverResponse = await api.action("revert", { baseDraftVersion: recoverBaseDraftVersion });
          var recoverData = ((recoverResponse || {}).data) || {};
          await remountWorkspace(recoverData.workspace || activeWorkspace);
          if (recoverData.staleIgnored === true) { setStatus("Recovery lost the freshness race, so the latest stored footer workspace was reloaded instead.", "alert-warning"); return; }
          setStatus("Recovery complete. The unsupported draft was replaced with a fresh draft rebuilt from live.", "alert-success");
          return;
        }
      } catch (error) {
        console.error(error);
        var actionError = describeWorkspaceError(error, "Footer workspace action failed.", "Footer Workspace Action Failed");
        setStatus(actionError.message, "alert-danger", actionError.reasons);
      }
    });
  } catch (error) {
    console.error(error);
    var details = describeWorkspaceError(error, "Unable to load footer workspace.", "Unable to Load Footer Workspace");
    renderUnsupportedWorkspace(details);
  }
}

async function platformNavigationWorkspaceInit(context) {
  var root = document.querySelector("[data-platform-navigation-workspace='true']");
  if (!root) return;
  if (root.getAttribute("data-navigation-workspace-init") === "true") return;

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI;
  if (!dashboardApi) return;

  try {
    var pageNamespace = (root.getAttribute("data-page-namespace") || "").trim();
  var pageUrl = (root.getAttribute("data-page-url") || "").trim();
  var workspacePageUrl = (root.getAttribute("data-workspace-page-url") || "").trim();
  var routeContext = {
    page: {
      namespace: pageNamespace,
      routes: {
        api: (root.getAttribute("data-api-url") || "").trim(),
        page: pageUrl
      }
    }
  };
  var workspaceContract = navigationRoutes.getWorkspaceContract(routeContext, root.getAttribute("data-navigation-id") || "main-navigation");
  if (workspacePageUrl) workspaceContract.workspace.page = workspacePageUrl;
  var api = dashboardApi.withBase(workspaceContract.workspace.api);

  root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'>Loading navigation workspace...</div></div>";

  function esc(value) {
    return escapeHtml((value || "").toString());
  }

  function normalizeReason(reason) {
    if (reason === null || reason === undefined) return "";
    if (typeof reason === "string") return reason.trim();
    if (typeof reason === "number" || typeof reason === "boolean") return String(reason);
    if (reason && typeof reason === "object") {
      var label = reason.title || reason.label || reason.field || reason.path || reason.name || "";
      var detail = reason.description || reason.message || reason.reason || reason.error || reason.expected || reason.value || "";
      if (label && detail) return (label + ": " + detail).trim();
      if (detail) return detail.toString().trim();
      if (label) return label.toString().trim();
      try {
        return JSON.stringify(reason);
      } catch (jsonError) {
        return "[unreadable reason]";
      }
    }
    return "";
  }

  function formatReasonList(reasons) {
    return (reasons instanceof Array ? reasons : []).map(normalizeReason).filter(function(reason) {
      return !!reason;
    });
  }

  function setStatus(message, tone, reasons) {
    var el = root.querySelector("[data-navigation-workspace-status='true']");
    if (!el) return;
    el.className = "small mb-0 " + (tone || "text-muted");
    var html = "<div>" + esc(message || "") + "</div>";
    var normalizedReasons = formatReasonList(reasons);
    if (normalizedReasons.length) {
      html += "<ul class='mb-0 mt-2 ps-3'>" + normalizedReasons.map(function(reason) {
        return "<li>" + esc(reason) + "</li>";
      }).join("") + "</ul>";
    }
    el.innerHTML = html;
  }

  function describeWorkspaceError(error, fallbackMessage, fallbackTitle) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var title = (error && (error.title || data.title)) || fallbackTitle || "Navigation Workspace Error";
    var message = (error && (error.description || data.description || error.message || data.message)) || fallbackMessage || "An error occurred while working with navigation.";
    var reasons = [];
    if (error && error.errors instanceof Array) reasons = reasons.concat(error.errors);
    if (data && data.errors instanceof Array) reasons = reasons.concat(data.errors);
    if (data && data.originalError) {
      var original = data.originalError;
      if (original.errors instanceof Array) reasons = reasons.concat(original.errors);
      if (original.message && reasons.length === 0) reasons.push(original.message);
    }
    reasons = formatReasonList(reasons);
    return { title: title.toString(), message: message.toString(), reasons: reasons };
  }

  function getPublishConfirmationDetails(error) {
    var data = error && typeof error === "object" ? (error.data || {}) : {};
    var namespace = ((error && (error.namespace || "")) || data.namespace || "").toString();
    if (namespace !== "platform.navigation.publishConfirmationRequired") return null;
    return {
      title: ((error && error.title) || data.title || "Publish confirmation required").toString(),
      message: ((error && error.description) || data.description || "Live changed after this draft started. Confirm if you want to replace the newer live version with this draft.").toString(),
      collaboration: data.collaboration || error.collaboration || {}
    };
  }

  function buildPublishOverridePrompt(details) {
    var collaboration = details && details.collaboration ? details.collaboration : {};
    var lines = [
      (details && details.title) || "Navigation publish confirmation required",
      "",
      (details && details.message) || "Live navigation changed after this draft started.",
      "",
      "Draft modified: " + (collaboration.draftModified || "—"),
      "Live modified: " + (collaboration.liveModified || "—"),
      "Draft baseline live version: " + (collaboration.sourceLiveVersion || "—"),
      "Current live version: " + (collaboration.liveVersion || "—")
    ];
    if (collaboration.summary) lines.push("", collaboration.summary);
    lines.push("", "Publish anyway and intentionally replace the newer live navigation with this draft?");
    return lines.join("\n");
  }

  function utilitySummary(utilityItem) {
    if (!(utilityItem) || utilityItem.enabled !== true) return "Disabled";
    return (utilityItem.title || utilityItem.quickName || "Utility item") + " → " + (utilityItem.src || "");
  }

  function navPreviewHtml(editor) {
    var doc = editor || {};
    var items = doc.items instanceof Array ? doc.items : [];
    return "<div class='border rounded p-3 bg-body-tertiary'><div class='d-flex flex-wrap align-items-center gap-2 mb-2'>" +
      items.map(function(item) {
        return "<span class='badge text-bg-light border'>" + esc(item.quickName || item.title || item.src || "Link") + "</span>";
      }).join("") +
      (doc.utilityItem && doc.utilityItem.enabled ? ("<span class='ms-auto badge text-bg-dark'>" + esc(doc.utilityItem.icon ? (doc.utilityItem.title + " • " + doc.utilityItem.icon) : doc.utilityItem.title) + "</span>") : "") +
      "</div><div class='small text-muted'>Type: " + esc(doc.type || "minimal") + " • Sticky: " + esc(doc.sticky !== false ? "On" : "Off") + " • Utility: " + esc(utilitySummary(doc.utilityItem || {})) + "</div></div>";
  }

  function guidanceListHtml(items) {
    var list = items instanceof Array ? items.filter(Boolean) : [];
    if (!list.length) return "";
    return "<ul class='small mb-0 ps-3'>" + list.map(function(item) {
      return "<li>" + esc(item) + "</li>";
    }).join("") + "</ul>";
  }

  function renderWorkspace(workspace) {
    var live = workspace.live || {};
    var draft = workspace.draft || {};
    var proof = workspace.proof || {};
    var constraints = workspace.constraints || {};
    var editor = workspace.editor || {};
    root.innerHTML = "" +
      "<div class='container-fluid px-0'><div class='row g-4'>" +
        "<div class='col-12 col-xl-5'><div class='card border-0 shadow-sm h-100'><div class='card-body p-4'>" +
          "<div class='mb-3'><p class='text-uppercase text-muted small mb-1'>Shared Navigation Workspace</p><h1 class='h4 mb-1'>Main Navigation</h1><p class='text-muted mb-0'>Edit the current safe navigation slice without widening into unsupported navbar/menu shapes.</p></div>" +
          "<div class='small text-muted border rounded p-3 mb-4 bg-body-tertiary'><div><strong>Editor route:</strong> <code>" + esc(proof.route || workspaceContract.workspace.page) + "</code></div><div><strong>Live source:</strong> <code>" + esc(proof.livePath || "@!/app/pages/parts/navigation.json") + "</code></div><div><strong>Draft source:</strong> <code>" + esc(proof.draftPath || "@!/app/drafts/pages/parts/navigation.json") + "</code></div><div><strong>Scope:</strong> <span data-navigation-scope-summary='true'>" + esc(constraints.summary || "Shared navigation subset only.") + "</span></div></div>" +
          "<div class='row g-3 mb-4'><div class='col-12 col-md-6'><div class='border rounded p-3 h-100'><div class='small text-uppercase text-muted mb-1'>Live</div><div class='fw-semibold'>" + esc(live.title || "Main Navigation") + "</div><div class='small text-muted mt-2'>Published: <span data-navigation-live-published='true'>" + esc(live.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-navigation-live-modified='true'>" + esc(live.modified || "—") + "</span></div></div></div><div class='col-12 col-md-6'><div class='border rounded p-3 h-100 bg-warning-subtle'><div class='small text-uppercase text-muted mb-1'>Draft</div><div class='fw-semibold'>" + esc(draft.title || "Main Navigation") + "</div><div class='small text-muted mt-2'>Published: <span data-navigation-draft-published='true'>" + esc(draft.published || "—") + "</span></div><div class='small text-muted'>Modified: <span data-navigation-draft-modified='true'>" + esc(draft.modified || "—") + "</span></div></div></div></div>" +
          "<div class='alert alert-secondary mb-4'><div class='fw-semibold mb-2'>What this editor supports</div>" + guidanceListHtml(constraints.supports || []) + "</div>" +
          "<div data-navigation-schema-editor='true' class='mb-3'></div>" +
          "<div class='d-flex flex-wrap gap-2 align-items-center'><button type='button' class='btn btn-outline-primary' data-navigation-action='save'>Save Draft</button><button type='button' class='btn btn-success' data-navigation-action='publish'>Publish Draft to Live</button><button type='button' class='btn btn-outline-danger' data-navigation-action='revert'>Revert Draft to Live</button><a class='btn btn-outline-secondary' href='" + esc(workspaceContract.routes.page) + "'>Back to Navigation</a></div>" +
          "<div class='small text-muted mt-3' data-navigation-workspace-status='true'><div>Draft workspace ready.</div></div>" +
        "</div></div></div>" +
        "<div class='col-12 col-xl-7'><div class='card border-0 shadow-sm h-100'><div class='card-body p-4'><p class='text-uppercase text-muted small mb-1'>Structured Preview</p><h2 class='h5 mb-3'>Current draft summary</h2><div data-navigation-preview='true'>" + navPreviewHtml(editor) + "</div><div class='alert alert-warning mt-3 mb-0'><div class='fw-semibold mb-2'>Recovery guidance for unsupported shapes</div>" + guidanceListHtml(constraints.recovery || ["Current slice supports direct top-level links and one utility item.", "Nested menus, pinned groups, and broader custom navbar shapes intentionally remain outside this editor for now."]) + "</div></div></div></div>" +
      "</div></div>";
  }

  function renderUnsupportedWorkspace(details) {
    details = details || {};
    var reasons = details.reasons instanceof Array ? details.reasons : [];
    var recovery = details.recovery || null;
    var canRetryLoad = details.retryableLoad === true;
    var reasonsHtml = reasons.length ? ("<ul class='small mb-0 mt-3 ps-3'>" + reasons.map(function(reason) { return "<li>" + esc(reason) + "</li>"; }).join("") + "</ul>") : "";
    var supportCardTitle = canRetryLoad ? "What this load failure means" : "This editor currently supports";
    var supportCardItems = canRetryLoad
      ? "<li>This looks like a workspace load failure, not proof that this navigation is unsupported.</li><li>You can retry loading this workspace without leaving the page.</li><li>If retry keeps failing, use the details below and inspect the live/draft files or API response.</li>"
      : "<li>Navbar presentation settings</li><li>Direct top-level links in the main items list</li><li>One trailing utility item</li>";
    var nextStepsItems = canRetryLoad
      ? "<li>Use <strong>Retry Loading Workspace</strong> for transient first-load failures.</li><li>If retry keeps failing, review the live navigation source at <code>@!/app/pages/parts/navigation.json</code> and the current draft at <code>@!/app/drafts/pages/parts/navigation.json</code>.</li><li>Return to source/developer flows only if the repeated failure reveals unsupported shapes or invalid stored data.</li>"
      : "<li>Review the live navigation source at <code>@!/app/pages/parts/navigation.json</code>.</li><li>If it uses nested menus, pinned groups, announcements, or custom first/last structures, keep editing in source/developer flows for now.</li><li>Return to this workspace once the shared navbar is back within the supported subset.</li>";
    root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4 p-lg-5'>" +
      "<div class='alert alert-warning mb-4'>" +
        "<h1 class='h5 mb-2'>" + esc(details.title) + "</h1>" +
        "<p class='mb-0'>" + esc(details.message) + "</p>" +
        reasonsHtml +
      "</div>" +
      "<div class='row g-4'>" +
        "<div class='col-12 col-lg-6'><div class='border rounded p-3 h-100 bg-body-tertiary'><h2 class='h6 mb-2'>" + supportCardTitle + "</h2><ul class='small mb-0 ps-3'>" + supportCardItems + "</ul></div></div>" +
        "<div class='col-12 col-lg-6'><div class='border rounded p-3 h-100'><h2 class='h6 mb-2'>What to do next</h2><ul class='small mb-0 ps-3'>" + nextStepsItems + "</ul></div></div>" +
      "</div>" +
      "<div class='d-flex flex-wrap gap-2 align-items-center mt-4'>" +
        (canRetryLoad ? "<button type='button' class='btn btn-primary' data-navigation-action='retry-load'>Retry Loading Workspace</button>" : "") +
        (recovery && recovery.action === "revert" ? ("<button type='button' class='btn btn-outline-danger' data-navigation-action='recover-revert' data-base-draft-version='" + esc(String(Number(recovery.baseDraftVersion || 0) || 0)) + "'>" + esc(recovery.label || "Revert Draft to Live") + "</button>") : "") +
        "<a class='btn btn-outline-secondary' href='" + esc(workspaceContract.routes.page) + "'>Back to Navigation</a></div>" +
    "</div></div>";
  }

  var activeWorkspace = null;
  var activeEditorHost = null;
  var activeEditorSelector = "";
  var saveSequence = 0;
  var lastAppliedSaveSequence = 0;
  var draftMutationVersion = 0;
  var draftBaseVersion = 0;

  async function mountSchemaEditor(workspace) {
    var host = root.querySelector("[data-navigation-schema-editor='true']");
    if (!host || !workspace || workspace.readOnly === true || workspace.unsupported) {
      activeEditorHost = null;
      activeEditorSelector = "";
      return;
    }
    host.innerHTML = "";
    var editorNode = await window.UATools.render({
      n: "ua.fields.schema.editor",
      name: "platformNavigationEditor",
      schema: workspace.schema || {},
      groups: workspace.groups || [],
      data: workspace.editor || {},
      continueText: "Continue",
      showSummaryStep: false,
      skipGroupedNestedSteps: true,
      disableDefaultWizardBehavior: true,
      showStepNavigation: true
    });
    if (typeof editorNode === "string") {
      host.innerHTML = editorNode;
      activeEditorHost = host.firstElementChild;
    } else {
      host.appendChild(editorNode);
      activeEditorHost = editorNode;
    }
    if (activeEditorHost) {
      if (!activeEditorHost.id) activeEditorHost.id = "platform-navigation-editor-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
      activeEditorSelector = "#" + activeEditorHost.id;
    }
    if (typeof window.UATools.after === "function") window.UATools.after();
  }

  async function getEditorData() {
    var result = await window.UATools.save(activeEditorSelector || activeEditorHost, true);
    if (!result || result.success === false) throw result || new Error("Unable to save schema editor state.");
    var editorSave = result.platformNavigationEditor || null;
    if (!editorSave || editorSave.success === false) throw editorSave || new Error("Schema editor did not return navigation data.");
    return editorSave.data || {};
  }

  function getWorkspaceDraftMutation(workspace) {
    return Number(((((workspace || {}).editorState) || {}).draftMutation) || 0) || 0;
  }

  function getWorkspaceDraftBaseVersion(workspace) {
    return Number(((((workspace || {}).editorState) || {}).baseDraftVersion) || ((((workspace || {}).editorState) || {}).draftVersion) || 0) || 0;
  }

  function syncWorkspaceSummary(workspace) {
    var live = (workspace || {}).live || {};
    var draft = (workspace || {}).draft || {};
    var constraints = (workspace || {}).constraints || {};
    var editor = (workspace || {}).editor || {};
    var livePublished = root.querySelector("[data-navigation-live-published='true']");
    if (livePublished) livePublished.textContent = live.published || "—";
    var liveModified = root.querySelector("[data-navigation-live-modified='true']");
    if (liveModified) liveModified.textContent = live.modified || "—";
    var draftPublished = root.querySelector("[data-navigation-draft-published='true']");
    if (draftPublished) draftPublished.textContent = draft.published || "—";
    var draftModified = root.querySelector("[data-navigation-draft-modified='true']");
    if (draftModified) draftModified.textContent = draft.modified || "—";
    var scopeEl = root.querySelector("[data-navigation-scope-summary='true']");
    if (scopeEl) scopeEl.textContent = constraints.summary || "Shared navigation subset only.";
    var previewEl = root.querySelector("[data-navigation-preview='true']");
    if (previewEl) previewEl.innerHTML = navPreviewHtml(editor);
  }

  function remountWorkspace(workspace) {
    activeWorkspace = workspace || activeWorkspace;
    draftMutationVersion = getWorkspaceDraftMutation(activeWorkspace);
    draftBaseVersion = getWorkspaceDraftBaseVersion(activeWorkspace);
    if (activeWorkspace && (activeWorkspace.readOnly === true || activeWorkspace.unsupported)) {
      var unsupported = activeWorkspace.unsupported || {};
      renderUnsupportedWorkspace({
        title: unsupported.title || "This Navigation Can’t Be Edited Here Yet",
        message: unsupported.description || unsupported.reason || "This workspace is read-only right now.",
        reasons: formatReasonList([unsupported.reason].filter(Boolean)),
        recovery: unsupported.recovery || null
      });
      return Promise.resolve(activeWorkspace);
    }
    renderWorkspace(activeWorkspace);
    return mountSchemaEditor(activeWorkspace).then(function() {
      syncWorkspaceSummary(activeWorkspace);
      return activeWorkspace;
    });
  }

  async function loadWorkspace() {
    var response = await api.get("main-navigation");
    await remountWorkspace((response || {}).data || {});
  }

  function markDraftDirty() {
    draftMutationVersion += 1;
    setStatus("Editing draft… not yet saved.", "text-muted");
  }

  function isEditorMutationEvent(event) {
    if (!(activeEditorHost) || !(event)) return false;
    if (event.target && activeEditorHost.contains(event.target)) return true;
    if (event.type === "ua:schema-editor:mutated" && event.target === activeEditorHost) return true;
    return false;
  }

  async function saveDraft(options) {
    options = options || {};
    var editorData = options.editorData || await getEditorData();
    var clientMutation = options.clientMutation;
    if (!(clientMutation > 0)) clientMutation = draftMutationVersion || getWorkspaceDraftMutation(activeWorkspace) || 0;
    var currentSaveSequence = ++saveSequence;
    var saveResponse = await api.save("", { editor: editorData, clientMutation: clientMutation, baseDraftVersion: draftBaseVersion });
    var responseData = ((saveResponse || {}).data) || {};
    var nextWorkspace = responseData.workspace || activeWorkspace;
    if (currentSaveSequence < lastAppliedSaveSequence) {
      return { workspace: nextWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: false };
    }
    if (draftMutationVersion > clientMutation) {
      setStatus("Save finished for an older editor state, so the response was ignored and newer unsaved edits were kept in place.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: responseData.staleIgnored === true, localChangesAhead: true };
    }
    lastAppliedSaveSequence = currentSaveSequence;
    await remountWorkspace(nextWorkspace);
    if (responseData.staleIgnored === true) {
      setStatus("Draft was not saved because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
      return { workspace: activeWorkspace, staleIgnored: true, localChangesAhead: false };
    }
    setStatus(options.reason === "publish-prepare" ? "Draft saved and reloaded from stored state. Ready to publish." : "Draft saved and reloaded from stored state.", "text-success");
    return { workspace: activeWorkspace, staleIgnored: false, localChangesAhead: false };
  }

  if (!(root.__platformNavigationWorkspaceEventsBound)) {
    root.__platformNavigationWorkspaceEventsBound = true;

    root.addEventListener("input", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("change", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("ua:schema-editor:mutated", function(event) {
      if (!(isEditorMutationEvent(event))) return;
      markDraftDirty();
    });

    root.addEventListener("click", async function(event) {
      var btn = event.target.closest("[data-navigation-action]");
      if (!btn) return;
      event.preventDefault();
      var action = btn.getAttribute("data-navigation-action");
      try {
        if (action === "retry-load") {
          root.innerHTML = "<div class='card border-0 shadow-sm'><div class='card-body p-4'>Retrying navigation workspace load…</div></div>";
          await loadWorkspace();
          root.setAttribute("data-navigation-workspace-init", "true");
          return;
        }
        if (action === "save") {
          setStatus("Saving draft…", "text-muted");
          await saveDraft();
          return;
        }
        if (action === "publish") {
          var publishConfirmed = window.confirm("Publish this draft to the live shared navigation now? This updates the navigation other people see across the app/site.");
          if (!publishConfirmed) {
            setStatus("Publish cancelled.", "text-muted");
            return;
          }
          setStatus("Validating draft before publish…", "text-muted");
          var savedDraft = await saveDraft({ reason: "publish-prepare" });
          if (savedDraft.localChangesAhead === true) {
            setStatus("Publish stopped because newer unsaved edits were made while the save was in flight. Save again after those edits settle before publishing.", "text-warning");
            return;
          }
          if (savedDraft.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale changes. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          setStatus("Publishing draft to live shared navigation…", "text-muted");
          var publishResponse;
          try {
            publishResponse = await api.action("publish", { baseDraftVersion: draftBaseVersion });
          } catch (publishError) {
            var publishConfirmation = getPublishConfirmationDetails(publishError);
            if (!(publishConfirmation)) throw publishError;
            var publishOverrideConfirmed = window.confirm(buildPublishOverridePrompt(publishConfirmation));
            if (!(publishOverrideConfirmed)) {
              setStatus("Publish cancelled. Live navigation changed after this draft started, so the draft was not forced over the newer live navigation.", "text-warning");
              return;
            }
            setStatus("Publishing draft with explicit stale-draft override…", "text-warning");
            publishResponse = await api.action("publish", { baseDraftVersion: draftBaseVersion, forcePublish: true });
          }
          var publishData = ((publishResponse || {}).data) || {};
          await remountWorkspace((publishData.workspace) || activeWorkspace);
          if (publishData.staleIgnored === true) {
            setStatus("Publish stopped because this editor had stale draft state. Review the reloaded stored draft before publishing.", "text-warning");
            return;
          }
          setStatus("Draft published to live shared navigation and reloaded from stored state.", "text-success");
          return;
        }
        if (action === "revert") {
          var confirmed = window.confirm("Revert this navigation draft back to the published live navigation?");
          if (!confirmed) return;
          setStatus("Reverting draft…", "text-muted");
          var revertResponse = await api.action("revert", { baseDraftVersion: draftBaseVersion });
          var revertData = ((revertResponse || {}).data) || {};
          await remountWorkspace(revertData.workspace || activeWorkspace);
          if (revertData.staleIgnored === true) {
            setStatus("Revert was not applied because a newer stored draft already exists. Reloaded the latest stored draft.", "text-warning");
            return;
          }
          setStatus("Draft reverted to live.", "text-success");
          return;
        }
        if (action === "recover-revert") {
          var recoverConfirmed = window.confirm("Revert this unsupported navigation draft back to the published live navigation? This discards the unsupported draft so editing can resume from live.");
          if (!recoverConfirmed) return;
          setStatus("Reverting draft to the published live navigation…", "text-muted");
          var recoverBaseDraftVersion = Number(btn.getAttribute("data-base-draft-version") || 0) || 0;
          var recoverResponse = await api.action("revert", { baseDraftVersion: recoverBaseDraftVersion });
          var recoverData = ((recoverResponse || {}).data) || {};
          await remountWorkspace(recoverData.workspace || activeWorkspace);
          if (recoverData.staleIgnored === true) {
            setStatus("Recovery lost the freshness race, so the latest stored navigation workspace was reloaded instead.", "text-warning");
            return;
          }
          setStatus("Unsupported draft reverted to live. Editing can continue from the supported live navigation.", "text-success");
          return;
        }
      } catch (error) {
        console.error(error);
        var actionError = describeWorkspaceError(error, "Navigation workspace action failed.", "Navigation Workspace Action Failed");
        setStatus(actionError.message, "text-danger", actionError.reasons);
      }
    });
  }

  try {
    await loadWorkspace();
    root.setAttribute("data-navigation-workspace-init", "true");
  } catch (error) {
    root.removeAttribute("data-navigation-workspace-init");
    console.error(error);
    var details = describeWorkspaceError(error, "Unable to load navigation workspace.", "Unable to Load Navigation Workspace");
    details.retryableLoad = true;
    renderUnsupportedWorkspace(details);
  }
  } catch (setupError) {
    root.removeAttribute("data-navigation-workspace-init");
    throw setupError;
  }
}

async function renderRows(host, rows, pageNamespace, viewMode, pageUrl, apiUrl) {
  if (!host) return;
  var slug    = pageNamespace.replace(/\./g, "-");
  var baseUrl = pageUrl || ("/dashboard/" + slug);

  if (viewMode === "card") {
    await renderCardView(host, rows, baseUrl, pageNamespace, apiUrl);
    return;
  }

  // Default: list view
  var html = "<div class='ua-dashboard-list-items'>";
  for (var i = 0; i < rows.length; i++) {
    html += renderListItemHtml(rows[i], baseUrl, pageNamespace, apiUrl);
  }
  html += "</div>";
  host.innerHTML = html;
}

function renderListItemHtml(row, baseUrl, pageNamespace, apiUrl) {
  var id = (row.id || row.namespace || "").toString();
  var customHref = (row.href || "").toString().trim();
  var isFolderRow = row.isFolder === true;
  var folderPath = (row.folderPath || "").toString();
  var allowEdit = row.allowEdit !== false;
  var allowDelete = row.allowDelete !== false;
  var overline = escapeHtml((row.overline || "").toString());
  var titleText = (row.title || row.name || row.email || id).toString();
  var title = escapeHtml(titleText);
  var subtitleText = (row.subtitle || row.email || row.namespace || "").toString();
  var descriptionText = (row.description || "").toString();
  var subtitle = escapeHtml(subtitleText);
  var description = escapeHtml(descriptionText);
  var showDescription = descriptionText && descriptionText !== subtitleText;
  var badge = row.badge || "";
  var badgeClass = row.badgeClass || (row.enabled === true ? "bg-success" : row.enabled === false ? "bg-secondary" : "");
  var icon = row.icon || "";
  var iconSize = (row.iconSize || "").toString().trim().toLowerCase();
  var iconBoxSize = iconSize === "lg" ? "3.25rem" : "2.75rem";
  var iconFontSize = iconSize === "lg" ? "1.5rem" : "1.2rem";

  if (!badge && typeof row.enabled === "boolean") {
    badge = row.enabled ? "Enabled" : "Disabled";
    badgeClass = row.enabled ? "bg-success" : "bg-secondary";
  }

  var iconHtml = "";
  var thumbUri = (row.thumbnail || row.thumb || row.preview || row.previewUri || row.image || "").toString().trim();
  if (thumbUri) {
    iconHtml = "<div class='ua-dashboard-item-icon ua-dashboard-item-thumb'>" +
      "<img src='" + escapeHtml(thumbUri) + "' alt='' loading='lazy' style='width:" + iconBoxSize + ";height:" + iconBoxSize + ";object-fit:cover;'/>" +
      "</div>";
  } else
  if (icon) {
    var iconClass = icon.indexOf("bi-") === 0 ? ("bi " + icon) : ("bi bi-" + icon);
    iconHtml = "<div class='ua-dashboard-item-icon' style='width:" + iconBoxSize + ";height:" + iconBoxSize + ";font-size:" + iconFontSize + ";'><i class='" + iconClass + "'></i></div>";
  }

  var securityIconName = (row.securityIcon || "").toString().trim();
  var securityIconHtml = "";
  if (securityIconName) {
    var securityIconClass = securityIconName.indexOf("bi-") === 0 ? ("bi " + securityIconName) : ("bi bi-" + securityIconName);
    var securityTitle = row.securityLocked ? "Locked / Secure" : "Public";
    securityIconHtml = "<span class='text-muted me-2' title='" + escapeHtml(securityTitle) + "'><i class='" + securityIconClass + "'></i></span>";
  }

  var badgeTitle = escapeHtml((row.badgeTitle || "").toString());
  var badgeHtml = badge ? ("<span class='badge " + escapeHtml(badgeClass) + "'" + (badgeTitle ? (" title='" + badgeTitle + "'") : "") + ">" + escapeHtml(badge) + "</span>") : "";
  var sideColorClass = (row.sideColorClass || "").toString().trim();
  var railClass = normalizeRailClass(sideColorClass);
  var rowRailClass = railClass ? (" rail-start " + railClass) : "";

  var metaHtml = "";
  if (row.meta) {
    var metaLinkHtml = "";
    if (row.metaLink) {
      metaLinkHtml = " <a href='" + escapeHtml((row.metaLink || "").toString()) + "' target='_blank' rel='noopener noreferrer' title='Open file'>" +
        "<i class='bi bi-link-45deg'></i></a>";
    }
    metaHtml = "<div class='ua-dashboard-item-meta small text-muted'>" + escapeHtml(row.meta.toString()) + metaLinkHtml + "</div>";
  }

  var editHref = customHref || (baseUrl.replace(/\/$/, "") + "/" + encodeURIComponent(id));
  var openIcon = (row.openIcon || "").toString().trim();
  var openIconClass = openIcon
    ? (openIcon.indexOf("bi-") === 0 ? ("bi " + openIcon) : openIcon)
    : (customHref ? "bi bi-arrow-right" : "bi bi-pencil");

  var actionHtml = "";
  var actionParts = [];
  if (isFolderRow) {
    actionParts.push("<button type='button' class='btn btn-sm btn-outline-primary' title='Rename folder'" +
      " data-file-folder-row-rename='true'" +
      " data-folder-path='" + escapeHtml(folderPath) + "'>" +
      "<i class='bi bi-pencil'></i></button>");
    actionParts.push("<button type='button' class='btn btn-sm btn-outline-danger' title='Recycle folder'" +
      " data-file-folder-row-remove='true'" +
      " data-folder-path='" + escapeHtml(folderPath) + "'>" +
      "<i class='bi bi-x-lg'></i></button>");
  } else if (allowEdit || customHref) {
    actionParts.push("<a href='" + editHref + "' class='btn btn-sm btn-outline-primary' title='" + (customHref ? "Open" : "Edit") + "'><i class='" + escapeHtml(openIconClass) + "'></i></a>");
  }
  if (!isFolderRow && allowDelete) {
    actionParts.push("<button type='button' class='btn btn-sm btn-outline-danger' title='Delete'" +
      " data-dashboard-delete='true'" +
      " data-delete-id='" + escapeHtml(id) + "'" +
      " data-delete-label='" + escapeHtml(titleText) + "'" +
      " data-page-namespace='" + escapeHtml(pageNamespace) + "'" +
      " data-api-url='" + escapeHtml(apiUrl || "") + "'>" +
      "<i class='bi bi-trash3'></i></button>");
  }
  var rowActions = row.actionButtons instanceof Array ? row.actionButtons : [];
  for (var rp = 0; rp < rowActions.length; rp++) {
    var rowAction = rowActions[rp] || {};
    var actionName = (rowAction.action || "").toString();
    var actionLabel = (rowAction.label || "").toString();
    var actionClass = (rowAction.className || "btn btn-sm btn-outline-secondary").toString();
    var actionIcon = (rowAction.icon || "").toString();
    var actionIconClass = "";
    var actionHref = (rowAction.href || "").toString().trim();
    if (actionIcon) {
      actionIconClass = actionIcon.indexOf("bi-") === 0 ? ("bi " + actionIcon) : actionIcon;
    }
    if (actionHref) {
      actionParts.push(
        "<a href='" + escapeHtml(actionHref) + "' class='" + escapeHtml(actionClass) + "'" +
        (actionLabel ? (" title='" + escapeHtml(actionLabel) + "'") : "") +
        ">" +
        (actionIconClass ? ("<i class='" + escapeHtml(actionIconClass + (actionLabel ? " me-1" : "")) + "'></i>") : "") +
        escapeHtml(actionLabel) +
        "</a>"
      );
      continue;
    }
    if (!actionName) continue;
    var payload = rowAction.data && typeof rowAction.data === "object" ? rowAction.data : {};
    payload.action = actionName;
    actionParts.push(
      "<button type='button' class='" + escapeHtml(actionClass) + "'" +
      " data-dashboard-custom-action='true'" +
      " data-action-name='" + escapeHtml(actionName) + "'" +
      " data-action-payload='" + escapeHtml(JSON.stringify(payload)) + "'" +
      rowActionConfirmAttrs(rowAction) +
      (actionLabel ? (" title='" + escapeHtml(actionLabel) + "'") : "") +
      ">" +
      (actionIconClass ? ("<i class='" + escapeHtml(actionIconClass + (actionLabel ? " me-1" : "")) + "'></i>") : "") +
      escapeHtml(actionLabel) +
      "</button>"
    );
  }
  if (actionParts.length > 0) {
    actionHtml = "<div class='ua-dashboard-item-actions'>" + actionParts.join("") + "</div>";
  }

  if (isFolderRow) {
    return "<div class='ua-dashboard-item ua-dashboard-item-folder" + rowRailClass + "'" +
      (editHref ? (" data-dashboard-row-href='" + escapeHtml(editHref) + "'") : "") +
      " data-file-folder-nav='true'" +
      " data-folder-path='" + escapeHtml(folderPath) + "'" +
      " style='background:rgba(var(--bs-warning-rgb),0.12);'>" +
      iconHtml +
      "<div class='ua-dashboard-item-body'>" +
      "<div class='ua-dashboard-item-title d-flex align-items-center gap-2'>" +
      (editHref
        ? ("<a href='" + escapeHtml(editHref) + "' data-file-folder-nav='true' data-folder-path='" + escapeHtml(folderPath) + "'>" + title + "</a>")
        : title) +
      (row.meta ? ("<span class='small text-muted'>" + escapeHtml(row.meta.toString()) + "</span>") : "") +
      "</div>" +
      "</div>" +
      actionHtml +
      "</div>";
  }

  return "<div class='ua-dashboard-item" + rowRailClass + "'" +
    (customHref ? (" data-dashboard-row-href='" + escapeHtml(editHref) + "'") : "") +
    ">" +
    iconHtml +
    "<div class='ua-dashboard-item-body'>" +
    (overline ? "<div class='ua-dahsboard-item-overline'>" + overline + "</div>" : "") +
    "<div class='ua-dashboard-item-title'>" + securityIconHtml + (customHref ? ("<a href='" + escapeHtml(editHref) + "'>" + title + "</a>") : title) + "</div>" +
    (subtitle ? "<div class='ua-dashboard-item-subtitle'>" + subtitle + "</div>" : "") +
    (showDescription ? "<div class='small text-muted mt-1'>" + description + "</div>" : "") +
    metaHtml +
    "</div>" +
    badgeHtml +
    actionHtml +
    "</div>";
}

async function renderCardView(host, rows, baseUrl, pageNamespace, apiUrl) {
  var html = "<div class='row g-3'>";
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    var id = (row.id || row.namespace || "").toString();
    var customHref = (row.href || "").toString().trim();
    var allowEdit = row.allowEdit !== false;
    var allowDelete = row.allowDelete !== false;
    var title = escapeHtml((row.title || row.name || row.email || id).toString());
    var desc = escapeHtml((row.description || row.subtitle || "").toString());
    var thumbUri = (row.thumbnail || row.thumb || row.preview || row.previewUri || row.image || "").toString().trim();
    var securityIconName = (row.securityIcon || "").toString().trim();
    var securityIconClass = securityIconName
      ? (securityIconName.indexOf("bi-") === 0 ? ("bi " + securityIconName) : ("bi bi-" + securityIconName))
      : "";
    var securityTitle = row.securityLocked ? "Locked / Secure" : "Public";
    var badge = row.badge || (typeof row.enabled === "boolean" ? (row.enabled ? "Enabled" : "Disabled") : "");
    var badgeClass = row.badgeClass || (row.enabled === true ? "bg-success" : "bg-secondary");
    var editHref = customHref || (baseUrl.replace(/\/$/, "") + "/" + encodeURIComponent(id));
    var sideColorClass = (row.sideColorClass || "").toString().trim();
    var railClass = normalizeRailClass(sideColorClass);
    var cardRailClass = railClass ? (" rail-start " + railClass) : "";
    var rowIcon = (row.icon || "").toString().trim();
    var rowIconClass = rowIcon
      ? (rowIcon.indexOf("bi-") === 0 ? ("bi " + rowIcon) : ("bi bi-" + rowIcon))
      : "bi bi-grid";
    var openIcon = (row.openIcon || "").toString().trim();
    var openIconClass = openIcon
      ? (openIcon.indexOf("bi-") === 0 ? ("bi " + openIcon) : openIcon)
      : (customHref ? "bi bi-arrow-right" : "bi bi-pencil");
    var layoutMode = (row.cardLayout || "").toString().trim().toLowerCase();

    var footerActions = "";
    if (allowEdit || customHref) {
      footerActions += "<a href='" + editHref + "' class='btn btn-sm btn-outline-primary'><i class='" + escapeHtml(openIconClass + (customHref ? "" : " me-1")) + "'></i>" + (customHref ? "" : "Edit") + "</a>";
    }
    if (allowDelete) {
      footerActions += "<button type='button' class='btn btn-sm btn-outline-danger'" +
        " data-dashboard-delete='true'" +
        " data-delete-id='" + escapeHtml(id) + "'" +
        " data-delete-label='" + escapeHtml((row.title || row.name || row.email || id).toString()) + "'" +
        " data-page-namespace='" + escapeHtml(pageNamespace) + "'" +
        " data-api-url='" + escapeHtml(apiUrl || "") + "'>" +
        "<i class='bi bi-trash3'></i></button>";
    }
    var rowActions = row.actionButtons instanceof Array ? row.actionButtons : [];
    for (var rp = 0; rp < rowActions.length; rp++) {
      var rowAction = rowActions[rp] || {};
      var actionName = (rowAction.action || "").toString().trim();
      var actionLabel = (rowAction.label || "").toString();
      var actionClass = (rowAction.className || "btn btn-sm btn-outline-secondary").toString();
      var actionIcon = (rowAction.icon || "").toString();
      var actionIconClass = actionIcon ? (actionIcon.indexOf("bi-") === 0 ? ("bi " + actionIcon) : actionIcon) : "";
      var actionHref = (rowAction.href || "").toString().trim();
      if (actionHref) {
        footerActions += "<a href='" + escapeHtml(actionHref) + "' class='" + escapeHtml(actionClass) + "'" +
          (actionLabel ? (" title='" + escapeHtml(actionLabel) + "'") : "") +
          ">" +
          (actionIconClass ? ("<i class='" + escapeHtml(actionIconClass + (actionLabel ? " me-1" : "")) + "'></i>") : "") +
          escapeHtml(actionLabel) +
          "</a>";
        continue;
      }
      if (!actionName) continue;
      var payload = rowAction.data && typeof rowAction.data === "object" ? rowAction.data : {};
      payload.action = actionName;
      footerActions += "<button type='button' class='" + escapeHtml(actionClass) + "'" +
        " data-dashboard-custom-action='true'" +
        " data-action-name='" + escapeHtml(actionName) + "'" +
        " data-action-payload='" + escapeHtml(JSON.stringify(payload)) + "'" +
        rowActionConfirmAttrs(rowAction) +
        (actionLabel ? (" title='" + escapeHtml(actionLabel) + "'") : "") +
        ">" +
        (actionIconClass ? ("<i class='" + escapeHtml(actionIconClass + (actionLabel ? " me-1" : "")) + "'></i>") : "") +
        escapeHtml(actionLabel) +
        "</button>";
    }

    if (layoutMode === "media-left") {
      html += "<div class='col-sm-6 col-xl-4'>" +
        "<div class='card h-100" + cardRailClass + "'" +
        (customHref ? (" data-dashboard-row-href='" + escapeHtml(editHref) + "'") : "") +
        ">" +
        "<div class='card-body d-flex flex-column'>" +
        "<div class='row g-3 align-items-start flex-grow-1'>" +
        "<div class='col-auto'>" +
        (thumbUri
          ? ("<img src='" + escapeHtml(thumbUri) + "' alt='' loading='lazy' style='width:4.25rem;height:4.25rem;object-fit:cover;border-radius:.75rem;'/>")
          : ("<div class='rounded-3 bg-body-tertiary d-inline-flex align-items-center justify-content-center' style='width:4.25rem;height:4.25rem;font-size:1.5rem;'><i class='" + escapeHtml(rowIconClass) + "'></i></div>")) +
        "</div>" +
        "<div class='col'>" +
        "<div class='d-flex justify-content-between align-items-start gap-2 mb-1'>" +
        "<h6 class='card-title mb-0'>" + title + "</h6>" +
        (badge ? "<span class='badge " + escapeHtml(badgeClass) + "'>" + escapeHtml(badge) + "</span>" : "") +
        "</div>" +
        (desc ? "<p class='card-text small text-muted mb-1' style='min-height:2.5rem;'>" + desc + "</p>" : "") +
        (row.meta ? "<div class='small text-muted'>" + escapeHtml((row.meta || "").toString()) + "</div>" : "") +
        (securityIconClass ? ("<div class='small text-muted mt-1' title='" + escapeHtml(securityTitle) + "'><i class='" + escapeHtml(securityIconClass) + "'></i></div>") : "") +
        "</div>" +
        "</div>" +
        "</div>" +
        "<div class='card-footer d-flex justify-content-end gap-2'>" +
        footerActions +
        "</div>" +
        "</div>" +
        "</div>";
      continue;
    }

    var previewHtml = "";
    if (thumbUri) {
      previewHtml = "<div class='mb-2 position-relative'>" +
        "<img src='" + escapeHtml(thumbUri) + "' alt='' loading='lazy' style='width:100%;height:9rem;object-fit:cover;border-radius:.5rem;'/>" +
        (securityIconClass
          ? ("<span class='position-absolute top-0 end-0 m-2 px-2 py-1 rounded text-white bg-dark bg-opacity-75' title='" + escapeHtml(securityTitle) + "'><i class='" + securityIconClass + "'></i></span>")
          : "") +
        "</div>";
    } else {
      previewHtml = "<div class='mb-2 d-flex align-items-center'>" +
        "<div class='rounded-3 bg-body-tertiary d-inline-flex align-items-center justify-content-center' style='width:3.5rem;height:3.5rem;font-size:1.4rem;'><i class='" + escapeHtml(rowIconClass) + "'></i></div>" +
        "</div>";
    }

    html += "<div class='col-sm-6 col-lg-4'>" +
      "<div class='card h-100" + cardRailClass + "'" +
      (customHref ? (" data-dashboard-row-href='" + escapeHtml(editHref) + "'") : "") +
      ">" +
      "<div class='card-body d-flex flex-column'>" +
      previewHtml +
      "<div class='d-flex justify-content-between align-items-start mb-2'>" +
      "<h6 class='card-title mb-0'>" + title + "</h6>" +
      (badge ? "<span class='badge " + escapeHtml(badgeClass) + "'>" + escapeHtml(badge) + "</span>" : "") +
      "</div>" +
      (desc ? "<p class='card-text small text-muted mb-1' style='min-height:2.5rem;'>" + desc + "</p>" : "<p class='card-text small text-muted mb-1' style='min-height:2.5rem;'></p>") +
      (row.meta ? "<div class='small text-muted'>" + escapeHtml((row.meta || "").toString()) + "</div>" : "") +
      "</div>" +
      "<div class='card-footer d-flex justify-content-end gap-2'>" +
      footerActions +
      "</div>" +
      "</div>" +
      "</div>";
  }
  html += "</div>";
  host.innerHTML = html;
}

function normalizeRailClass(sideColorClass) {
  var value = (sideColorClass || "").toString().trim().toLowerCase();
  if (!(value)) return "";

  if (value.indexOf("rail-") === 0) {
    return value.replace(/[^a-z0-9-]/g, "");
  }

  if (value.indexOf("bg-") === 0) {
    return "rail-" + value.slice(3).replace(/[^a-z0-9-]/g, "");
  }

  return "rail-" + value.replace(/[^a-z0-9-]/g, "");
}

function renderPagination(host, state, onPage) {
  if (!host) return;
  var totalPages = Math.ceil(state.total / state.limit) || 1;
  if (totalPages <= 1) {
    host.innerHTML = "";
    return;
  }

  var prevDisabled = state.page <= 1;
  var nextDisabled = state.page >= totalPages;

  host.innerHTML =
    "<span class='text-muted small'>Page " + state.page + " of " + totalPages + "</span>" +
    "<div class='btn-group btn-group-sm'>" +
    "<button type='button' class='btn btn-outline-secondary' id='dash-prev'" + (prevDisabled ? " disabled" : "") + ">Prev</button>" +
    "<button type='button' class='btn btn-outline-secondary' id='dash-next'" + (nextDisabled ? " disabled" : "") + ">Next</button>" +
    "</div>";

  var prev = host.querySelector("#dash-prev");
  var next = host.querySelector("#dash-next");
  if (prev && !prevDisabled) {
    prev.addEventListener("click", function() {
      state.page = Math.max(1, state.page - 1);
      onPage();
    });
  }
  if (next && !nextDisabled) {
    next.addEventListener("click", function() {
      state.page = Math.min(totalPages, state.page + 1);
      onPage();
    });
  }
}

/**
 * OPT-IN confirmation attributes for a row action button.
 *
 * A page opts a custom row action into a confirm prompt by adding a `confirm` string
 * to its actionButtons entry (optionally `confirmTitle` / `confirmLabel` /
 * `confirmClass`). Actions WITHOUT `confirm` produce an empty string here, so their
 * rendered markup and their click behaviour are unchanged.
 *
 * @param {object} rowAction One entry from a row's actionButtons array.
 * @returns {string} HTML attributes to splice into the button tag ("" when not opted in).
 */
function rowActionConfirmAttrs(rowAction) {
  var confirmMessage = ((rowAction || {}).confirm || "").toString().trim();
  if (!confirmMessage) return "";
  var confirmTitle = ((rowAction || {}).confirmTitle || "Are you sure?").toString().trim();
  var confirmLabel = ((rowAction || {}).confirmLabel || "Continue").toString().trim();
  var confirmClass = ((rowAction || {}).confirmClass || "btn btn-danger").toString().trim();
  return " data-action-confirm='" + escapeHtml(confirmMessage) + "'" +
    " data-action-confirm-title='" + escapeHtml(confirmTitle) + "'" +
    " data-action-confirm-label='" + escapeHtml(confirmLabel) + "'" +
    " data-action-confirm-class='" + escapeHtml(confirmClass) + "'";
}

// ─── Generic confirmation via ua.dialog / UATools / native confirm ───────────

/**
 * Ask the operator to confirm an action, then run `onConfirm` only if they agree.
 *
 * Resolution order (each tier falls through to the next; the chain NEVER silently
 * proceeds and NEVER silently no-ops):
 *   1. window.UATools.ShowConfirm — probed across the signatures live surfaces use.
 *   2. an inline ua.dialog rendered through window.UATools.render.
 *   3. native window.confirm.
 *
 * @param {object} options { title, message, messageHtml?, confirmLabel?, confirmClass?, confirmIcon? }
 *   `message` is plain text (native confirm); `messageHtml` is trusted HTML for the
 *   dialog body and defaults to the escaped `message`.
 * @param {function} onConfirm Invoked (once) only when the operator confirms.
 */
function confirmDashboardAction(options, onConfirm) {
  var opts = options || {};
  var title = (opts.title || "Are you sure?").toString();
  var message = (opts.message || "").toString();
  var messageHtml = (typeof opts.messageHtml === "string" && opts.messageHtml)
    ? opts.messageHtml
    : escapeHtml(message);
  var confirmLabel = (opts.confirmLabel || "Continue").toString();
  var confirmClass = (opts.confirmClass || "btn btn-primary").toString();
  var confirmIcon = (opts.confirmIcon || "").toString();

  var settled = false;

  function accept() {
    if (settled) return;
    settled = true;
    try {
      return onConfirm();
    } catch (confirmRunError) {
      console.error("Dashboard confirm action error:", confirmRunError);
    }
  }

  function decline() {
    settled = true;
  }

  // ── tier 3: native confirm (last resort — always decisive) ──────────────────
  function nativeConfirm() {
    if (settled) return;
    if (window.confirm(message || title)) {
      accept();
    } else {
      decline();
    }
  }

  // ── tier 2: an inline ua.dialog ─────────────────────────────────────────────
  function dialogConfirm() {
    if (settled) return;
    if (!(window.UATools && typeof window.UATools.render === "function")) {
      nativeConfirm();
      return;
    }

    var dialogId = "dash-action-confirm-" + Date.now() + "-" + Math.floor(Math.random() * 100000);
    // NOTE: deliberately no `AlertStyle: "confirm"`. `ua.dialog` treats AlertStyle as
    // ADDITIVE (uat/src/elements/ua.dialog.js:294-314): it PREPENDS a generic no/Yes
    // group to `options.footer` rather than replacing it. Since this caller supplies a
    // complete, wired footer below, passing it rendered four buttons of which only two
    // did anything — the generic pair carries `ua-response`, which nothing reads, so
    // clicking "Yes" merely dismissed the modal and silently abandoned the action.
    var dialogJson = {
      n: "ua.dialog",
      title: title,
      allowclose: true,
      inner: messageHtml,
      footer: [
        {
          n: "button",
          type: "button",
          id: dialogId + "-confirm",
          c: confirmClass,
          i: confirmIcon
            ? [{ n: "i", c: confirmIcon + " me-1" }, confirmLabel]
            : confirmLabel
        },
        {
          n: "button",
          type: "button",
          id: dialogId + "-cancel",
          c: "btn btn-secondary",
          "data-dismiss": "dialog",
          i: "Cancel"
        }
      ]
    };

    Promise.resolve(window.UATools.render(dialogJson)).then(function(rendered) {
      // A render that produced no node cannot collect a decision — do not drop the
      // action on the floor; ask natively instead.
      if (!(rendered && rendered.nodeType)) {
        nativeConfirm();
        return;
      }
      document.body.appendChild(rendered);

      // `rendered` may be the `.modal` itself or a `uae` wrapper around it. The
      // bootstrap instance and the shared dismiss handlers both act on the `.modal`,
      // but only removing `rendered` clears the wrapper too.
      var modalEl = (rendered.classList && rendered.classList.contains("modal"))
        ? rendered
        : (typeof rendered.querySelector === "function" ? rendered.querySelector(".modal") : null);

      var decided = false;

      // Idempotent: safe to call from any path, including twice for one dismissal.
      function cleanup() {
        if (rendered.parentNode) rendered.parentNode.removeChild(rendered);
      }

      // Exactly one outcome per dialog. `decided` also stops a dismissal that races a
      // button click from turning an accept() into a decline().
      function finish(outcome) {
        if (decided) return;
        decided = true;
        cleanup();
        outcome();
      }

      var confirmBtn = document.getElementById(dialogId + "-confirm");
      var cancelBtn = document.getElementById(dialogId + "-cancel");
      if (!confirmBtn) {
        cleanup();
        nativeConfirm();
        return;
      }
      confirmBtn.addEventListener("click", function() {
        finish(accept);
      });
      if (cancelBtn) {
        cancelBtn.addEventListener("click", function() {
          finish(decline);
        });
      }

      // Dismissal WITHOUT using our buttons — the header "X", Escape, or a backdrop
      // click. None of these ran decline() or removed the node, so each dismissal
      // parked one hidden modal on <body> for the life of the page. Treat dismissal as
      // a decline (fails safe: the action still does not run) and clean up after it.
      if (modalEl && typeof modalEl.addEventListener === "function") {
        // Escape, backdrop, and any `data-bs-dismiss` control: bootstrap only HIDES
        // the node, so remove it once it has finished hiding.
        modalEl.addEventListener("hidden.bs.modal", function() {
          finish(decline);
        });

        // The shared `data-ua-dismiss` handler (uat/src/elements/ua.dialog.js:478)
        // removes the `.modal` directly, which strands the `uae` wrapper and fires no
        // bootstrap event if no bootstrap instance was ever created. Reconcile after
        // letting the shared handler run.
        modalEl.addEventListener("click", function(clickEvent) {
          var clickTarget = clickEvent.target;
          if (!clickTarget || typeof clickTarget.closest !== "function") return;
          if (!clickTarget.closest("[data-ua-dismiss='modal'], [data-bs-dismiss='modal']")) return;
          setTimeout(function() {
            finish(decline);
          }, 0);
        });
      }
    }).catch(function(renderError) {
      console.error("Dashboard confirm dialog render error:", renderError);
      nativeConfirm();
    });
  }

  // ── tier 1: UATools.ShowConfirm ─────────────────────────────────────────────
  // Some live surfaces expose ShowConfirm(title, message, callback), while others
  // expose ShowConfirm(message, callback), ShowConfirm(title, message) returning a
  // promise, or ShowConfirm(message) returning a promise/boolean. Do not rely on
  // Function.length alone; probe return values so confirmation stays wired across
  // mixed dashboard runtimes.
  if (window.UATools && typeof window.UATools.ShowConfirm === "function") {
    var consumeConfirmResult = function(confirmResult) {
      if (confirmResult && typeof confirmResult.then === "function") {
        confirmResult.then(function(confirmed) {
          // Ambiguous resolutions must NOT be read as approval, and must not be
          // dropped either — re-ask through the fallback chain.
          if (confirmed === undefined || confirmed === null) {
            dialogConfirm();
            return;
          }
          if (confirmed) {
            accept();
            return;
          }
          decline();
        }).catch(function(error) {
          console.error("Dashboard confirm error:", error);
          dialogConfirm();
        });
        return true;
      }
      if (confirmResult === true) {
        accept();
        return true;
      }
      if (confirmResult === false) {
        decline();
        return true;
      }
      return false;
    };

    var tryShowConfirm = function(args, callbackIndex) {
      try {
        var callbackInvoked = false;
        var hasCallback = typeof callbackIndex === "number" && callbackIndex >= 0 && callbackIndex < args.length && typeof args[callbackIndex] === "function";
        if (hasCallback) {
          var originalCallback = args[callbackIndex];
          args = args.slice();
          args[callbackIndex] = function() {
            callbackInvoked = true;
            return originalCallback.apply(this, arguments);
          };
        }

        var result = window.UATools.ShowConfirm.apply(window.UATools, args);
        if (callbackInvoked) return true;
        if (consumeConfirmResult(result)) return true;

        // Some confirm helpers are callback-driven and return undefined until the
        // user acts. Only treat that as a valid match when we actually passed a
        // function callback in a likely callback position.
        if (result === undefined && hasCallback) return true;
      } catch (showConfirmError) {
        console.error("Dashboard confirm error:", showConfirmError);
      }
      return false;
    };

    if (tryShowConfirm([title, messageHtml, accept], 2)) return;
    if (tryShowConfirm([title, accept], 1)) return;
    if (tryShowConfirm([messageHtml, accept], 1)) return;
    if (tryShowConfirm([title, messageHtml], -1)) return;
    if (tryShowConfirm([messageHtml], -1)) return;
  }

  dialogConfirm();
}

function confirmDelete(pageNamespace, id, label, onSuccess, dashboardApi, apiUrl) {
  confirmDashboardAction({
    title: "Delete " + label + "?",
    message: "Are you sure you want to delete " + label + "? This action cannot be undone.",
    messageHtml: "Are you sure you want to delete <strong>" + escapeHtml(label) + "</strong>? This action cannot be undone.",
    confirmLabel: "Delete",
    confirmClass: "btn btn-danger",
    confirmIcon: "bi bi-trash3"
  }, async function() {
    await doDelete(pageNamespace, id, onSuccess, dashboardApi, apiUrl);
  });
}

async function doDelete(pageNamespace, id, onSuccess, dashboardApi, apiUrl) {
  try {
    var response = apiUrl
      ? await dashboardApi.withBase(apiUrl).delete(id)
      : await dashboardApi.delete(pageNamespace, id);
    if (response && response.success) {
      if (typeof onSuccess === "function") onSuccess();
    } else {
      await showDashboardError((((response || {}).errors || [])[0]) || null, "Delete failed.");
    }
  } catch (err) {
    console.error("Dashboard delete error:", err);
    await showDashboardError(err, "An error occurred during deletion.");
  }
}

/**
 * Validate a handler-supplied redirect target. Only SAME-ORIGIN absolute paths are
 * accepted, so a compromised or careless handler cannot turn a dashboard action into
 * an open redirect.
 *
 * Accepts: "/dashboard/my/thing/123", "/a?b=c#d"
 * Rejects: "//evil.com" and "/\evil.com" (protocol-relative), "http://evil",
 *          "javascript:…", "evil.com", anything with whitespace/backslashes/control
 *          characters, and any non-string.
 *
 * @param {*} value The candidate redirect.
 * @returns {string} The safe path, or "" when the value must not be followed.
 */
function safeDashboardRedirectPath(value) {
  if (typeof value !== "string") return "";
  var path = value.trim();
  if (!path) return "";
  // Must be an absolute path on this origin.
  if (path.charAt(0) !== "/") return "";
  // "//host" and "/\host" are protocol-relative — they leave the origin.
  if (path.charAt(1) === "/" || path.charAt(1) === "\\") return "";
  // No backslashes, whitespace, or control characters anywhere.
  if (/[\\\s]/.test(path)) return "";
  for (var i = 0; i < path.length; i++) {
    if (path.charCodeAt(i) < 0x20 || path.charCodeAt(i) === 0x7f) return "";
  }
  return path;
}

async function doCustomAction(pageNamespace, actionName, payload, onSuccess, dashboardApi, apiUrl) {
  if (!(dashboardApi)) return;
  try {
    var actionPayload = payload && typeof payload === "object" ? payload : {};
    var response = apiUrl
      ? await dashboardApi.action(pageNamespace, "action", actionPayload, apiUrl)
      : await dashboardApi.action(pageNamespace, "action", actionPayload);
    if (response && response.success) {
      if (response.alreadyExists === true) {
        window.alert("This widget or dashboard is already on your Home workspace.");
      }
      // A handler may ask the client to route somewhere after a successful action
      // (e.g. "duplicate" → the new editable draft). Only same-origin ABSOLUTE PATHS
      // are honoured; anything else is ignored and the caller's refresh runs instead.
      var redirectPath = safeDashboardRedirectPath(
        (response.redirect !== undefined && response.redirect !== null)
          ? response.redirect
          : ((response.data || {}).redirect)
      );
      if (redirectPath) {
        window.location.href = redirectPath;
        return;
      }
      if (typeof onSuccess === "function") onSuccess();
      return;
    }
    await showDashboardError((((response || {}).errors || [])[0]) || null, "Action failed.");
  } catch (error) {
    await showDashboardError(error, "Unable to complete action.");
  }
}

// ─── Read-only HTML preview containers ───────────────────────────────────────

/**
 * OPT-IN: hydrate any `[data-email-preview]` container on the page.
 *
 * A page opts in purely by rendering a container carrying `data-email-preview`
 * whose value is the record id to preview (empty = nothing saved yet). The binder
 * asks the page's OWN `action` handler for `{ action: "preview", id, docId }` and
 * expects `{ success:true, html }` back.
 *
 * The returned markup is document-level email HTML (its own <table> layout and
 * inline CSS), so it is injected into a SANDBOXED <iframe srcdoc> — never into the
 * dashboard DOM. `sandbox="allow-same-origin"` withholds allow-scripts, so nothing
 * in the previewed markup can execute; same-origin is granted only so the frame can
 * be measured and sized to its content.
 *
 * Pages that render no such container do no work here and issue no request.
 *
 * @param {object} context The dashboard page context.
 */
async function bindDashboardPreviewContainers(context) {
  var ctx = context || {};
  var dashboardApi = ctx.dashboardApi;
  var dashCtx = ctx.dashboard || {};
  var currentPage = dashCtx.currentPage || {};
  var pageNamespace = (currentPage.namespace || "").toString().trim();
  var apiUrl = ((currentPage.routes || {}).api || "").toString().trim() || null;

  if (!dashboardApi || !pageNamespace) return;

  // A page may OWN its preview container with a page-specific client module (it sets
  // data-email-preview-managed='true'); this generic binder leaves those alone so it
  // never double-binds or clobbers the richer UI. Compose does this for its
  // desktop/mobile/plain-text + Send Test surface (dashboard/client/egt.email.compose.js).
  var containers = document.querySelectorAll("[data-email-preview]:not([data-email-preview-managed='true'])");

  // STRICTLY OPT-IN: a page that renders no preview container does no work, issues
  // no request, and installs no observer — it leaves this function unchanged from
  // its previous (non-existent) behaviour.
  if (containers.length === 0) return;

  for (var i = 0; i < containers.length; i++) {
    await hydrateDashboardPreviewContainer(containers[i], pageNamespace, apiUrl, dashboardApi, dashCtx);
  }

  // An opted-in page may re-render its container (a wizard step redrawn on
  // navigation). Watch briefly so the pane re-hydrates instead of silently going
  // blank. Bounded to 60s, and only ever installed on a page that already opted in.
  if (typeof MutationObserver !== "function") return;
  var observer = new MutationObserver(function() {
    var late = document.querySelectorAll("[data-email-preview]:not([data-email-preview-bound='true']):not([data-email-preview-managed='true'])");
    for (var j = 0; j < late.length; j++) {
      hydrateDashboardPreviewContainer(late[j], pageNamespace, apiUrl, dashboardApi, dashCtx);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function() { observer.disconnect(); }, 60000);
}

function renderDashboardPreviewNote(host, text) {
  host.innerHTML = "<p class='small text-muted mb-0'>" + escapeHtml(text) + "</p>";
}

async function hydrateDashboardPreviewContainer(host, pageNamespace, apiUrl, dashboardApi, dashCtx) {
  if (!host || host.getAttribute("data-email-preview-bound") === "true") return;
  host.setAttribute("data-email-preview-bound", "true");

  var recordId = (host.getAttribute("data-email-preview") || "").toString().trim();
  if (!recordId || recordId === "new") {
    recordId = ((dashCtx || {}).currentRecordId || "").toString().trim();
  }
  if (!recordId || recordId === "new") {
    renderDashboardPreviewNote(host, "Save this draft to see a preview.");
    return;
  }

  renderDashboardPreviewNote(host, "Loading preview…");

  var response = null;
  try {
    var payload = { action: "preview", id: recordId, docId: recordId };
    response = apiUrl
      ? await dashboardApi.action(pageNamespace, "action", payload, apiUrl)
      : await dashboardApi.action(pageNamespace, "action", payload);
  } catch (previewError) {
    console.error("Dashboard preview error:", previewError);
    renderDashboardPreviewNote(host, "Preview is unavailable right now.");
    return;
  }

  var html = null;
  if (response && response.success) {
    if (typeof response.html === "string") {
      html = response.html;
    } else if (response.data && typeof response.data.html === "string") {
      html = response.data.html;
    }
  }

  if (typeof html !== "string" || !html) {
    var reason = (((response || {}).errors || [])[0] || {}).description
      || ((response || {}).reason || "");
    renderDashboardPreviewNote(host, reason ? reason.toString() : "No preview available for this record.");
    return;
  }

  var frame = document.createElement("iframe");
  // No allow-scripts: the previewed markup cannot execute. allow-same-origin only so
  // the frame's height can be measured.
  frame.setAttribute("sandbox", "allow-same-origin");
  frame.setAttribute("referrerpolicy", "no-referrer");
  frame.setAttribute("title", "Email preview");
  frame.setAttribute("loading", "lazy");
  frame.className = "ua-dashboard-preview-frame";
  frame.style.width = "100%";
  frame.style.border = "0";
  frame.style.minHeight = "24rem";
  frame.style.display = "block";
  frame.style.borderRadius = "0.5rem";
  frame.style.background = "#ffffff";

  frame.addEventListener("load", function() {
    try {
      var doc = frame.contentDocument;
      if (!doc || !doc.body) return;
      var height = Math.max(
        doc.body.scrollHeight || 0,
        doc.documentElement ? (doc.documentElement.scrollHeight || 0) : 0
      );
      if (height > 0) frame.style.height = (height / 16) + "rem";
    } catch (measureError) {
      // Opaque origin (or a hostile document) — keep the min-height fallback.
    }
  });

  host.innerHTML = "";
  host.appendChild(frame);
  frame.setAttribute("srcdoc", html);
}

// ─── Wizard detail pages: load existing record via DashboardAPI.get() ────────

function bindDashboardDetailDeleteButton(context) {
  var dashboardApi = (context || {}).dashboardApi;
  var dashCtx = (context || {}).dashboard || {};
  var currentPage = dashCtx.currentPage || {};
  var pageNamespace = (currentPage.namespace || "").toString().trim();
  var routes = currentPage.routes || {};
  var apiUrl = (routes.api || "").toString().trim() || null;
  var pageUrl = (routes.page || "").toString().trim() || "/dashboard";
  if (!dashboardApi || !pageNamespace) return;

  var deleteButtons = document.querySelectorAll("[data-dashboard-delete='true']");
  deleteButtons.forEach(function(button) {
    if (!button || button.getAttribute("data-dashboard-delete-bound") === "true") return;
    button.setAttribute("data-dashboard-delete-bound", "true");
    button.addEventListener("click", function(event) {
      event.preventDefault();
      var deleteId = (button.getAttribute("data-delete-id") || dashCtx.currentRecordId || "").trim();
      if (!deleteId) return;
      var deleteLabel = (button.getAttribute("data-delete-label") || deleteId).trim();
      var buttonNamespace = (button.getAttribute("data-page-namespace") || pageNamespace).trim();
      var buttonApiUrl = (button.getAttribute("data-api-url") || apiUrl || "").trim() || null;
      confirmDelete(buttonNamespace, deleteId, deleteLabel, function() {
        window.location.href = pageUrl;
      }, dashboardApi, buttonApiUrl);
    });
  });
}

async function initDashboardDetailPage(context) {
  var dashboardApi  = (context || {}).dashboardApi;
  var dashCtx       = (context || {}).dashboard || {};
  var recordId      = (dashCtx.currentRecordId || "").toString().trim();
  var currentPage   = dashCtx.currentPage || {};
  var pageNamespace = (currentPage.namespace || "").toString().trim();
  var apiUrl        = ((currentPage.routes || {}).api || "").toString().trim() || null;

  bindDashboardDetailDeleteButton(context);

  if (!dashboardApi || !recordId || recordId === "new" || !pageNamespace) return;

  // Load the record and populate UA controls via UATools.load()
  try {
    var response = apiUrl
      ? await dashboardApi.withBase(apiUrl).get(recordId)
      : await dashboardApi.get(pageNamespace, recordId);
    if (response && response.success && response.data) {
      if (window.UATools && typeof window.UATools.load === "function") {
        window.UATools.load(response.data);
      }
    }
  } catch (err) {
    // console.warn("Dashboard detail load error:", err);
  }
}

// ─── Utility ─────────────────────────────────────────────────────────────────

function escapeHtml(value) {
  return (value || "").toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function _dashboardRoles() {
  var roles = window.__uaDashboardUserRoles;
  if (!(roles instanceof Array)) return [];
  return roles.map(function(role) {
    return (role || "").toString().trim().toLowerCase();
  }).filter(Boolean);
}

function _canSeeStacktrace() {
  var roles = _dashboardRoles();
  return roles.indexOf("admin.app") >= 0 || roles.indexOf("superadmin.universe") >= 0;
}

function _stackValue(error) {
  if (!(error && typeof error === "object")) return null;
  if (error.stacktrace) return error.stacktrace;
  if (error.stack) return error.stack;
  if (error.data && error.data.originalError) {
    if (error.data.originalError.stacktrace) return error.data.originalError.stacktrace;
    if (error.data.originalError.stack) return error.data.originalError.stack;
  }
  return null;
}

function _siteOrigin() {
  var fromCard = ((((window || {}).UATServerCard || {}).my || {}).app || {}).url;
  var candidate = (fromCard || "").toString().trim();
  if (candidate) {
    try {
      return new URL(candidate).origin;
    } catch (error) {}
  }

  if (window && window.location && window.location.origin) {
    return window.location.origin.toString();
  }

  return "";
}

function _redactOrigin(line) {
  var raw = (line || "").toString();
  if (!raw) return raw;

  var origin = _siteOrigin();
  if (origin) {
    return raw.split(origin).join("{uri}");
  }

  return raw.replace(/https?:\/\/[^/\s]+/g, "{uri}");
}

function _normalizeStackLines(stack) {
  if (!stack) return [];

  if (typeof stack === "string") {
    return stack.split("\n").map(function(line) {
      return _redactOrigin((line || "").toString().trim());
    }).filter(Boolean);
  }

  if (stack instanceof Array) {
    return stack.map(function(line) {
      if (typeof line === "string") return _redactOrigin(line.trim());
      if (line && typeof line === "object") {
        var next = { ...line };
        if (next.file) next.file = _redactOrigin(next.file);
        if (next.s) next.s = _redactOrigin(next.s);
        return next;
      }
      return "";
    }).filter(Boolean);
  }

  if (typeof stack === "object") {
    var normalized = { ...stack };
    if (normalized.file) normalized.file = _redactOrigin(normalized.file);
    if (normalized.s) normalized.s = _redactOrigin(normalized.s);
    return [normalized];
  }

  return [];
}

async function _stackLineHtml(line) {
  if (window.UATools && typeof window.UATools.render === "function") {
    try {
      var rendered = await window.UATools.render({
        n: "ua.error.stacktrace.line",
        line: line
      });

      if (typeof rendered === "string") return rendered;
      if (rendered && typeof rendered.outerHTML === "string") return rendered.outerHTML;
      if (rendered && rendered.nodeType) {
        var holder = document.createElement("div");
        holder.appendChild(rendered.cloneNode(true));
        return holder.innerHTML;
      }
    } catch (error) {
      // console.warn("Unable to render stack trace line element.", error);
    }
  }

  var fallback = typeof line === "string"
    ? line
    : (line && (line.s || line.message || JSON.stringify(line)));

  return "<li class='ua-error-stacktrace-line'>" + escapeHtml((fallback || "").toString()) + "</li>";
}

async function _stacktraceSectionHtml(error) {
  if (!(_canSeeStacktrace())) return "";
  var lines = _normalizeStackLines(_stackValue(error));
  if (lines.length === 0) return "";

  var firstLine = lines[0];
  var firstLineText = typeof firstLine === "string"
    ? firstLine
    : (firstLine && (firstLine.s || firstLine.message || JSON.stringify(firstLine))) || "";

  var lineHtml = [];
  for (var i = 1; i < lines.length; i++) {
    lineHtml.push(await _stackLineHtml(lines[i]));
  }

  var html = "<div class='message-fullscreen-stacktrace-firstline'>" + escapeHtml(firstLineText) + "</div>";
  if (lineHtml.length > 0) {
    html += "<ul class='message-fullscreen-stacktrace'>" + lineHtml.join("") + "</ul>";
  }

  return html;
}

async function showDashboardError(error, fallbackMessage) {
  var title = (error && (error.title || error.namespace)) || "Dashboard Error";
  var body = (error && (error.description || error.message)) || fallbackMessage || "An error occurred.";
  var namespace = (error && error.namespace) ? error.namespace.toString() : "";
  var stacktraceSection = await _stacktraceSectionHtml(error);

  if (window.UATools && typeof window.UATools.ShowErrorMessage === "function") {
    var html = "";
    if (namespace) {
      html += "<div class='message-fullscreen-namespace'>" + escapeHtml(namespace) + "</div>";
    }
    html += "<h1>" + escapeHtml(title) + "</h1>";
    html += "<p>" + escapeHtml(body) + "</p>";
    html += stacktraceSection;

    window.UATools.ShowErrorMessage("", html, "", true);
    return;
  }
  alert(body);
}

function _oauthInput(name) {
  return document.querySelector('[name="' + name + '"]');
}

function _oauthInputInWizard(wizard, name) {
  if (!wizard) return null;
  return wizard.querySelector('[name="' + name + '"]');
}

function _providerAuthorizeUrl(provider, redirectUri) {
  var clientId = ((_oauthInput("clientId") || {}).value || "").toString().trim();
  if (!clientId) return "";

  if (provider === "gdrive") {
    var scope = ((_oauthInput("scope") || {}).value || "https://www.googleapis.com/auth/drive.readonly").toString().trim();
    var google = new URL("https://accounts.google.com/o/oauth2/v2/auth");
    google.searchParams.set("response_type", "code");
    google.searchParams.set("client_id", clientId);
    google.searchParams.set("redirect_uri", redirectUri);
    google.searchParams.set("scope", scope || "https://www.googleapis.com/auth/drive.readonly");
    google.searchParams.set("access_type", "offline");
    google.searchParams.set("prompt", "consent");
    return google.toString();
  }

  if (provider === "dropbox") {
    var dropbox = new URL("https://www.dropbox.com/oauth2/authorize");
    dropbox.searchParams.set("response_type", "code");
    dropbox.searchParams.set("client_id", clientId);
    dropbox.searchParams.set("redirect_uri", redirectUri);
    dropbox.searchParams.set("token_access_type", "offline");
    return dropbox.toString();
  }

  return "";
}

function _providerAuthorizeUrlWithClient(provider, redirectUri, clientId, scope) {
  var cleanClientId = (clientId || "").toString().trim();
  if (!cleanClientId) return "";

  if (provider === "gdrive") {
    var cleanScope = (scope || "https://www.googleapis.com/auth/drive.readonly").toString().trim();
    var google = new URL("https://accounts.google.com/o/oauth2/v2/auth");
    google.searchParams.set("response_type", "code");
    google.searchParams.set("client_id", cleanClientId);
    google.searchParams.set("redirect_uri", redirectUri);
    google.searchParams.set("scope", cleanScope || "https://www.googleapis.com/auth/drive.readonly");
    google.searchParams.set("access_type", "offline");
    google.searchParams.set("prompt", "consent");
    return google.toString();
  }

  if (provider === "dropbox") {
    var dropbox = new URL("https://www.dropbox.com/oauth2/authorize");
    dropbox.searchParams.set("response_type", "code");
    dropbox.searchParams.set("client_id", cleanClientId);
    dropbox.searchParams.set("redirect_uri", redirectUri);
    dropbox.searchParams.set("token_access_type", "offline");
    return dropbox.toString();
  }

  return "";
}

async function _openProviderOAuthPopup(repo) {
  var wizard = repo.wizard;
  var provider = (repo.provider || "").toString().trim().toLowerCase();
  var redirectUri = (repo.redirectUri || "").toString().trim();
  var clientId = (repo.clientId || "").toString().trim();
  var scope = (repo.scope || "").toString().trim();

  var url = _providerAuthorizeUrlWithClient(provider, redirectUri, clientId, scope);
  if (!url) {
    throw {
      namespace: "provider.oauth.clientid.required",
      title: "Client ID Required",
      description: "Enter your provider Client ID before continuing."
    };
  }

  var state = (Date.now() + "." + Math.random().toString(36).slice(2));
  var parsed = new URL(url);
  parsed.searchParams.set("state", state);
  parsed.searchParams.set("provider", provider);

  window.__uaProviderOAuthPending[state] = {
    provider: provider,
    wizardId: repo.wizardId || "",
    step: Number(repo.step || 0),
    autoAdvance: repo.autoAdvance !== false
  };

  var statusEl = wizard ? wizard.querySelector("#provider-oauth-status") : null;
  if (statusEl) {
    statusEl.textContent = "Sign-in popup opened. Complete sign-in to continue.";
  }

  window.open(parsed.toString(), "provider_oauth_" + provider, "width=560,height=740,resizable=yes,scrollbars=yes");
}

function _wireProviderOAuthStepHandler(wizard, provider, redirectUri) {
  if (!(window.wizard && typeof window.wizard.AddHandler === "function")) return;
  if (!wizard) return;
  if (wizard.getAttribute("data-provider-oauth-handler-wired") === "true") return;

  var authCodeInput = _oauthInputInWizard(wizard, "authorizationCode");
  if (!authCodeInput) return;
  var stepEl = authCodeInput.closest("[data-wizard-step]");
  if (!stepEl) return;
  var stepNum = Number(stepEl.getAttribute("data-wizard-step") || "0");
  if (!stepNum) return;

  var wizardId = (wizard.getAttribute("id") || "").toString().trim();
  if (!wizardId) return;

  wizard.setAttribute("data-provider-oauth-handler-wired", "true");

  window.wizard.AddHandler(wizardId, stepNum, async function(stateData) {
    var state = stateData || {};
    var stateProvider = (state.oauthProvider || "").toString().trim().toLowerCase();
    if (stateProvider !== provider) return;

    var hasCode = !!(state.authorizationCode || "").toString().trim();
    var hasAccessToken = !!(state.accessToken || "").toString().trim();
    if (hasCode || hasAccessToken) return;

    var clientId = (state.clientId || "").toString().trim();
    var clientSecret = (state.clientSecret || "").toString().trim();
    if (!(clientId) || !(clientSecret)) {
      throw {
        namespace: "provider.oauth.credentials.required",
        title: "Credentials Required",
        description: "Add your app Client ID and Client Secret first, then click Next."
      };
    }

    await _openProviderOAuthPopup({
      wizard: wizard,
      wizardId: wizardId,
      step: stepNum,
      provider: provider,
      redirectUri: redirectUri,
      clientId: clientId,
      scope: (state.scope || "").toString(),
      autoAdvance: true
    });

    throw {
      namespace: "provider.oauth.pending",
      title: "Finish Sign-In",
      description: "Complete provider sign-in in the popup. This wizard will continue automatically."
    };
  });
}

function initProviderOAuthHelpers() {
  var buttons = document.querySelectorAll("[data-provider-oauth]");
  if (!(buttons && buttons.length)) return;

  if (!(window.__uaProviderOAuthPending)) {
    window.__uaProviderOAuthPending = {};
  }

  if (!(window.__uaProviderOAuthListenerAttached)) {
    window.addEventListener("message", async function(event) {
      if (event.origin !== window.location.origin) return;
      var data = event.data || {};
      if (!(data && typeof data === "object")) return;
      if (data.type !== "provider-oauth-callback") return;

      var state = (data.state || "").toString().trim();
      if (!state) return;

      var pending = (window.__uaProviderOAuthPending || {})[state];
      if (!(pending)) return;
      delete window.__uaProviderOAuthPending[state];

      if (data.error) {
        await showDashboardError({
          namespace: "provider.oauth.callback.error",
          title: "Sign-In Failed",
          description: ((data.errorDescription || data.error) || "").toString()
        }, "Unable to complete provider sign-in.");
        return;
      }

      var wizardEl = pending.wizardId ? document.getElementById(pending.wizardId) : null;
      var codeInput = wizardEl ? _oauthInputInWizard(wizardEl, "authorizationCode") : _oauthInput("authorizationCode");
      if (codeInput && data.code) {
        codeInput.value = (data.code || "").toString().trim();
        codeInput.dispatchEvent(new Event("input", { bubbles: true }));
      }

      var statusEl = wizardEl ? wizardEl.querySelector("#provider-oauth-status") : document.getElementById("provider-oauth-status");
      if (statusEl) {
        statusEl.textContent = "Authorization received. Continuing...";
      }

      if (pending.autoAdvance && wizardEl) {
        var currentStep = Number(wizardEl.getAttribute("data-wizard-current") || "0");
        if (currentStep === Number(pending.step || 0)) {
          var continueBtn = document.getElementById((pending.wizardId || "") + "-continue");
          if (continueBtn && !continueBtn.disabled) {
            setTimeout(function() {
              continueBtn.click();
            }, 80);
          }
        }
      }
    });
    window.__uaProviderOAuthListenerAttached = true;
  }

  var redirectUri = window.location.origin + "/oauth/provider-callback";
  for (var i = 0; i < buttons.length; i++) {
    (function(button) {
      var wizard = button.closest("[data-wizard='true']");
      var provider = (button.getAttribute("data-provider-oauth") || "").toString().trim().toLowerCase();
      var redirectInput = wizard ? _oauthInputInWizard(wizard, "redirectUri") : _oauthInput("redirectUri");
      if (redirectInput) redirectInput.value = redirectUri;

      if (wizard && (provider === "gdrive" || provider === "dropbox")) {
        _wireProviderOAuthStepHandler(wizard, provider, redirectUri);
      }

      button.addEventListener("click", async function() {
        var clientIdInput = wizard ? _oauthInputInWizard(wizard, "clientId") : _oauthInput("clientId");
        var scopeInput = wizard ? _oauthInputInWizard(wizard, "scope") : _oauthInput("scope");
        try {
          await _openProviderOAuthPopup({
            wizard: wizard,
            wizardId: wizard ? wizard.getAttribute("id") : "",
            step: Number((button.closest("[data-wizard-step]") || {}).getAttribute ? button.closest("[data-wizard-step]").getAttribute("data-wizard-step") : 0),
            provider: provider,
            redirectUri: redirectUri,
            clientId: ((clientIdInput || {}).value || "").toString(),
            scope: ((scopeInput || {}).value || "").toString(),
            autoAdvance: false
          });
        } catch (error) {
          await showDashboardError(error, "Unable to start provider sign-in.");
        }
      });
    })(buttons[i]);
  }
}

// ─── Module export: register all pageinit handlers ───────────────────────────

module.exports = async function(options) {
  var pageinit = (options || {}).pageinit || (((window.UATools || {}).pageinit) || null);
  if (!(pageinit && typeof pageinit.register === "function")) return;

  // Wildcard: runs on every dashboard page
  pageinit.register("dashboard", "*", async function(context) {
    context = context || {};
    context.dashboard = context.dashboard || context.context || {};
    context.dashboardApi = context.dashboardApi || (window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null));
    context.initDashboardLists = async function(root) {
      await initDashboardLists(context, root);
    };
    window.__uaDashboardUserRoles = ((((context.dashboard || {}).user || {}).roles) || []).slice();

    attachSharedDashboardBehavior(context);

    // Init any ua.dashboard.list elements present on this page
    await initDashboardLists(context);
    await collectionOrderPageInit(context);

    // If we're on a detail/wizard view, pre-populate form fields
    await initDashboardDetailPage(context);

    // OPT-IN: hydrate any read-only [data-email-preview] containers. No container
    // on the page = no work and no request.
    await bindDashboardPreviewContainers(context);

    // Shared workspace markers can carry injected route/namespace truth even when
    // the registered page namespace is a stubbed contract variant.
    await platformNavigationWorkspaceInit(context);

    // OAuth popup helpers for provider setup wizards
    initProviderOAuthHelpers();

    // Load dashboard-level error screens into the wizard error registry
    if (window.wizard && typeof window.wizard.registerErrors === "function" && context.dashboardApi) {
      try {
        var errScreenResp = await context.dashboardApi.list("platform.error.screens", {}, 1, {}, 1000);
        if (errScreenResp && errScreenResp.success) {
          window.wizard.registerErrors(((errScreenResp.data || {}).rows || []), 1);
        }
      } catch (e) { /* silently skip if not yet configured */ }
    }

    // Page-level overrides (plugin/app pages can provide page.errors array/object)
    if (window.wizard && typeof window.wizard.registerErrors === "function") {
      var currentPage = (context.dashboard || {}).currentPage || {};
      var source = (currentPage.source || "").toString().toLowerCase();
      var priority = source === "app" ? 3 : (source === "plugin" ? 2 : 1);
      var pageErrors = currentPage.errors || null;
      if (pageErrors) {
        if (pageErrors instanceof Array) {
          window.wizard.registerErrors(pageErrors, priority);
        } else if (typeof pageErrors === "object") {
          var arr = [];
          Object.keys(pageErrors).forEach(function(namespace) {
            var item = pageErrors[namespace];
            if (!item || typeof item !== "object") return;
            arr.push({
              namespace: namespace,
              title: item.title || "",
              description: item.description || "",
              actions: item.actions || null,
              close: item.close !== false
            });
          });
          if (arr.length > 0) window.wizard.registerErrors(arr, priority);
        }
      }
    }
  });

  pageinit.register("dashboard", "platform.app.config", async function(context) {
    await configPageInit(context || {});
  });

  pageinit.register("dashboard", "platform.overview", async function(context) {
    await homePageInit(context || {});
  });

  pageinit.register("dashboard", "platform.home.defaults", async function(context) {
    await homeDefaultsPageInit(context || {});
  });

  pageinit.register("dashboard", "platform.application.artisan.report", async function(context) {
    await applicationArtisanReportPageInit(context || {});
  });

  pageinit.register("dashboard", "platform.commands", async function(context) {
    await commandsPageInit(context || {});
  });

  // Email Compose: owns its Review-step live preview (desktop/mobile/plain-text
  // modes + self-addressed Send Test). The container opts out of the generic
  // preview binder above via data-email-preview-managed.
  pageinit.register("dashboard", "egt.email.compose", async function(context) {
    await emailComposePageInit(context || {});
  });

  pageinit.register("dashboard", "platform.fields.schemas", async function() {
    fieldsSchemasPageInit();
  });

  pageinit.register("dashboard", "platform.pages", async function(context) {
    await platformPagesWorkspaceInit(context || {});
  });

  pageinit.register("dashboard", "platform.parts", async function(context) {
    await platformPartsWorkspaceInit(context || {});
  });

  pageinit.register("dashboard", "platform.navigation", async function(context) {
    await platformNavigationWorkspaceInit(context || {});
  });

  pageinit.register("dashboard", "platform.footer", async function(context) {
    await platformFooterWorkspaceInit(context || {});
  });

  // Platform: Account/user pages
  var accountNamespaces = [
    "platform.settings.passkeys",
    "platform.settings.sessions"
  ];
  for (var i = 0; i < accountNamespaces.length; i++) {
    (function(ns) {
      pageinit.register("dashboard", ns, async function(context) {
        await accountPageInit(context || {});
      });
    })(accountNamespaces[i]);
  }

  // Platform: Files pages
  var fileNamespaces = [
    "platform.files",
    "platform.files.setup",
    "platform.files.recycle",
    "platform.files.storage",
    "platform.files.providers"
  ];
  for (var j = 0; j < fileNamespaces.length; j++) {
    (function(ns) {
      pageinit.register("dashboard", ns, async function(context) {
        await filesPageInit(context || {});
      });
    })(fileNamespaces[j]);
  }
};

if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "test") {
  module.exports.__test = {
    initDashboardDetailPage: initDashboardDetailPage,
    bindDashboardDetailDeleteButton: bindDashboardDetailDeleteButton,
    platformNavigationWorkspaceInit: platformNavigationWorkspaceInit,
    renderButtonToggleLabel: renderButtonToggleLabel,
    getButtonToggleValue: getButtonToggleValue,
    setButtonToggleValue: setButtonToggleValue,
    bindButtonToggle: bindButtonToggle,
    safeDashboardRedirectPath: safeDashboardRedirectPath,
    rowActionConfirmAttrs: rowActionConfirmAttrs,
    confirmDashboardAction: confirmDashboardAction,
    bindDashboardPreviewContainers: bindDashboardPreviewContainers
  };
}
